import React, { useEffect, useState, useRef } from 'react'
import { Grid, makeStyles } from "@material-ui/core";
import { useNavigate } from 'react-router-dom';
import Typography from "@mui/material/Typography";
import { VolumeOff } from '@mui/icons-material';
import Avatar from '@mui/material/Avatar';
import useStyle from '../Css/MainCss';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import { CONFIG } from '../config'
import axios from 'axios';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { ClockLoader } from 'react-spinners';
import EvaluateComponent1 from '../Components/EvaluateComponent1';
import EvaluateComponent from '../Components/EvaluateComponent';
import SavePageAs from '../Components/SavePageAs';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { Close } from '@mui/icons-material';
import Draggable from 'react-draggable';
import RiskRegisterComponent from '../Components/RiskRegisterComponent';
import { green, red } from '@mui/material/colors';
import RiskHierarchyNew from '../Components/RiskHierarchyNew';
import AddQuestionComponent from '../Components/AddQuestionComponent';
import { DataGrid } from '@mui/x-data-grid';
import "../Css/DmgRiskGpt.css";
import parse from 'html-react-parser';
import { useSpeechSynthesis } from 'react-speech-kit';
import { VolumeUp } from '@mui/icons-material';
import TransferToExcelHierarchy from './TransferToExcelHierarchy';
import Slide from '@mui/material/Slide';
import CircularWithValueLabel from './ProgressTimer';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Card from "@mui/material/Card";
import CardContent from '@mui/material/CardContent';

import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { Document, Packer, Paragraph, TextRun } from "docx";
import { saveAs } from "file-saver";
import { ArrowUpward } from '@mui/icons-material';


const useStyles = makeStyles((theme) => ({
  right: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  pageTop: {
    marginTop: '115px',
  },
  pageBodyStyle: {

    paddingTop: '12px',
  },

}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
    fontSize: '13px'
  },
}));


function handleClick(event) {
  event.preventDefault();
  console.info('You clicked a breadcrumb.');
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const DMGRiskGptComponent3 = ({ createdRegisterName, createdRegisterId, createdRegisterDescription, createdRiskHierarchyId, setCreatedRiskHierarchyId, selectedRegisterDataObj, selectedRiskGPTSessionId }) => {


  const { speak } = useSpeechSynthesis();
  const [speakerOff, setSpeakerOff] = React.useState(false);
  function handleVolumeUp() {
    setSpeakerOff(true);
  }
  function handleVolumeDown() {
    setSpeakerOff(false);
  }
  const handleVolumeUpClick = (value) => {
    speak({ text: value });
  };

  const classes = useStyles();
  const classe = useStyle();
  const navigate = useNavigate();

  const [selectedRegisterData, setSelectedRegisterData] = useState({})


  const wordstyle = 'wordStyle'

  React.useEffect(() => {
    getAllRiskSchemas();
    getSessionData();
    getColors();
    setSpeakerOff(true);
    setSelectedRegisterData(selectedRegisterDataObj);
  }, [])

  const [globalCentreId, setGlobalCentreId] = React.useState('');
  const [globalUserId, setGlobalUserId] = React.useState('');

  const [createUser, setCreateUser] = React.useState('');
  function getSessionData() {
    let data = sessionStorage.getItem('sessionstorage');
    data = JSON.parse(data);
    setGlobalUserId(data.userId);
    setCreateUser(data.name)
    setGlobalCentreId(data.centreId);
    setRiskRegsiter(data.centreId);
    getGlobalRiskForCenter(data.centreId);
    getStandards(data.centreId)
    console.log(data)
  }

  const [globalRiskArray, setGlobalRiskArray] = useState([]);


  function getGlobalRiskForCenter(centerId) {
    axios(CONFIG.MAIN_URL + `/risk/all?centreId=` + centerId, {
      method: 'get',
    })
      .then(function (response) {
        console.log("+++++++++++Return All Risk Hierarchies in a Center Response++++++++++++++++");
        console.log(response.data);
        setGlobalRiskArray(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }


  const [showAddNextHirarchy, setShowAddNextHirarchy] = useState(true);

  const [allRegister, setAllRegister] = useState([])
  const [sectionTmpId, setSectionTmpId] = useState(0)
  const [selectedSectionId, setSelectedSectionId] = useState('')
  const [selectedSectionName, setSelectedSectionName] = useState('')
  const [selectedRiskId, setSelectedRiskId] = useState('')
  const [selectedRiskKey, setSelectedRiskKey] = useState('')
  const [selectedRiskName, setSelectedRiskName] = useState('')

  const [sectionData, setSectionData] = useState([])
  const [registerUniqName, setRegisterUniqName] = useState('')


  const [qStr, setQStr] = useState('')
  const [firstTime, setFirstTime] = React.useState(true);

  const [subRiskLabals, setSubRiskLabals] = React.useState('Sub Risks');
  const [subSubRiskLabals, setSubSubRiskLabals] = React.useState('Sub Sub Risks');
  const [subRiskLabal, setSubRiskLabal] = React.useState('Risk');
  const [subSubRiskLabal, setSubSubRiskLabal] = React.useState('Risk');

  const [voice, setVoice] = React.useState('');
  const [voice1, setVoice1] = React.useState('Select the item to change or amend your risks');
  const [voice2, setVoice2] = React.useState('Change your Hierarchy Key for creating a new Hierarchy. If you need to keep the existing Key for the new Hierarchy press the done button. If you need to assign a existing risk hierarchy press Assign a Created Hierarchy button to list the existing hierarchies');
  const [voice3, setVoice3] = React.useState('Enter your Hierarchy Name. If you want to keep the exiting name press the done button.');
  const [voice4, setVoice4] = React.useState('Enter your main Risk');
  const [voice5, setVoice5] = React.useState('Enter next main Risk and press next button or press done to enter risks within first main risk you have entered before');
  const [voice6, setVoice6] = React.useState('Enter another risks within the main risk or press done to select next main risk or press finish to auto complete');
  const [voice7, setVoice7] = React.useState('Enter another sub risk within your main risk and press next or press done or finish to auto complete');
  const [voice8, setVoice8] = React.useState('Enter another sub risk within your next main risk or press done for next main risk or press finish to auto complete');
  const [voice9, setVoice9] = React.useState('Enter another sub sub risk within your sub risk');
  const [voice10, setVoice10] = React.useState('Enter another sub sub risk within your sub risk risk ore press done to select next sub risk or finish to auto complete');
  const [voice11, setVoice11] = React.useState('Enter another sub sub risk within your selected sub risk');
  const [voice12, setVoice12] = React.useState('Enter DMG Risk GPT Question Id and Press Create Risk Hierarchy.');

  const [riskIdCount, setRiskIdCount] = React.useState(1);

  function setRiskRegsiter(centrId) {
    setLoading1(true);
    axios(CONFIG.MAIN_URL + `/register/all`, {
      method: 'get',
    })
      .then(function (response) {
        var arr = []
        console.log("all register");
        console.log(response.data);
        response.data.forEach((item) => {
          if (item.centreId === centrId) {
            arr.push(item);
            console.log(arr);
          }
        })
        setAllRegister(arr);
        var tmpSectionName = "";
        var tmpRiskKey = "";
        var tmpRiskName = "";
        if (createdRegisterId != undefined && createdRegisterId != null && createdRegisterId != '') {
          arr.forEach((data) => {
            if (data.id === createdRegisterId) {
              var countSection = 1;
              var arrSection = [];

              console.log("++++++++++++++++++++++data+++++++++++++++++++++++");
              console.log(data);
              data.riskRegister.forEach((item, index) => {
                item["sectionTmpId"] = countSection;
                countSection++;
                if (index === 0) {
                  setSelectedSectionId(item.id);
                  tmpSectionName = item.section;
                  setSelectedSectionName(item.section)
                }
                var arrRisk = [];
                if (item.risks != undefined && item.risks != null && item.risks.length > 0) {
                  item.risks.forEach((item1, index1) => {
                    item1["hierarchyTmpId"] = countSection;
                    countSection++;
                    if (index === 0 && index1 === 0) {
                      setSelectedRiskId(item1.id);
                      tmpRiskKey = item1.riskHierarchy.key;
                      setSelectedRiskKey(item1.riskHierarchy.key);
                      tmpRiskName = item1.name;
                      setSelectedRiskName(item1.name);
                    }
                    arrRisk.push(item1);
                  })
                }

                item["risks"] = arrRisk
                arrSection.push(item);
              })

              setSelectedRegisterData(data);

              setSectionTmpId(countSection);
              setSectionData(arrSection);
              setRegisterUniqName(data.registerUniqueName)

              setLoading1(false);

              setSendMessageField('2');
              setStep0(true);
              setStep1(false);
              setStep2(false);
              setStep3(false);
              setStep4(false);
              setStep5(false);
              setStep6(false);
              setStep7(false);
              var objQa = {}
              var arrQa = [];
              objQa = {}
              var tStr = "";
              var tCount = 1;
              data.riskRegister.forEach((item, index) => {
                if (item.risks != undefined && item.risks != null && item.risks.length > 0) {
                  item.risks.forEach((item1, index1) => {
                    if (tCount === 1) {
                      tStr += "";
                      tStr += "<table style='background: rgb(247, 247, 248); border-top: 1px solid rgb(229, 229, 229); border-bottom: 1px solid rgb(222, 222, 223);>";
                      tStr += "<tr>";
                      tStr += "<td width='5%'>&nbsp;</td>";
                      tStr += `<td width='20%'><span className="${wordstyle}" style='font-weight: 600; line-height: 1.2rem; font-family: Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular;'>Section</span></td>`;

                      tStr += `<td width='40%'><span className="${wordstyle}" style='font-weight: 600; line-height: 1.2rem; font-family: Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular;'>Risk</span></td>`;
                      tStr += `<td width='18%'><span className="${wordstyle}" style='font-weight: 600; line-height: 1.2rem; font-family: Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular;'>Progress</span></td>`;
                      tStr += `<td width='17%'><span className="${wordstyle}" style='font-weight: 600; line-height: 1.2rem; font-family: Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular;'>Actions</span></td>`;
                      tStr += "</tr>";

                    }
                    tStr += "<tr>";
                    tStr += "<td><span className=\"" + wordstyle + "\" style=' line-height: 1.1rem; font-family: Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular;'>&nbsp;&nbsp;&nbsp;" + tCount + ")</span></td>";
                    tStr += "<td><span className=\"" + wordstyle + "\" style='padding-right: 5px;  line-height: 1.1rem; font-family: Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular;'>" + item.section + "</span></td>";
                    tStr += "<td><span className=\"" + wordstyle + "\" style='padding-right: 5px;  line-height: 1.1rem; font-family: Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular;'>" + item1.riskHierarchy.name + "</span></td>";

                    if (item1.riskHierarchy.riskId != "") {
                      tStr += "<td><span className=\"" + wordstyle + "\" style=' line-height: 1.1rem; font-family: Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular; '>" + "<span style='color:green'>Assigned</span>" + "</span></td>";
                      tStr += "<td><span className=\"" + wordstyle + "\" style=' line-height: 1.1rem; font-family: Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular; '>";
                      tStr += "<button class=\"MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedPrimary MuiButton-sizeMedium MuiButton-containedSizeMedium MuiButton-root MuiButton-contained MuiButton-containedPrimary MuiButton-sizeMedium MuiButton-containedSizeMedium css-sghohy-MuiButtonBase-root-MuiButton-root\" tabindex=\"0\" type=\"button\" style=\"height: 20px;\">Detail<span class=\"MuiTouchRipple-root css-8je8zh-MuiTouchRipple-root\"></span></button>";
                      tStr += "</span></td>";
                    } else {
                      tStr += "<td><span className=\"" + wordstyle + "\" style=' line-height: 1.1rem; font-family: Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular;'>" + "<span style='color:red'>Not Assigned</span>" + "</span></td>";
                      tStr += "<td><span className=\"" + wordstyle + "\" style=' line-height: 1.1rem; font-family: Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular;'>" + "<span style='color:red'>&nbsp;</span>" + "</span></td>";
                    }
                    tStr += "</tr>";
                    tCount++;
                  })
                }
              })
              tStr += "</table>";
              objQa["q"] = tStr
              objQa["id"] = riskIdCount;
              objQa["v"] = voice1;

              arrQa.push(objQa)
              setQaArray(arrQa)
              setDivHeight('300');
              setDivHeight1('10');
              console.log("+++++++++++++++++++++++++++arrQa111111111111111++++++++++++++++++++++");
              console.log(arrQa);
              setVoice(voice1);
              blinkText1(voice1);
            }
          })
        }
      })
      .catch(function (error) {
        setLoading1(false);
        console.log(error);
      });
  }



  const [colorPatterns, setColorPatterns] = React.useState([])

  function getColors() {
    axios(CONFIG.MAIN_URL + CONFIG.CONTROLLER_NAME_FOR_SLIDER_COLOR + "/all", {
      method: 'get',
      headers: {
        'Content-Type': 'text/plain',
      },
    })
      .then(function (response) {
        console.log("+++++++++++++++++All colors++++++++++++++++++");
        console.log(response.data);
        setColorPatterns(response.data);

      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const [PageName, setPageName] = useState('DMG Risk Gpt')

  const [headerInfoMessage, setheaderInfoMessage] = useState("Create Templates For Schemas");

  const [selectedSchemaId, setSelectedSchemaId] = React.useState('');
  const [selectedSchemaName, setSelectedSchemaName] = React.useState('');

  const [allAvailableRiskSchemas, setAllAvailableRiskSchemas] = React.useState([]);

  function getAllRiskSchemas() {
    axios(CONFIG.MAIN_URL + `/schemaformat/all`, {
      method: 'get',
      headers: {
        'Content-Type': 'text/plain',
      },
    })
      .then(function (response) {
        console.log("All Risk Schemas Returns");
        console.log(response.data);
        setAllAvailableRiskSchemas(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }
  const [sendMessageField, setSendMessageField] = React.useState();

  const handleSendMessage = (event) => {
    setSendMessageField(event.target.value);
  };

  const [step0, setStep0] = React.useState(false);
  const [step1, setStep1] = React.useState(false);
  const [step2, setStep2] = React.useState(false);
  const [step3, setStep3] = React.useState(false);
  const [step4, setStep4] = React.useState(false);
  const [step5, setStep5] = React.useState(false);
  const [step6, setStep6] = React.useState(false);
  const [step7, setStep7] = React.useState(false);

  const [headerMessage, setHeaderMessage] = React.useState('');

  const [divHeight, setDivHeight] = React.useState('200');
  const [divHeight1, setDivHeight1] = React.useState('10');
  const [qaArray, setQaArray] = React.useState([]);

  const scrollRef = useRef(null);
  const scrollRef1 = useRef(null);

  const [firstStyle, setFirstStyle] = React.useState('');
  const [secondStyle, setSecondStyle] = React.useState('');


  function blinkText(voice) {
    setFirstStyle('typed');
    setSecondStyle('fontColorWhite');
    setTimeout(function () {
      setSecondStyle('typed');
      setTimeout(function () {
        if (voice != undefined && voice != null && voice != '' && !speakerOff) {
          handleVolumeUpClick(voice);
        }
        setSecondStyle('blink-bg');
        setFirstStyle('');

      }, 3000);
    }, 2000);
  }
  function textFieldClickBlinkStop() {
    setSecondStyle('not-blink-bg');
  }

  function blinkText1(voice) {
    setFirstStyle('typed');
    setSecondStyle('fontColorWhite');
    setTimeout(function () {
      setSecondStyle('typed');
      setTimeout(function () {
        var ele = document.getElementById('iconVolumeUp');
        handleVolumeUpClick(voice);
        setSecondStyle('blink-bg');
      }, 1000);
    }, 20);
  }


  const [openHaDetails, setOpenHaDetails] = React.useState(false);
  const [rHName, setRHName] = React.useState('');
  const [rHId, setRHId] = React.useState('');

  const haDetailshandleClose = () => {
    setOpenHaDetails(false);
  };

  function showDetailsFuction(id, name) {
    setRHName(name);
    setRHId(id);
    setOpenHaDetails(true);
  }

  function handleButtonHaEval() {
    setLoading1(true);
    axios(CONFIG.MAIN_URL + `/register/all`, {
      method: 'get',
    })
      .then(function (response) {
        var arr = []
        console.log("all register");
        console.log(response.data);
        response.data.forEach((item) => {
          if (item.centreId === globalCentreId) {
            arr.push(item);
            console.log(arr);
          }
        })
        setLoading1(false);
        if (createdRegisterId != undefined && createdRegisterId != null && createdRegisterId != '') {
          arr.forEach((data) => {
            if (data.id === createdRegisterId) {
              data.riskRegister.forEach((item, index) => {
                if (item.risks != undefined && item.risks != null && item.risks.length > 0) {
                  item.risks.forEach((item1, index1) => {
                    if (item1.riskHierarchy != undefined && item1.riskHierarchy != null) {
                      if (item1.riskHierarchy.riskId != undefined && item1.riskHierarchy.riskId != null && item1.riskHierarchy.riskId != '') {
                        if (item1.riskHierarchy.riskId === rHId) {
                          setRiskTypeDataForEval(item1.riskHierarchy.riskHierarchyData);
                          setSelectedRiskEvaluateTitle(item1.riskHierarchy.riskHierarchyData.name);
                          setRegisterEvaluate(false)
                          setRegisterTypeDataForEval(item1.riskHierarchy.riskHierarchyData);
                          setSelectedRegisterEvaluateTitle(item1.riskHierarchy.riskHierarchyData.name);
                          setOpenRegisterDataForEval(true)
                          setOpenRegisterDataForEvalScroll('paper');
                        }

                      }
                    }
                  })
                }
              })
            }
          })
        }
      })
      .catch(function (error) {
        setLoading1(false);
        console.log(error);
      });

  }
  function handleButtonHaQuestion() {

    setLoading1(true);
    axios(CONFIG.MAIN_URL + `/register/all`, {
      method: 'get',
    })
      .then(function (response) {
        var arr = []
        console.log("all register");
        console.log(response.data);
        response.data.forEach((item) => {
          if (item.centreId === globalCentreId) {
            arr.push(item);
            console.log(arr);
          }
        })

        if (createdRegisterId != undefined && createdRegisterId != null && createdRegisterId != '') {
          arr.forEach((data) => {
            if (data.id === createdRegisterId) {
              data.riskRegister.forEach((item, index) => {
                if (item.risks != undefined && item.risks != null && item.risks.length > 0) {
                  item.risks.forEach((item1, index1) => {
                    if (item1.riskHierarchy != undefined && item1.riskHierarchy != null) {
                      if (item1.riskHierarchy.riskId != undefined && item1.riskHierarchy.riskId != null && item1.riskHierarchy.riskId != '') {
                        if (item1.riskHierarchy.riskId === rHId) {

                          axios(CONFIG.MAIN_URL + "/question/getquestiononly?centreId=" + globalCentreId, {
                            method: 'get',
                          })
                            .then(function (response) {
                              setLoading1(false);
                              console.log("+++++++++++++++++Get All question+++++++++++++++++");
                              console.log(response.data);
                              var tArr = [];
                              response.data.forEach((itemX, index) => {
                                if (itemX.riskTypes != undefined && itemX.riskTypes != null) {
                                  if (itemX.riskTypes.collectionRiskId === rHId) {
                                    tArr.push(itemX);
                                  }
                                }
                              })
                              var count = 1;
                              var tmpArray = [];
                              setRows([]);
                              tArr.forEach((item) => {
                                console.log("++++++++++++++++item++++++++++++++++");
                                console.log(item);
                                var tmpObj = {};
                                tmpObj["questionId"] = item.questionId;
                                tmpObj["id"] = count;
                                tmpObj["riskName"] = item.riskTypes.name;
                                var priNumber = ""
                                if (item.principle.principleNumber != undefined && item.principle.principleNumber != null) {
                                  priNumber = item.principle.principleNumber;
                                }
                                if (priNumber != '') {
                                  tmpObj["principalName"] = "Principle " + priNumber + ": " + item.principle.name;
                                } else {
                                  tmpObj["principalName"] = item.principle.name;
                                }
                                if (item.objective != undefined && item.objective != null) {
                                  if (item.objective.name != undefined && item.objective.name != null) {
                                    tmpObj["objectiveName"] = item.objective.name;
                                  }
                                } else {
                                  tmpObj["objectiveName"] = "";
                                }
                                if (item.component != undefined && item.component != null) {
                                  if (item.component.name != undefined && item.component.name != null) {
                                    tmpObj["componentName"] = item.component.name;
                                  }
                                } else {
                                  tmpObj["componentName"] = "";
                                }

                                //tmpObj["objectiveName"] = item.objective.name;
                                //tmpObj["componentName"] = item.component.name;
                                if (item.entity != undefined && item.entity != null) {
                                  tmpObj["entityName"] = item.entity.name;
                                } else {
                                  tmpObj["entityName"] = "";
                                }
                                tmpObj["question"] = item.question;
                                tmpObj["questionType"] = item.questionType;
                                tmpObj["questionData"] = item;
                                tmpArray.push(tmpObj);
                                setRiskName(item.riskTypes.name)
                                arrayForTransferExcel.push(tmpObj)
                                setRows(tmpArray);
                                count++;
                              })
                              setSelectedRiskEvaluateTitle(rHName)
                              setOpenShowQuestions(true);
                              setOpenShowQuestionsScroll('paper');

                            })
                            .catch(function (error) {
                              setLoading1(false);

                            });

                        }

                      }
                    }
                  })
                }
              })
            }
          })
        }
      })
      .catch(function (error) {
        setLoading1(false);
        console.log(error);
      });

  }


  var haCount = 0;
  var haCountX = 0;
  const previousHaTable = (
    <>
      <Grid container spacing={2} class='visibleDiv'>
      <Grid item xs={12}>
      <Grid container spacing={1}>
        {selectedRegisterDataObj.riskRegister.map((item, index) => (
          <>
            {item.risks != undefined && item.risks != null && item.risks.length > 0 ?
              <>
                {item.risks.map((item1, index1) => {
                  haCount++;
                  return (
                    <>

<Grid item xs={12}>

                      <Card style={{ "width": "100% !important", border: "1px solid black", backgroundColor: '#F8EFFF', marginLeft: '-20px', marginRight: '-20px' }}>
                        <CardContent>
                          <Grid container spacing={0} class='marginPos'>
                          <Grid item xs={12}>
                              <span class='headingsText1'>Item No :</span><span class='valuesText1'>{haCount}</span>
                            </Grid>
                            <Grid item xs={12}>
                              <span class='headingsText1'>Section : </span><span class='valuesText1'>{item.section}</span>
                            </Grid>
                            <Grid item xs={12}>
                              <span class='headingsText1'>Risk : </span><span class='valuesText1'>{item1.name}</span>
                            </Grid>
                            <Grid item xs={12}>
                              <span class='headingsText1'>Progress : </span>
                              {item1.riskHierarchy.riskId != "" ?
                                <span class='valuesText1'>Assigned</span>
                              :  
                                <span class='valuesText1'>Not Assigned</span>
                              }  
                            </Grid>
                            <Grid item xs={12}>
                              <span class='headingsText1'>Details : </span>
                              {item1.riskHierarchy.riskId != "" ?
                                <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                onClick={() => {
                                  showDetailsFuction(item1.riskHierarchy.riskId, item1.riskHierarchy.name)
                                }}
                              >
                                Detail
                              </Button>
                              :  
                                <span class='valuesText1'>&nbsp;</span>
                              }  
                            </Grid>




                          </Grid>
                        </CardContent>
                      </Card>
</Grid>
                    </>
                  )

                })}
              </>
              :
              ''
            }

          </>
        ))}
      </Grid>  
      </Grid>  
      </Grid>
      <TableContainer class='hideDiv'>
        <Table size="small" aria-label="a dense table" style={{ backgroundColor: '#F8EFFF', border: '1px solid #E5E5E5' }}>
          <TableBody>
            <TableRow>
              <TableCell style={{ width: '5%', verticalAlign: 'top', padding: '0px' }}>
                <div style={{ whiteSpace: 'normal' }}>
                  <span className={wordstyle} style={{ fontWeight: 600, lineHeight: '1.0rem', fontFamily: 'Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular' }}>&nbsp;</span>
                </div>
              </TableCell>
              <TableCell style={{ width: '20%', verticalAlign: 'top', padding: '0px' }}>
                <div style={{ whiteSpace: 'normal' }}>
                  <span className={wordstyle} style={{ fontWeight: 600, lineHeight: '1.0rem', fontFamily: 'Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular' }}>Section</span>
                </div>
              </TableCell>
              <TableCell style={{ width: '40%', verticalAlign: 'top', padding: '0px' }}>
                <div style={{ whiteSpace: 'normal' }}>
                  <span className={wordstyle} style={{ fontWeight: 600, lineHeight: '1.0rem', fontFamily: 'Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular' }}>Risk</span>
                </div>
              </TableCell>
              <TableCell style={{ width: '18%', verticalAlign: 'top', padding: '0px' }}>
                <div style={{ whiteSpace: 'normal' }}>
                  <span className={wordstyle} style={{ fontWeight: 600, lineHeight: '1.0rem', fontFamily: 'Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular' }}>Progress</span>
                </div>
              </TableCell>
              <TableCell style={{ width: '17%', verticalAlign: 'top', padding: '0px' }}>
                <div style={{ whiteSpace: 'normal' }}>
                  <span className={wordstyle} style={{ fontWeight: 600, lineHeight: '1.0rem', fontFamily: 'Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular' }}>Details</span>
                </div>
              </TableCell>
            </TableRow>
            {selectedRegisterDataObj.riskRegister.map((item, index) => (
              <>
                {item.risks != undefined && item.risks != null && item.risks.length > 0 ?
                  <>
                    {item.risks.map((item1, index1) => {
                      haCountX++;
                      return (
                        <>
                          <TableRow>
                            <TableCell style={{ width: '5%', verticalAlign: 'top', padding: '0px' }}>
                              <div style={{ whiteSpace: 'normal' }}>
                                <span className={wordstyle} style={{ lineHeight: '1.0rem', fontFamily: 'Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular' }}>{haCountX}</span>
                              </div>
                            </TableCell>
                            <TableCell style={{ width: '20%', verticalAlign: 'top', padding: '0px' }}>
                              <div style={{ whiteSpace: 'normal' }}>
                                <span className={wordstyle} style={{ lineHeight: '1.0rem', fontFamily: 'Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular' }}>{item.section}</span>
                              </div>
                            </TableCell>
                            <TableCell style={{ width: '40%', verticalAlign: 'top', padding: '0px' }}>
                              <div style={{ whiteSpace: 'normal' }}>
                                <span className={wordstyle} style={{ lineHeight: '1.0rem', fontFamily: 'Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular' }}>{item1.name}</span>
                              </div>
                            </TableCell>
                            {item1.riskHierarchy.riskId != "" ?
                              <>
                                <TableCell style={{ width: '18%', verticalAlign: 'top', padding: '0px' }}>
                                  <div style={{ whiteSpace: 'normal' }}>
                                    <span className={wordstyle} style={{ lineHeight: '1.0rem', fontFamily: 'Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular' }}>Assigned</span>
                                  </div>
                                </TableCell>
                                <TableCell style={{ width: '17%', verticalAlign: 'top', padding: '0px' }}>
                                  <div style={{ whiteSpace: 'normal' }}>
                                    <span className={wordstyle} style={{ lineHeight: '1.0rem', fontFamily: 'Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular' }}>
                                      <Button
                                        variant="contained"
                                        color="primary"
                                        size="small"
                                        onClick={() => {
                                          showDetailsFuction(item1.riskHierarchy.riskId, item1.riskHierarchy.name)
                                        }}
                                      >
                                        Detail
                                      </Button>
                                    </span>
                                  </div>
                                </TableCell>
                              </>
                              :
                              <>
                                <TableCell style={{ width: '18%', verticalAlign: 'top', padding: '0px' }}>
                                  <div style={{ whiteSpace: 'normal' }}>
                                    <span className={wordstyle} style={{ lineHeight: '1.0rem', fontFamily: 'Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular' }}>Not Assigned</span>
                                  </div>
                                </TableCell>
                                <TableCell style={{ width: '17%', verticalAlign: 'top', padding: '0px' }}>
                                  <div style={{ whiteSpace: 'normal' }}>
                                    <span className={wordstyle} style={{ lineHeight: '1.0rem', fontFamily: 'Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular' }}>&nbsp;</span>
                                  </div>
                                </TableCell>
                              </>
                            }

                          </TableRow>


                        </>
                      )

                    })}
                  </>
                  :
                  ''
                }

              </>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  )

  const registerArrayQa = (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <div ref={scrollRef} style={{ overflowY: 'scroll', overflowX: 'hidden', height: `${divHeight}px`, width: '100%' }}>
          <TableContainer>
            <Table id={'tblId'} stickyHeader aria-label="sticky table" style={{ border: '1px solid #ddd' }}>
              <TableBody>
                {qaArray.map((data, index) => (
                  <>
                    {index === 0 ?
                      <>
                        <StyledTableRow key={0} className={classes.tableTrStyle}>
                          <StyledTableCell component="th" scope="row" className={classes.tableTrStyle} style={{ width: '5%', verticalAlign: 'top' }}>
                            <div style={{ whiteSpace: 'normal' }}>
                              <BootstrapTooltip title='Risk GPT'>
                                <Avatar sx={{ bgcolor: red[500], height: '25px', width: '25px' }} className='wordstyle' variant="square">
                                  <span className={wordstyle}>RG</span>
                                </Avatar>
                              </BootstrapTooltip>
                            </div>
                          </StyledTableCell>
                          <StyledTableCell component="th" scope="row" className={classes.tableTrStyle} style={{ width: '45%', verticalAlign: 'top' }}>
                            {index === qaArray.length - 1 ?
                              <>
                                <p className={secondStyle} style={{ lineHeight: '1.0rem', fontFamily: 'Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular' }}><span className={wordstyle}>Select the item to change/amend your risks</span>
                                  {voice != '' ?
                                    <>
                                      &nbsp;&nbsp;<VolumeUp
                                        sx={{ cursor: 'pointer' }}
                                        onClick={() => { handleVolumeUpClick(voice) }}
                                      />
                                    </>
                                    :
                                    ''
                                  }
                                </p>

                                <span className='wordstyle' style={{ lineHeight: '1.0rem', fontFamily: 'Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular' }}>{previousHaTable}</span>
                              </>
                              :
                              <>
                                <p className='wordstyle' style={{ lineHeight: '1.0rem', fontFamily: 'Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular' }}><span className={wordstyle}>Select the item to change/amend your risks</span></p>
                                <span className='wordstyle' style={{ lineHeight: '1.0rem', fontFamily: 'Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular' }}>{previousHaTable}</span>
                              </>
                            }
                          </StyledTableCell>
                          <StyledTableCell component="th" scope="row" className={classes.tableTrStyle} style={{ width: '5%', verticalAlign: 'top' }}>
                            <div style={{ whiteSpace: 'normal' }}>
                              <BootstrapTooltip title={createUser}>
                                <Avatar sx={{ bgcolor: green[500], height: '25px', width: '25px', }} className='wordstyle' variant="square">
                                  <span className={wordstyle}>{createUser.substr(0, 2)}</span>
                                </Avatar>
                              </BootstrapTooltip>
                            </div>
                          </StyledTableCell>
                          <StyledTableCell component="th" scope="row" className={classes.tableTrStyle} style={{ width: '45%', verticalAlign: 'top' }}>
                            {data.a != undefined && data.a != null ?
                              <p className={firstStyle}>
                                <span className='wordstyle' style={{ lineHeight: '1.0rem', fontFamily: 'Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular' }}><span className={wordstyle}>{parse(data.a)}</span></span>

                              </p>
                              :
                              ''
                            }
                          </StyledTableCell>
                        </StyledTableRow>
                      </>
                      :
                      <>
                        <StyledTableRow key={0} className={classes.tableTrStyle}>
                          <StyledTableCell component="th" scope="row" className={classes.tableTrStyle} style={{ width: '5%', verticalAlign: 'top' }}>
                            <div style={{ whiteSpace: 'normal' }}>
                              <BootstrapTooltip title='Risk GPT'>
                                <Avatar sx={{ bgcolor: red[500], height: '25px', width: '25px' }} className='wordstyle' variant="square">
                                  <span className={wordstyle}>RG</span>
                                </Avatar>
                              </BootstrapTooltip>
                            </div>
                          </StyledTableCell>
                          <StyledTableCell component="th" scope="row" className={classes.tableTrStyle} style={{ width: '45%', verticalAlign: 'top' }}>
                            {index === qaArray.length - 1 ?
                              <>
                                <p className={secondStyle} style={{ fontSize: '1.0rem', lineHeight: '1.0rem', fontFamily: 'Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular' }}><span className={wordstyle}>{data.q}</span>
                                  {voice != '' ?
                                    <>
                                      &nbsp;&nbsp;<VolumeUp
                                        sx={{ cursor: 'pointer' }}
                                        onClick={() => { handleVolumeUpClick(voice) }}
                                      />
                                    </>
                                    :
                                    ''
                                  }
                                </p>
                              </>
                              :
                              <>
                                <p style={{ fontSize: '1.0rem', lineHeight: '1.0rem', fontFamily: 'Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular' }}><span className={wordstyle}>{data.q}</span></p>
                              </>
                            }
                          </StyledTableCell>
                          <StyledTableCell component="th" scope="row" className={classes.tableTrStyle} style={{ width: '5%', verticalAlign: 'top' }}>
                            <div style={{ whiteSpace: 'normal' }}>
                              <BootstrapTooltip title={createUser}>
                                <Avatar sx={{ bgcolor: green[500], height: '25px', width: '25px' }} className='wordstyle' variant="square">
                                  <span className={wordstyle}>{createUser.substr(0, 2)}</span>
                                </Avatar>
                              </BootstrapTooltip>
                            </div>
                          </StyledTableCell>
                          <StyledTableCell component="th" scope="row" className={classes.tableTrStyle} style={{ width: '45%', verticalAlign: 'top' }}>
                            {index === qaArray.length - 2 ?
                              <p className={firstStyle}>
                                {data.a != undefined && data.a != null ?
                                  <>
                                    <span style={{ fontSize: '1.0rem', lineHeight: '1.0rem', fontFamily: 'Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular' }}><span className={wordstyle}>{parse(data.a)}</span></span>

                                  </>
                                  :
                                  ''
                                }
                              </p>
                              :
                              <p>
                                {data.a != undefined && data.a != null ?
                                  <>
                                    <span style={{ fontSize: '1.0rem', lineHeight: '1.0rem', fontFamily: 'Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular' }}><span className={wordstyle}>{parse(data.a)}</span></span>

                                  </>
                                  :
                                  ''
                                }
                              </p>
                            }
                          </StyledTableCell>
                        </StyledTableRow>
                      </>
                    }

                  </>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </Grid>
    </Grid>
  )




  const handleButtonStep1Click = () => {
    blinkText();

    if (sendMessageField === '1') {
      setStep1(true);
      setHeaderMessage('You are creating a risk Register. ')
      var objQa = {}
      var arrQa = qaArray;
      objQa["q"] = " Do you want to create 1) A risk Register 2) A risk Hierarchy. Answer 1 or 2 ?."

      var arrX = [];
      var objX = {}
      objX["label"] = "You have selected ";
      arrX.push(objX);
      objX = {}
      objX["var"] = "1";
      arrX.push(objX);
      objX = {}
      objX["label"] = " to create risk register";
      arrX.push(objX);
      objQa["a"] = arrX;
      arrQa.push(objQa)
      objQa = {}
      objQa["q"] = " Enter your Register Name."
      arrQa.push(objQa)
      setQaArray(arrQa)
    } else {
      if (sendMessageField === '2') {
        setStep1(true);
        var objQa = {}
        var arrQa = qaArray;

        var arrX = [];
        var objX = {}
        objX["label"] = "You have selected number";
        arrX.push(objX);
        objX = {}
        objX["var"] = "2";
        arrX.push(objX);
        objQa["a"] = arrX;

        arrQa.push(objQa)
        objQa = {}
        objQa["q"] = "XXEnter your Hierarchy Key."
        arrQa.push(objQa)
        setQaArray(arrQa)

      } else {
        alert("Invalid Number. Please select 1 OR 2")
      }
    }

  };

  const [registerName, setRegisterName] = React.useState('');
  const handleChangeRegisterName = (event) => {
    setRegisterName(event.target.value);
  };

  const handleButtonStep2Click = () => {
    blinkText();
    if (registerName === '') {
      alert("Please assign a Register Name");
      return;
    }
    setStep2(true);
    var str = headerMessage;
    str = str + "Name " + registerName;
    setHeaderMessage(str);

    var objQa = {}
    var arrQa = qaArray;
    var arrX = [];
    var objX = {};
    objX["label"] = "Register Name is ";
    arrX.push(objX);
    objX = {};
    objX["var"] = registerName;
    arrX.push(objX);
    objQa["a"] = arrX;
    arrQa.push(objQa)
    objQa = {}
    objQa["q"] = "Enter your Register Description."
    arrQa.push(objQa)
    setQaArray(arrQa)
    setDivHeight('200');
  };

  const [registerDescription, setRegisterDescription] = React.useState('');
  const handleChangeRegisterDescription = (event) => {
    setRegisterDescription(event.target.value);
  };

  const handleButtonStep3Click = () => {

    blinkText();
    if (registerDescription === '') {
      alert("Please assign a Register Description");
      return;
    }
    setStep3(true);
    var str = headerMessage;
    str = str + " and Description " + registerDescription + '.';
    setHeaderMessage(str);

    var objQa = {}
    var arrQa = qaArray;
    var arrX = [];
    var objX = {};
    objX["label"] = "Register Description is ";
    arrX.push(objX);
    objX = {};
    objX["var"] = registerDescription;
    arrX.push(objX);
    objQa["a"] = arrX;
    arrQa.push(objQa)
    objQa = {}
    objQa["q"] = sectionHeadingMessage
    arrQa.push(objQa)
    setQaArray(arrQa)
    setDivHeight('200');

    setTimeout(() => {
      if (scrollRef.current) {
        scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
      }
      if (scrollRef1.current) {
        scrollRef1.current.scrollTop = scrollRef1.current.scrollHeight;
      }

    }, 100);

  };

  //SECTION 
  const [sectionHeadingName, setSectionHeadingName] = React.useState('');


  const onChangeSectionHeadingName = (event) => {
    setSectionHeadingName(event.target.value);
  };


  const [registerArray, setRegisterArray] = useState([]);


  function clearSection() {
    setSectionHeadingName('')

  }

  function clickSectionMore() {

    blinkText();

    if (sectionHeadingName === '') {
      alert('please enter section name')
      return
    }

    buildRegisterArray();
    clearSection()

    setSectionHeadingMessage('Enter your Next Register heading section')

    var str = headerMessage
    var tmpStr = ''
    if (registerArray.length === 1) {
      tmpStr += " The register section is " + registerArray[0].section
      if (registerArray[0].risks != undefined && registerArray[0].risks != null && registerArray[0].risks.length > 0) {
        registerArray[0].risks.forEach((data, index) => {
          if (index === 0) {
            tmpStr += " with risk type " + data.description
          } else {
            tmpStr += " ," + data.description
          }
        })
      } else {
        tmpStr += ".";
      }

    } else {
      tmpStr += " The register sections are "
      registerArray.forEach((data, index) => {
        if (index === 0) {
          tmpStr += data.section
        } else {
          tmpStr += ", " + data.section
        }
        if (data.risks != undefined && data.risks != null && data.risks.length > 0) {
          data.risks.forEach((data1, index1) => {
            if (index1 === 0) {
              tmpStr += " with risk type " + data1.description
            } else {
              tmpStr += " ," + data1.description
            }
          })
        }

      })
    }

    var objQa = {}
    var arrQa = qaArray;


    var arrX = [];
    var objX = {};
    objX["label"] = "Section heading is ";
    arrX.push(objX);
    objX = {};
    objX["var"] = sectionHeadingName;
    arrX.push(objX);
    objQa["a"] = arrX;

    arrQa.push(objQa)
    objQa = {}
    objQa["q"] = "Next Section OR Press \"DONE\" to Enter Risks"
    arrQa.push(objQa)
    setQaArray(arrQa)
    setDivHeight('200');

    setTimeout(() => {
      if (scrollRef.current) {
        scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
      }
      if (scrollRef1.current) {
        scrollRef1.current.scrollTop = scrollRef1.current.scrollHeight;
      }

    }, 100);


  }

  function buildRegisterArray() {
    var arr = registerArray
    var obj = {};
    obj["section"] = sectionHeadingName;

    arr.push(obj)
    setRegisterArray(arr)

    console.log(registerArray)

  }

  function addingSectionFinishButton() {

    blinkText();
    if (sectionHeadingName != '') {
      buildRegisterArray()
      clearSection()

      var objQa = {}
      var arrQa = qaArray;
      var arrX = [];
      var objX = {};
      objX["label"] = "Section heading is ";
      arrX.push(objX);
      objX = {};
      objX["var"] = sectionHeadingName;
      arrX.push(objX);
      objQa["a"] = arrX;

      arrQa.push(objQa)
      objQa = {}
      objQa["q"] = "Enter Risk for \"" + registerArray[0].section + "\" OR \"FINISH\" to auto Generate Register"
      arrQa.push(objQa)
      setQaArray(arrQa)
      setDivHeight('150');

      setRiskSectionName("Enter risk type for " + registerArray[0].section)
      setRiskSectionId(registerArray[0].section)


      setStep4(true);
      setTimeout(() => {
        if (scrollRef.current) {
          scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
        }
        if (scrollRef1.current) {
          scrollRef1.current.scrollTop = scrollRef1.current.scrollHeight;
        }

      }, 100);

      return
    } else {
      setRiskSectionName("Enter risk type for " + registerArray[0].section)
      setRiskSectionId(registerArray[0].section)
      var objQa = {}
      var arrQa = qaArray;
      objQa = {}
      objQa["q"] = "Enter Risk for \"" + registerArray[0].section + "\" OR \"FINISH\" to auto Generate Register"
      arrQa.push(objQa)
      setQaArray(arrQa)
      setDivHeight('150');

      setTimeout(() => {
        if (scrollRef.current) {
          scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
        }
        if (scrollRef1.current) {
          scrollRef1.current.scrollTop = scrollRef1.current.scrollHeight;
        }

      }, 100);

      setStep4(true);

    }

  }


  //risk SECTION

  const [riskSectionId, setRiskSectionId] = React.useState('');

  const [riskSectionName, setRiskSectionName] = React.useState('');

  const [riskDescription, setRiskDescription] = React.useState('');



  const onChangeRiskDescription = (event) => {
    setRiskDescription(event.target.value);
  };

  function riskClear() {
    setRiskDescription('')
  }

  function riskFinish() {

    blinkText();
    if (riskDescription != '') {
      buildRiskArrayWithSection()
      riskClear()
      var objQa = {}
      var arrQa = qaArray;
      var arrX = [];
      var objX = {};
      objX["label"] = "Your have entered ";
      arrX.push(objX);
      objX = {};
      objX["var"] = riskDescription;
      arrX.push(objX);
      objX = {};
      objX["label"] = " as the Risk.";
      arrX.push(objX);
      objQa["a"] = arrX;

      arrQa.push(objQa)
      setQaArray(arrQa)
      setDivHeight('150');

      setTimeout(() => {
        if (scrollRef.current) {
          scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
        }
        if (scrollRef1.current) {
          scrollRef1.current.scrollTop = scrollRef1.current.scrollHeight;
        }

      }, 100);

    }

    registerArray.forEach((data, index) => {
      if (data.section === riskSectionId) {
        if (index + 1 >= registerArray.length) {
          finalizeReg()
        } else {
          setRiskSectionName("Enter risk type for " + registerArray[index + 1].section)
          setRiskSectionId(registerArray[index + 1].section)

          var objQa = {}
          var arrQa = qaArray;
          objQa = {}
          objQa["q"] = "Enter risk type for " + registerArray[index + 1].section
          arrQa.push(objQa)
          setQaArray(arrQa)
          setDivHeight('150');
        }
      }
    })

  }

  function buildRiskArrayWithSection() {

    var obj = {};
    obj["description"] = riskDescription;

    registerArray.forEach((data, index) => {
      if (data.section === riskSectionId) {
        if (registerArray[index + 1] != undefined && registerArray[index + 1] != null) {
          setNextRiskSectionId(registerArray[index + 1].section)
        } else {
          setNextRiskSectionId('')
        }
        var risksArr = []
        if (data.risks != undefined && data.risks != null) {
          risksArr = data.risks
          risksArr.push(obj)
        } else {
          risksArr.push(obj)
        }
        data["risks"] = risksArr

      }


    })


  }


  const [nextRiskSectionId, setNextRiskSectionId] = React.useState('');


  function riskMore() {
    blinkText();
    if (riskDescription === '') {
      alert('please enter description')
      return
    }
    buildRiskArrayWithSection()
    riskClear()

    var str = headerMessage
    var tmpStr = ''
    if (registerArray.length === 1) {
      tmpStr += " The register section is " + registerArray[0].section
      if (registerArray[0].risks != undefined && registerArray[0].risks != null && registerArray[0].risks.length > 0) {
        registerArray[0].risks.forEach((data, index) => {
          if (index === 0) {
            tmpStr += " with risk type " + data.description
          } else {
            tmpStr += " ," + data.description
          }
        })
      } else {
        tmpStr += ".";
      }

    } else {
      tmpStr += " The register sections are "
      registerArray.forEach((data, index) => {
        if (index === 0) {
          tmpStr += data.section
        } else {
          tmpStr += ", " + data.section
        }
        if (data.risks != undefined && data.risks != null && data.risks.length > 0) {
          data.risks.forEach((data1, index1) => {
            if (index1 === 0) {
              tmpStr += " with risk type " + data1.description
            } else {
              tmpStr += " ," + data1.description
            }
          })
        }

      })
    }
    var nextSectionId = "";
    registerArray.forEach((data, index) => {
      if (data.section === riskSectionId) {
        if (registerArray[index + 1] != undefined && registerArray[index + 1] != null) {
          nextSectionId = registerArray[index + 1].section;
        }
      }
    })

    var objQa = {}
    var arrQa = qaArray;

    var arrX = [];
    var objX = {};
    objX["label"] = "Your have entered ";
    arrX.push(objX);
    objX = {};
    objX["var"] = riskDescription;
    arrX.push(objX);
    objX = {};
    objX["label"] = " as a Risk for ";
    arrX.push(objX);
    objX = {};
    objX["var"] = riskSectionId;
    arrX.push(objX);
    objQa["a"] = arrX;

    arrQa.push(objQa)
    objQa = {}

    if (nextSectionId != '') {
      objQa["q"] = "Enter the Risk for \"" + riskSectionId + "\" OR Press \"DONE\" for Next Section \"" + nextSectionId + "\".\nOR Press \"FINISH\" to create the register."
    } else {
      objQa["q"] = "Enter the Risk for \"" + riskSectionId + "\" OR Press \"DONE\" Or \"FINISH\" to create the risk register "
    }

    arrQa.push(objQa)
    setQaArray(arrQa)
    setDivHeight('150');

    setTimeout(() => {
      if (scrollRef.current) {
        scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
      }
      if (scrollRef1.current) {
        scrollRef1.current.scrollTop = scrollRef1.current.scrollHeight;
      }
    }, 100);
  }

  const [finalJson, setFinalJson] = React.useState('')

  const [sectionHeadingMessage, setSectionHeadingMessage] = React.useState('Enter your Register sections')

  const [showSubmit, setShowSubmit] = React.useState(false)

  function finalizeReg() {
    blinkText();
    setShowSubmit(true)
    setStep5(true);

    var objQa = {}
    var arrQa = qaArray;
    objQa["q"] = "Enter DMG Risk GPT Question Id and Press \"Create Register\".";
    arrQa.push(objQa)
    setQaArray(arrQa)
    setDivHeight('150');

    setTimeout(() => {
      if (scrollRef.current) {
        scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
      }
      if (scrollRef1.current) {
        scrollRef1.current.scrollTop = scrollRef1.current.scrollHeight;
      }

    }, 100);

    var jsonStr = JSON.stringify(registerArray)
    setFinalJson(jsonStr)
  }

  const [loading, setLoading] = React.useState(false);
  const [loading1, setLoading1] = React.useState(false);

  const [questionId, setQuestionId] = useState('');
  const handlequestionId = (event) => {
    setQuestionId(event.target.value);
  };

  const [questiomRes, setQuestiomRes] = useState('');

  const [selectedRegisteredArray, setSelectedRegisteredArray] = React.useState([]);
  const [selectedRegisteredId, setSelectedRegisteredId] = React.useState('');
  const [selectedRegisteredName, setSelectedRegisteredName] = React.useState('');
  const [showEvaluateAndEditBtn, setShowEvaluateAndEditBtn] = React.useState(false);

  const [createdRegister, setCreatedRegister] = React.useState(false);

  const [createdHierachy, setCreatedHierachy] = React.useState(false);


  function sendToDataBase() {
    if (registerName === '') {
      alert("Please Register Name")
      return;
    }
    if (registerDescription === '') {
      alert("Please enter Register Description")
      return;
    }
    if (questionId === '') {
      alert("Please enter question id")
      return;
    }
    if (registerArray.length === 0) {
      alert("Please enter Key words to create Register")
      return;
    }

    setLoading(true);
    var obj = {}
    obj["userId"] = globalCentreId
    obj["createdBy"] = createUser


    var questionStr = "";
    questionStr += "Using the following JSON schema create a risk register ";

    var objArr = [];

    var riskStr = ""

    var tmpCount = 1;
    registerArray.forEach((item) => {
      if (item.risks != undefined && item.risks != null && item.risks.length > 0) {
        item.risks.forEach((item1, index1) => {
          if (riskStr === "") {
            riskStr += tmpCount + ")" + item1.description;
            tmpCount++;
          } else {
            riskStr += ", " + tmpCount + ")" + item1.description;
            tmpCount++;
          }
        })
      }
    })

    if (riskStr != "") {
      questionStr += "for the risks " + riskStr + " and incorporate risks";
      tmpCount = 1;
      var subStr = ""
      var emptyRiskSectionArr = [];
      registerArray.forEach((item) => {
        var str = "";

        if (item.risks != undefined && item.risks != null && item.risks.length > 0) {
          var noFound = false;
          item.risks.forEach((item1, index1) => {
            noFound = true;
            if (str === "") {
              str += tmpCount + ")";
              tmpCount++;
            } else {
              str += " and " + tmpCount + ")";
              tmpCount++;
            }
          })
          if (!noFound) {
            var xObj = {};
            xObj["section"] = item.section;
            emptyRiskSectionArr.push(xObj);
          }
          if (str === "") {
          } else {
            if (subStr === "") {
              subStr += " " + str + " into  the section " + item.section
            } else {
              subStr += " and risks " + str + " into  the section " + item.section
            }
          }
        } else {
          var xObj = {};
          xObj["section"] = item.section;
          emptyRiskSectionArr.push(xObj);
        }
      })

      questionStr += subStr;
      if (emptyRiskSectionArr.length > 0) {
        var xxStr = "";
        var xCount = 0
        emptyRiskSectionArr.forEach((item2, index2) => {
          xCount++;
          if (index2 === 0) {
            xxStr += item2.section;
          } else {
            xxStr += ", " + item2.section;
          }
        })
        if (xCount > 1) {
          questionStr += ", add further sections " + xxStr + " with at least 3 risks of your choice ";
        } else {
          questionStr += ", add further section " + xxStr + " with at least 3 risks of your choice ";
        }

      }

    } else {
      questionStr += "to cover ";
      var str = "";
      registerArray.forEach((item) => {
        if (str === "") {
          str += item.section
        } else {
          str += ", " + item.section
        }
      })
      questionStr += str;
    }
    questionStr += " and show it as a JSON object only : ";

    questionStr += "{   '$schema': 'http://json-schema.org/draft-07/schema#',   'type': 'object',   'properties': {     'riskRegister': {       'type': 'array',       'items': {         'type': 'object',         'properties': {           'section': {             'type': 'string'           },           'role': {             'type': 'string'           },           'likelihood': {             'type': 'integer',             'minimum': 1,             'maximum': 5           },           'impact': {             'type': 'integer',             'minimum': 1,             'maximum': 5           },           'riskLevel': {             'type': 'integer',             'minimum': 1,             'maximum': 25           },           'riskAppetite': {             'type': 'integer',             'minimum': 1,             'maximum': 10           },           'risks': {             'type': 'array',             'items': {               'type': 'object',               'properties': {                 'description': {                   'type': 'string'                 },                 'likelihood': {                   'type': 'integer',                   'minimum': 1,                   'maximum': 5                 },                 'impact': {                   'type': 'integer',                   'minimum': 1,                   'maximum': 5                 },                 'riskLevel': {                   'type': 'integer',                   'minimum': 1,                   'maximum': 25                 },                 'riskAppetite': {                   'type': 'integer',                   'minimum': 1,                   'maximum': 10                 },                 'riskHierarchy': {                   'type': 'object',                   'properties': {                     'key': {                       'type': 'string'                     },                     'description': {                       'type': 'string'                     }                   },                   'required': [                     'key',                     'description'                   ]                 }               },               'required': [                 'description',                 'likelihood',                 'impact',                 'riskLevel',                 'riskAppetite',                 'riskHierarchy'               ]             }           }         },         'required': [           'section',           'role',           'likelihood',           'impact',           'riskLevel',           'riskAppetite',           'risks'         ]       }     }   } }";

    var obj1 = {}
    obj1["messageId"] = questionId;
    obj1["message"] = questionStr;
    objArr.push(obj1);
    obj["chats"] = objArr
    var sendJson = JSON.stringify(obj)

    axios(CONFIG.MAIN_URL + '/openai/chat', {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      data: sendJson,
    })
      .then(function (response) {
        console.log(JSON.stringify(response.data));
        var schemaStr = JSON.stringify(response.data)
        var schemaObj = JSON.parse(schemaStr);

        setQuestiomRes(JSON.stringify(schemaObj, null, "\t"));
        console.log(response.data)

        var dataStr = "";
        schemaObj.messages.map((item, index) => {
          if (index === schemaObj.messages.length - 1) {
            item.answers.map((data, index) => {
              if (data.messageId === questionId) {
                dataStr = data.answer;
                dataStr = dataStr.replaceAll("\n", "");
                dataStr = dataStr.replaceAll("```json", "");
                dataStr = dataStr.replaceAll("```", "");
              }
            })
          }
        })

        try {
          var jObj = JSON.parse(dataStr);
          console.log(jObj);
          var riskRegisterValidate = true
          if (riskRegisterValidate) {
            var riskObj = {};
            riskObj["documentCreator"] = "expert";
            riskObj["name"] = registerName;
            riskObj["description"] = registerDescription;
            riskObj["centreId"] = globalCentreId;
            riskObj["status"] = "Draft";
            if (jObj.riskRegister != undefined && jObj.riskRegister != null && jObj.riskRegister.length > 0) {
              var mainArr = [];
              jObj.riskRegister.forEach((data) => {
                var tmpObj1 = {};
                tmpObj1["section"] = data.section;
                tmpObj1["role"] = data.role;
                tmpObj1["likelihood"] = data.likelihood;
                tmpObj1["impact"] = data.impact;
                tmpObj1["riskLevel"] = data.riskLevel;
                tmpObj1["riskAppetite"] = data.riskAppetite;
                var subArr = [];
                if (data.risks != undefined && data.risks != null && data.risks.length > 0) {
                  data.risks.forEach((data1) => {
                    var tmpObj2 = {};
                    tmpObj2["name"] = data1.description;
                    tmpObj2["description"] = data1.description;
                    tmpObj2["likelihood"] = data1.likelihood;
                    tmpObj2["impact"] = data1.impact;
                    tmpObj2["riskLevel"] = data1.riskLevel;
                    tmpObj2["riskAppetite"] = data1.riskAppetite;
                    var tmpObj3 = {};
                    var riskId = "";
                    tmpObj3["riskId"] = riskId;
                    tmpObj3["key"] = data1.riskHierarchy.key;
                    tmpObj3["name"] = data1.riskHierarchy.description;
                    tmpObj2["riskHierarchy"] = tmpObj3;
                    subArr.push(tmpObj2);
                  })
                  tmpObj1["risks"] = subArr;
                }
                mainArr.push(tmpObj1);
              })
              riskObj["riskRegister"] = mainArr;
            }
            console.log(riskObj);

            var sendingData = "mutation{createRegisterData(registerName:\"" + registerName + "\",status:\"" + 'draft' + "\",centreId:\"" + globalCentreId + "\"){registerId,registerName,status,centreId }}"

            axios(CONFIG.MAIN_URL + '/graphql', {
              method: 'post',
              headers: {
                'Content-Type': 'text/plain'
              },
              data: sendingData
            })
              .then(function (response) {
                console.log(JSON.stringify(response.data));
                let rtnData = response.data;
                console.log("++++++++++ register Data save in PG");
                console.log(rtnData);
                console.log("++++++++++ register Data save in PG");
                riskObj["registerUniqueName"] = globalCentreId + "_register_" + rtnData.data.createRegisterData.registerId;
                console.log(riskObj);
                console.log(JSON.stringify(riskObj));
                let sendJson = JSON.stringify(riskObj);
                axios(CONFIG.MAIN_URL + '/register/save', {
                  method: 'post',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  data: sendJson,
                })
                  .then(function (response) {
                    setLoading(false);
                    console.log(JSON.stringify(response.data));
                    console.log(response.data);
                    let rtnData = response.data;
                    alert("Register Created successfully.");

                    var registerId = response.data.id;
                    var name = response.data.name;

                    setSelectedRegisteredArray(response.data);
                    setSelectedRegisteredId(registerId);
                    setSelectedRegisteredName(name);

                    setStep1(false);
                    setStep2(false);
                    setStep3(false);
                    setStep4(false);
                    setStep5(false);
                    setRegisterArray([]);
                    setCreatedRegister(true)

                  })
                  .catch(function (error) {
                    setLoading(false);
                    console.log(error);
                    alert("Error saving Register-:" + error);
                  });
              })
              .catch(function (error) {
                setLoading(false);
                console.log(error);
                alert("Error saving register Data to Database Server -:" + error);
              });
          }

        } catch (error) {
          alert("Invalid Json created. Please do this again")
        }

      })
      .catch(function (error) {
        setLoading(false);
        console.log(error);
        alert("Error saving Question -:" + error);
      });

  }

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    try {
      var jObj = JSON.parse(questiomRes);
      var dataStr = "";
      jObj.messages.map((item, index) => {
        item.questions.map((data, index) => {
          dataStr = data.question;
          dataStr = dataStr.replaceAll("\n", "");
          dataStr = dataStr.replaceAll("\t", " ");
          dataStr = dataStr.replaceAll("\"", "\'");
          data["question"] = dataStr;
        })
        item.answers.map((data, index) => {
          dataStr = data.answer;
          dataStr = dataStr.replaceAll("\n", "");
          dataStr = dataStr.replaceAll("\t", " ");
          dataStr = dataStr.replaceAll("\"", "\'");
          data["answer"] = dataStr;
        })
      })
      setQuestiomRes(JSON.stringify(jObj, null, "\t"));
      setOpen(true);
    } catch (error) {
      alert("Invalid Json created. Please do this again")
      return;
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  function clearButton() {
    setTopHeaderTextMessage('');
    setQuestiomRes('');
    setCreatedRegister(false);
    setQuestionId('');
    setRegisterArray([]);
    setShowEvaluateAndEditBtn(false);
    setRegisterName('')
    setRegisterDescription('');
    setStep0(false);
    setStep1(false);
    setStep2(false);
    setStep3(false);
    setStep4(false);
    setStep5(false);
    setStep6(false);
    setStep7(false);
    setHeaderMessage("")
    setSectionHeadingMessage("");
    setSendMessageField();
    setRegisterName('');
    setRegisterDescription('')
    setQuestionId('')
    setRegisterArray([]);
    setHierarchyArray([]);
    setQaArray([]);

    setCreatedHierachy(false)
    setHierarchyKey('')
    setHierarchyNo('')
    setHierarchyName('')
    setRiskTypeDataForEval({})
    setSavedQuestionArray([])
    setCreatedRiskId('')
    setOpenShowQuestions(false)

    setSelectedQuesData([])
    setQuesDataCount(0)
    setUpdatedFromPreviousHirarchy(false);

  }

  const [registerTypeDataForEval, setRegisterTypeDataForEval] = React.useState({});
  const [editRiskHirachy, setEditRiskHirachy] = React.useState(false);
  const [selectedRegisterEvaluateTitle, setSelectedRegisterEvaluateTitle] = React.useState('');


  function createJsonObject(obj) {
    console.log("+++++++++++++++++++obj+++++++++++++++++++++");
    console.log(obj);
    var regTmpId = 100000;
    obj.riskRegister.forEach((data) => {
      data["riskTypeId"] = regTmpId
      regTmpId++;
      data.risks.forEach((risk) => {
        risk["riskTypeId"] = regTmpId
        regTmpId++;
        if (risk.riskHierarchy != undefined && risk.riskHierarchy != null) {
          if (risk.riskHierarchy.riskHierarchyData != undefined && risk.riskHierarchy.riskHierarchyData != null) {
            var riskHierarchyObj = risk.riskHierarchy.riskHierarchyData;
            if (riskHierarchyObj.riskTypes != undefined && riskHierarchyObj.riskTypes != null && riskHierarchyObj.riskTypes.length > 0) {
              risk["subRisks"] = riskHierarchyObj.riskTypes;
            }
          }

        }

      })
    })

    var dataStr = JSON.stringify(obj);
    dataStr = dataStr.replaceAll("\"riskRegister\"", "\"riskTypes\"");
    dataStr = dataStr.replaceAll("\"section\"", "\"name\"");
    dataStr = dataStr.replaceAll("\"risks\"", "\"subRisks\"");
    dataStr = dataStr.replaceAll("\"likelihood\"", "\"riskLikelihood\"");
    dataStr = dataStr.replaceAll("\"impact\"", "\"riskImpact\"");
    var jsonObj = JSON.parse(dataStr)

    return jsonObj;


  }

  var globalIdCount = 1;

  function assignExtraAttributes(data, tmpIdCount) {
    data.forEach((item) => {
      item["riskTypeTmpId"] = globalIdCount
      console.log(globalIdCount)
      globalIdCount++;
      if (item.subRisks != undefined && item.subRisks != null && item.subRisks.length > 0) {
        assignExtraAttributes(item.subRisks, tmpIdCount);
      }
    })
    return tmpIdCount;
  }


  const [multipleRoles, setMultipleRoles] = React.useState(false);


  function evaluateRiskFuction() {
    setRegisterTypeDataForEval({});

    setEditRiskHirachy(false)

    setOpenDisplayChoice(true)

  }


  function byRoleFuction() {
    getAllRegisterEval(globalCentreId, selectedRegisteredId, 'Role');
    setRegisterEvaluate(true)
    setOpenRegisterDataForEval(true)
    setOpenRegisterDataForEvalScroll('paper');
    setOpenDisplayChoice(false);
  }
  function byRiskNameFuction() {
    getAllRegisterEval(globalCentreId, selectedRegisteredId, 'RiskName');
    setRegisterEvaluate(true)
    setOpenRegisterDataForEval(true)
    setOpenRegisterDataForEvalScroll('paper');
    setOpenDisplayChoice(false);
  }



  function getAllRegisterEval(centrId, regId, type) {
    axios(CONFIG.MAIN_URL + `/register/all`, {
      method: 'get',
    })
      .then(function (response) {
        console.log("all register");
        console.log(response.data);
        response.data.forEach((item) => {
          if (item.centreId === centrId && item.id === regId) {
            var tmpIdCount = 1;
            var tmpIdCount1 = 1;
            var jsonObj = createJsonObject(item);
            setSelectedRegisterEvaluateTitle(item.name)


            globalIdCount = 1;
            jsonObj.riskTypes.forEach((item, index) => {
              item["riskTypeTmpId"] = globalIdCount;
              console.log(globalIdCount)
              globalIdCount++
              if (item.subRisks != undefined && item.subRisks != null && item.subRisks.length > 0) {
                tmpIdCount = assignExtraAttributes(item.subRisks, tmpIdCount);
                tmpIdCount++;
              }

            })
            setRegisterTypeDataForEval(jsonObj);

            setMultipleRoles(false)

            var mainArr = []
            jsonObj.riskTypes.forEach((data) => {
              var secName = data.role;
              var obj = {};
              var arr = [];
              var canTake = true;

              mainArr.forEach((arrData) => {
                if (arrData.role === secName) {
                  canTake = false;
                }
              })

              if (canTake) {
                jsonObj.riskTypes.forEach((item) => {
                  if (secName === item.role) {
                    arr.push(item);
                  }
                })

                obj["role"] = data.role

                mainArr.push(obj);
              }
            })

            if (mainArr.length > 1) {
              setMultipleRoles(true)
            }

            if (type === "RiskName") {
              setMultipleRoles(false)
            }
          }

        })

      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const [openRegisterDataForEval, setOpenRegisterDataForEval] = React.useState(false);
  const [openRegisterDataForEvalScroll, setOpenRegisterDataForEvalScroll] = React.useState('paper');
  const [registerEvaluate, setRegisterEvaluate] = React.useState(false);

  const [fullScreenState, setFullScreenState] = React.useState(false);
  const [fullScreenStateRegister, setFullScreenStateRegister] = React.useState(false);
  const [fullScreenStateMsg, setFullScreenStateMsg] = React.useState('Full Screen');
  const [maxWidthState, setMaxWidthState] = React.useState('lg');

  function PaperComponentCollectionDataRegister(props) {
    return (
      <Draggable
        handle="#register-data-dialog-title"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} />
      </Draggable>
    );
  }

  const [openDisplayChoice, setOpenDisplayChoice] = React.useState(false);
  const handleCloseDisplayChoice = () => {
    setOpenDisplayChoice(false);
  };

  function RegisterDataForEvalfunctionClose() {
    setOpenRegisterDataForEval(false)
  }

  const [openRegisterEdit, setOpenRegisterEdit] = React.useState(false);
  const [openRegisterEditScroll, setOpenRegisterEditScroll] = React.useState('paper');


  function editRiskFuction() {
    setOpenRegisterEdit(true)
    setOpenRegisterEditScroll('paper');
  }

  const [openRiskHierarchyComponent, setOpenRiskHierarchyComponent] = React.useState(false);
  const [openRiskHierarchyComponentScroll, setOpenRiskHierarchyComponentScroll] = React.useState('paper');


  function addRiskFuction() {
    setOpenRiskHierarchyComponent(true)
    setOpenRiskHierarchyComponentScroll('paper')

  }

  //dialogstandard

  const [riskStandardOpen, setRiskStandardOpen] = React.useState(false);

  const [globalStandardDataForObjective, setGlobalStandardDataForObjective] = useState('')

  const [globalStandardDataForComponent, setGlobalStandardDataForComponent] = useState('')

  const [globalStandardDataForPrinciple, setGlobalStandardDataForPrinciple] = useState('')

  const [globalStandardData, setGlobalStandardData] = React.useState([]);

  const [standardData, setStandardData] = React.useState([]);

  const [customStandardData, setCustomStandardData] = React.useState([]);

  function getStandards(cntre) {
    axios(CONFIG.MAIN_URL + `/standard/all??centreId=` + cntre, {
      method: 'get',
    })
      .then(function (response) {
        console.log("++++++++++++++++Return Standard Data +++++++++++++++++++");
        console.log(response.data);
        console.log(JSON.stringify(response.data));
        setStandardData(response.data);
        var arrG = [];
        var arrC = [];
        response.data.forEach((item) => {
          if (item.centreId === "globle") {
            arrG.push(item);
          }
          if (item.centreId === cntre) {
            arrC.push(item);
          }
        })
        setGlobalStandardData(arrG);
        setCustomStandardData(arrC);

      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const [schemaName, setSchemaName] = useState('');
  const handleChangeSchemaName = (event) => {
    setSchemaName(event.target.value);
  };


  function addRiskFuctionStandard() {
    if (hierarchyKey === '') {
      alert("Please Assign Risk Hierarchy Key")
      return;
    }
    if (hierarchyName === '') {
      alert("Please Assign Risk Hierarchy Name")
      return;
    }

    if (questionId === '') {
      alert("Please enter question id")
      return;
    }
    if (finalHJson === '') {
      alert("Please enter Key words to create Risk Hierarchy")
      return;
    }


    setRiskStandardOpen(true)
  }

  const handleCloseStandardDialog = () => {
    setRiskStandardOpen(false);
  };


  const handleStandardDialogClear = () => {
    setGlobalStandardDataForObjective('');
    setGlobalStandardDataForComponent('')
    setGlobalStandardDataForPrinciple('')
  };

  const handleChangeGlobalStandardDataForObjective = (event) => {
    console.log(globalStandardData)
    setGlobalStandardDataForObjective(event.target.value);
    globalStandardData.filter(com => com.components.length > 0).forEach((obj) => {
      if (obj.standardName === event.target.value) {
        if (globalStandardDataForComponent === '') {
          setGlobalStandardDataForComponent(event.target.value)
        }
      }

    })
    globalStandardData.filter(com => com.principles.length > 0).forEach((obj) => {
      if (obj.standardName === event.target.value) {
        if (globalStandardDataForPrinciple === '') {
          setGlobalStandardDataForPrinciple(event.target.value)
        }
      }

    })
  }

  const handleChangeGlobalStandardDataForComponent = (event) => {
    setGlobalStandardDataForComponent(event.target.value);
    globalStandardData.filter(com => com.objectives.length > 0).forEach((obj) => {
      if (obj.standardName === event.target.value) {
        if (globalStandardDataForObjective === '') {
          setGlobalStandardDataForObjective(event.target.value)
        }
      }

    })
    globalStandardData.filter(com => com.principles.length > 0).forEach((obj) => {
      if (obj.standardName === event.target.value) {
        if (globalStandardDataForPrinciple === '') {
          setGlobalStandardDataForPrinciple(event.target.value)
        }
      }

    })
  }

  const handleChangeGlobalStandardDataForPrinciple = (event) => {
    setGlobalStandardDataForPrinciple(event.target.value);
    globalStandardData.filter(com => com.objectives.length > 0).forEach((obj) => {
      if (obj.standardName === event.target.value) {
        if (globalStandardDataForObjective === '') {
          setGlobalStandardDataForObjective(event.target.value)
        }
      }

    })
    globalStandardData.filter(com => com.components.length > 0).forEach((obj) => {
      if (obj.standardName === event.target.value) {
        if (globalStandardDataForComponent === '') {
          setGlobalStandardDataForComponent(event.target.value)
        }
      }

    })


  }

  /** Risk Hierarchy Section */

  const [hierarchyNo, setHierarchyNo] = React.useState('');
  const handleChangeHierarchyNo = (event) => {
    setHierarchyNo(event.target.value);
  };


  const [selectedEntityName, setSelectedEntityName] = React.useState('');

  const [topHeaderTextMessage, setTopHeaderTextMessage] = React.useState('');

  const handleButtonStep0HClick = () => {
    blinkText(voice2);
    if (hierarchyNo === '') {
      alert("Please Select the item to change/amend your risks ");
      return;
    }

    var tmpSectionName = "";
    var tmpRiskKey = "";
    var tmpRiskName = "";


    var countItem = 0;
    var foundItem = false;

    var countSection = 1;
    var arrSection = [];

    selectedRegisterData.riskRegister.forEach((item, index) => {
      item["sectionTmpId"] = countSection;
      countSection++;
      var arrRisk = [];
      if (item.risks != undefined && item.risks != null && item.risks.length > 0) {
        item.risks.forEach((item1, index1) => {
          item1["hierarchyTmpId"] = countSection;
          countSection++;
          countItem++;
          if (countItem === parseInt(hierarchyNo)) {
            foundItem = true;
            setSelectedSectionId(item.id);
            setSelectedEntityName(item.role)
            tmpSectionName = item.section;
            setSelectedSectionName(item.section)


            setSelectedRiskId(item1.id);
            tmpRiskKey = item1.riskHierarchy.key;
            setSelectedRiskKey(item1.riskHierarchy.key);
            tmpRiskName = item1.name;
            setSelectedRiskName(item1.name);
          }
          arrRisk.push(item1);

        })
      }
      item["risks"] = arrRisk
      arrSection.push(item);
    })

    if (!foundItem) {
      alert("You have selected a wrong number. Please select a correct No");
      return;
    }

    setStep1(true);
    setFirstTime(false)

    var objQa = {}
    var arrQa = qaArray;

    var messageStr = "";

    arrQa.forEach((data, itemIndex) => {
      if (itemIndex + 1 === riskIdCount) {
        var tStr = "You have selected ";
        tStr += "<i><span className=\"" + wordstyle + "\" style='font-weight: 600; line-height: 1.2rem; font-family: Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular;'>" + hierarchyNo + "</span></i>"

        messageStr = `<span className="${wordstyle}" style=' line-height: 1.2rem; font-family: Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular;'>You have selected number </span>`;
        messageStr += "<i><span className=\"" + wordstyle + "\" style='font-weight: 600; line-height: 1.2rem; font-family: Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular;'>" + hierarchyNo + "</span></i>";

        data["a"] = tStr;
      }
    })

    if (messageStr != '') {
      messageStr += "<span className=\"" + wordstyle + "\" style=' line-height: 1.2rem; font-family: Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular;'> - Section : </span>";
      messageStr += "<i><span className=\"" + wordstyle + "\" style='font-weight: 600; line-height: 1.2rem; font-family: Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular;'>" + tmpSectionName + "</span></i>";
      messageStr += "<span className=\"" + wordstyle + "\" style=' line-height: 1.2rem; font-family: Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular;'> Risk : </span>";
      messageStr += "<i><span className=\"" + wordstyle + "\" style='font-weight: 600; line-height: 1.2rem; font-family: Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular;'>" + tmpRiskName + "</span></i>";
      setTopHeaderTextMessage(messageStr);
    }

    objQa = {}
    objQa["id"] = riskIdCount + 1;
    setRiskIdCount(riskIdCount + 1);
    objQa["q"] = "Change your Hierarchy Key for Creating a new Hierarchy."

    objQa["v"] = voice2;

    setVoice(voice2);

    arrQa.push(objQa)
    setQaArray(arrQa)
    setDivHeight('300');
    setDivHeight1('300');

    setHierarchyKey(tmpRiskKey)

    setTimeout(() => {

      if (scrollRef.current) {
        scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
      }

      if (scrollRef1.current) {
        scrollRef1.current.scrollTop = scrollRef1.current.scrollHeight;
      }

    }, 100);

  };



  const [hierarchyKey, setHierarchyKey] = React.useState('');
  const handleChangeHierarchyKey = (event) => {
    setHierarchyKey(event.target.value);
  };

  const handleButtonStep2HClick = () => {

    blinkText(voice3);

    if (hierarchyKey === '') {
      alert("Please assign a Hierarchy Key");
      return;
    }
    setStep2(true);

    var objQa = {}
    var arrQa = qaArray;

    arrQa.forEach((data, itemIndex) => {
      if (itemIndex + 1 === riskIdCount) {
        var tStr = "";
        tStr += "<i><span className=\"" + wordstyle + "\" style='font-weight: 600; line-height: 1.2rem; font-family: Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular;'>" + hierarchyKey + "</span></i>"
        data["a"] = tStr;

      }
    })

    objQa = {}
    objQa["id"] = riskIdCount + 1;
    setRiskIdCount(riskIdCount + 1);
    objQa["q"] = "Enter your Hierarchy Name."

    objQa["v"] = voice3;
    setVoice(voice3);

    arrQa.push(objQa)
    setQaArray(arrQa)
    setDivHeight('300');
    setDivHeight1('300');


    setHierarchyName(selectedRiskName)


    setTimeout(() => {
      if (scrollRef.current) {
        scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
      }
      if (scrollRef1.current) {
        scrollRef1.current.scrollTop = scrollRef1.current.scrollHeight;
      }

    }, 100);

  };

  /** For Previous Hirarchy */

  const renderTextName = (params) => {
    return (
      <Tooltip title={params.row.name}>
        <span style={{ fontSize: '10px' }}>{params.row.name}</span>
      </Tooltip>
    )
  }
  const renderTextNo = (params) => {
    return (
      <span style={{ fontSize: '10px' }}>{params.row.id}</span>
    )
  }
  const renderTextKey = (params) => {
    return (
      <Tooltip title={params.row.key}>
        <span style={{ fontSize: '10px' }}>{params.row.key}</span>
      </Tooltip>
    )
  }

  const renderShowButton = (params) => {
    return (
      <strong>
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={() => {
            showPreviousHirarchyFun(params.row.riskId)
          }}
        >
          Show
        </Button>
      </strong>
    )
  }


  const renderSelectButton = (params) => {
    return (
      <strong>
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={() => {
            selectPreviousHirarchyFun(params.row.riskId)
          }}
        >
          Assign
        </Button>
      </strong>
    )
  }

  const hColumns = [
    { field: 'id', headerName: 'No', renderCell: renderTextNo, resizable: true, width: 15 },
    { field: 'riskId', headerName: 'No', width: 15, hide: true },
    { field: 'key', headerName: 'RiskHierarchy Key', renderCell: renderTextKey, resizable: true, cellClassName: 'super-app-theme--cell', width: 180 },
    { field: 'name', headerName: 'Risk Hierarchy Name', renderCell: renderTextName, resizable: true, cellClassName: 'super-app-theme--cell', width: 425 },
    {
      field: 'action1',
      headerName: 'Show',
      sortable: false,
      renderCell: renderShowButton,
      disableClickEventBubbling: true,

    },
    {
      field: 'action',
      headerName: 'Assign',
      sortable: false,
      renderCell: renderSelectButton,
      disableClickEventBubbling: true,

    }
  ];

  function PaperComponentHierarchyData(props) {
    return (
      <Draggable
        handle="#hierarchy-data-dialog-title"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} />
      </Draggable>
    );
  }

  const [hRows, setHRows] = React.useState([]);
  const [openShowHierarchies, setOpenShowHierarchies] = React.useState(false);
  const [openShowHierarchiesScroll, setOpenShowHierarchiesScroll] = React.useState('paper');



  function handleButtonStep2HPreviousClick() {
    var count = 1;
    var tmpArray = [];
    setHRows([]);
    globalRiskArray.forEach((item) => {
      console.log(item);
      var tmpObj = {};
      tmpObj["id"] = count;
      tmpObj["riskId"] = item.riskId;
      tmpObj["key"] = item.key;
      tmpObj["name"] = item.name;
      tmpObj["riskData"] = item;
      tmpArray.push(tmpObj);
      setHRows(tmpArray);
      count++;
    })
    setOpenShowHierarchies(true);
    setOpenShowHierarchiesScroll('paper');


  }


  const [updatedFromPreviousHirarchy, setUpdatedFromPreviousHirarchy] = React.useState(false);

  function showPreviousHirarchyFun(id) {
    setCreatedRiskId(id)
    setRegisterEvaluate(false)
    globalRiskArray.forEach((item) => {
      if (id === item.riskId) {
        setRegisterTypeDataForEval(item)
        setSelectedRegisterEvaluateTitle(item.name)
      }
    });
    setOpenRegisterDataForEval(true)
    setOpenRegisterDataForEvalScroll('paper');

  }


  function selectPreviousHirarchyFun(id) {
    setLoading(true);
    globalRiskArray.forEach((item) => {
      if (id === item.riskId) {
        axios(CONFIG.MAIN_URL + `/register/all`, {
          method: 'get',
        })
          .then(function (response) {
            console.log("all register");
            console.log(response.data);
            response.data.forEach((data) => {
              if (data.centreId === globalCentreId && data.id === createdRegisterId) {
                var regData = data;
                regData.riskRegister.forEach((dataReg, index) => {
                  if (dataReg.id === selectedSectionId) {
                    dataReg.risks.forEach((dataRisks, index1) => {
                      if (dataRisks.id === selectedRiskId) {
                        dataRisks.riskHierarchy["riskId"] = item.riskId;
                        dataRisks.riskHierarchy["key"] = item.key;
                        dataRisks.riskHierarchy["name"] = item.name;
                        dataRisks.riskHierarchy["riskHierarchyData"] = item;
                      }
                    })
                  }
                })
                console.log(regData);
                console.log(JSON.stringify(regData));
                let sendJson = JSON.stringify(regData);
                axios(CONFIG.MAIN_URL + '/register/save', {
                  method: 'post',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  data: sendJson,
                })
                  .then(function (resp) {
                    setLoading(false);
                    console.log("++++++++++++++++++Register Update Response+++++++++++++++++++");
                    console.log(resp.data);
                    let rtnData = resp.data;
                    setTimeout(() => {
                      alert("Register Updated successfully with Created Risk Hierarchy.");
                    }, 500);
                    setSelectedRegisteredId(rtnData.id);
                    setUpdatedFromPreviousHirarchy(true)

                    setRiskTypeDataForEval(item);
                    setCreatedRiskId(item.riskId);
                    /** From DmgRiskGpt */
                    setCreatedRiskHierarchyId(item.riskId)
                    setSelectedRiskEvaluateTitle(item.name);
                    setEditRiskOrRegister('Edit Risk');

                    setCreatedHierachy(true)

                    setOpenShowHierarchies(false);

                  })
                  .catch(function (error) {
                    setLoading(false);
                    console.log(error);
                    alert("Error updating Register -:" + error);
                  });
              }
            })
          })
          .catch(function (error) {
            console.log(error);
            setLoading(false);
          });
      }

    })

  }

  /** End of Previos Adding */

  const [hierarchyName, setHierarchyName] = React.useState('');
  const handleChangeHierarchyName = (event) => {
    setHierarchyName(event.target.value);
  };


  const [hierarchyMainRiskMessage, setHierarchyMainRiskMessage] = React.useState('Enter your Main Risk')
  const handleButtonStep3HClick = () => {
    blinkText(voice4);

    if (hierarchyName === '') {
      alert("Please assign a Hierarchy Name");
      return;
    }
    setStep3(true);

    var objQa = {}
    var arrQa = qaArray;
    arrQa.forEach((data, itemIndex) => {
      if (itemIndex + 1 === riskIdCount) {
        var tStr = "";
        tStr += "<i><span className=\"" + wordstyle + "\" style='font-weight: 600; line-height: 1.2rem; font-family: Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular;'>" + hierarchyName + "</span></i>"
        data["a"] = tStr;
      }
    })

    objQa = {}
    objQa["id"] = riskIdCount + 1;
    setRiskIdCount(riskIdCount + 1);
    objQa["q"] = "Enter your Main Risks (Separate with ;)"

    setVoice(voice4);

    arrQa.push(objQa)
    setQaArray(arrQa)
    setDivHeight('300');

    setTimeout(() => {
      if (scrollRef.current) {
        scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
      }
      if (scrollRef1.current) {
        scrollRef1.current.scrollTop = scrollRef1.current.scrollHeight;
      }

    }, 100);

  };

  const [hierarchyArray, setHierarchyArray] = React.useState([])

  function buildHierarchyArray() {
    var arr = hierarchyArray;
    var tmpArr = mainRiskName.split(";")
    tmpArr.forEach((data) => {
      var obj = {};
      obj["mainRisk"] = data;
      arr.push(obj);
    })
    setHierarchyArray(arr);
    console.log(arr);
  }

  function clearMainRisk() {
    setMainRiskName('');
  }


  const [mainRiskName, setMainRiskName] = React.useState('');
  const onChangeMainRiskName = (event) => {
    setMainRiskName(event.target.value);
  };

  const [mainRiskId, setMainRiskId] = React.useState('');
  function clickMainRiskDoneButton() {
    blinkText(voice6);

    if (mainRiskName === '') {
      alert('please enter at least one Main Risk')
      return;
    }

    buildHierarchyArray();

    var objQa = {}
    var arrQa = qaArray;

    arrQa.forEach((data, itemIndex) => {
      if (itemIndex + 1 === riskIdCount) {
        var tStr = "You have selected ";
        tStr += "<i><span className=\"" + wordstyle + "\" style='font-weight: 600; line-height: 1.2rem; font-family: Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular;'>" + mainRiskName + "</span></i>"
        data["a"] = tStr;
      }
    })

    objQa = {}
    objQa["id"] = riskIdCount + 1;
    setRiskIdCount(riskIdCount + 1);
    objQa["q"] = "Enter another " + subRiskLabals + " within \"" + hierarchyArray[0].mainRisk + "\" (Separate with ;) OR \"DONE\" to continue OR \"FINISH\" to auto complete"
    arrQa.push(objQa)
    setQaArray(arrQa)
    setDivHeight('300');

    setMainRiskId(hierarchyArray[0].mainRisk)
    setStep4(true);
    clearMainRisk()
    setTimeout(() => {
      if (scrollRef.current) {
        scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
      }
      if (scrollRef1.current) {
        scrollRef1.current.scrollTop = scrollRef1.current.scrollHeight;
      }

    }, 100);
    setVoice(voice6)

  }


  const [subRiskName, setSubRiskName] = React.useState('');
  const onChangeSubRiskName = (event) => {
    setSubRiskName(event.target.value);
  };

  const [nextMainRiskId, setNextMainRiskId] = React.useState('');
  function buildSubRiskArrayWithMainRisk() {
    var tmpArr = subRiskName.split(";")
    tmpArr.forEach((item) => {
      var obj = {};
      obj["subRisk"] = item;
      hierarchyArray.forEach((data, index) => {
        if (data.mainRisk === mainRiskId) {
          if (hierarchyArray[index + 1] != undefined && hierarchyArray[index + 1] != null) {
            setNextMainRiskId(hierarchyArray[index + 1].mainRisk)
          } else {
            setNextMainRiskId('')
          }
          var subRisksArr = []
          if (data.components != undefined && data.components != null) {
            subRisksArr = data.components
            subRisksArr.push(obj)
          } else {
            subRisksArr.push(obj)
          }
          data["components"] = subRisksArr
        }
      })
    })
  }

  function subRiskClear() {
    setSubRiskName('');
  }

  function subRiskDone() {
    blinkText(voice8);
    if (subRiskName != '') {
      buildSubRiskArrayWithMainRisk()
      var objQa = {}
      var arrQa = qaArray;

      arrQa.forEach((data, itemIndex) => {
        if (itemIndex + 1 === riskIdCount) {
          var tStr = "Your have entered ";
          tStr += "<i><span className=\"" + wordstyle + "\" style='font-weight: 600; line-height: 1.2rem; font-family: Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular;'>" + subRiskName + "</span></i>"
          tStr += "<span className=\"" + wordstyle + "\" style=' line-height: 1.2rem; font-family: Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular;'>" + " as a Sub Risk for " + "</span>";
          tStr += "<i><span className=\"" + wordstyle + "\" style='font-weight: 600; line-height: 1.2rem; font-family: Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular;'>" + mainRiskId + "</span></i>"
          data["a"] = tStr;


        }
      })
      setQaArray(arrQa)
      setDivHeight('300');

      subRiskClear()
    }

    hierarchyArray.forEach((data, index) => {
      if (data.mainRisk === mainRiskId) {
        if (index + 1 >= hierarchyArray.length) {
          finishSubRisk();
        } else {
          setMainRiskId(hierarchyArray[index + 1].mainRisk)
          var objQa = {}
          var arrQa = qaArray;
          objQa = {}
          objQa["id"] = riskIdCount + 1;
          setRiskIdCount(riskIdCount + 1);

          objQa["q"] = "Enter another " + subRiskLabals + " within \"" + hierarchyArray[index + 1].mainRisk + "\" (Separate with ;) OR \"DONE\" to continue OR \"FINISH\" to auto complete.";

          setVoice(voice8)
          arrQa.push(objQa)
          setQaArray(arrQa)
          setDivHeight('300');
          setTimeout(() => {
            if (scrollRef.current) {
              scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
            }
            if (scrollRef1.current) {
              scrollRef1.current.scrollTop = scrollRef1.current.scrollHeight;
            }

          }, 100);

        }
      }
    })
  }


  const [selectedMainRiskId, setSelectedMainRiskId] = React.useState('');
  const [selectedSubRiskId, setSelectedSubRiskId] = React.useState('');

  function finishSubRisk() {
    blinkText(voice9);
    var foundSub = false;
    var mainName = '';
    var subName = '';
    hierarchyArray.forEach((data, index) => {
      if (!foundSub) {
        if (data.components != undefined && data.components != null) {
          data.components.forEach((item, index) => {
            if (!foundSub) {
              if (item.subRisk != undefined && item.subRisk != null && item.subRisk != '') {
                foundSub = true;
                setSelectedMainRiskId(data.mainRisk);
                setSelectedSubRiskId(item.subRisk);
                mainName = data.mainRisk;
                subName = item.subRisk;
              }
            }
          })
        }
      }
    })
    if (subName === "" && mainName === "") {
      setStep4(true);
      setStep5(true);
      finishSubSubRisk();
    } else {
      setStep5(true);
      var objQa = {}
      var arrQa = qaArray;
      objQa["q"] = "Enter another " + subSubRiskLabals + " (Separate with ;) within \"" + subName + "\" in \"" + mainName + "\"";
      objQa["id"] = riskIdCount + 1;
      setRiskIdCount(riskIdCount + 1);
      setVoice(voice9)


      arrQa.push(objQa)
      setQaArray(arrQa)
      setDivHeight('300');

      setTimeout(() => {
        if (scrollRef.current) {
          scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
        }
        if (scrollRef1.current) {
          scrollRef1.current.scrollTop = scrollRef1.current.scrollHeight;
        }

      }, 100);
    }


  }

  const [subSubRiskName, setSubSubRiskName] = React.useState('');
  const onChangeSubSubRiskName = (event) => {
    setSubSubRiskName(event.target.value);
  };

  function buildSubSubRiskArrayWithMainRisk() {
    var tmpArr = subSubRiskName.split(";")
    tmpArr.forEach((itemT) => {
      var obj = {};
      obj["subSubRiskName"] = itemT;
      hierarchyArray.forEach((data, index) => {
        if (data.mainRisk === selectedMainRiskId) {
          if (data.components != undefined && data.components != null) {
            data.components.forEach((item, index) => {
              if (item.subRisk === selectedSubRiskId) {
                var subSubRisksArr = [];
                if (item.subSubRisks != undefined && item.subSubRisks != null) {
                  subSubRisksArr = item.subSubRisks;
                }
                subSubRisksArr.push(obj);
                item["subSubRisks"] = subSubRisksArr;
              }
            })
          }
        }
      })
    })
  }

  function subSubRiskClear() {
    setSubSubRiskName('');
  }

  function subSubRiskDone() {
    blinkText(voice11);
    if (subSubRiskName != '') {
      buildSubSubRiskArrayWithMainRisk();

      var objQa = {}
      var arrQa = qaArray;
      arrQa.forEach((data, itemIndex) => {
        if (itemIndex + 1 === riskIdCount) {
          var tStr = "Your have entered ";
          tStr += "<i><span className=\"" + wordstyle + "\" style='font-weight: 600; line-height: 1.2rem; font-family: Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular;'>" + subSubRiskName + "</span></i>"
          tStr += "<span className=\"" + wordstyle + "\" style=' line-height: 1.2rem; font-family: Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular;'>" + " as a Sub Sub Risk for " + "</span>";
          tStr += "<i><span className=\"" + wordstyle + "\" style='font-weight: 600; line-height: 1.2rem; font-family: Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular;'>" + selectedSubRiskId + "</span></i>"
          tStr += "<span className=\"" + wordstyle + "\" style=' line-height: 1.2rem; font-family: Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular;'>" + " in " + "</span>";
          tStr += "<i><span className=\"" + wordstyle + "\" style='font-weight: 600; line-height: 1.2rem; font-family: Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular;'>" + selectedMainRiskId + "</span></i>"
          data["a"] = tStr;

        }
      })

      setQaArray(arrQa)
      setDivHeight('300');
      subRiskClear()
    }

    var nextSelectedSubRiskId = ""
    var nextSelectedMainRiskId = ""
    hierarchyArray.forEach((data, index) => {
      if (data.mainRisk === selectedMainRiskId) {
        if (data.components != undefined && data.components != null) {
          data.components.forEach((item, index1) => {
            if (item.subRisk === selectedSubRiskId) {
              if (data.components[index1 + 1] != undefined && data.components[index1 + 1] != null) {
                nextSelectedSubRiskId = data.components[index1 + 1].subRisk;
                nextSelectedMainRiskId = selectedMainRiskId;
                setSelectedSubRiskId(data.components[index1 + 1].subRisk);
              }
            }
          })
        }
      }
    })
    if (nextSelectedSubRiskId === "") {
      hierarchyArray.forEach((data, index) => {
        if (data.mainRisk === selectedMainRiskId) {
          var calTake = false;
          for (let i = index + 1; i < hierarchyArray.length; i++) {
            if (!calTake && hierarchyArray[i] != undefined && hierarchyArray[i] != null) {
              if (hierarchyArray[i].components != undefined && hierarchyArray[i].components != null) {
                hierarchyArray[i].components.forEach((item, index1) => {
                  if (!calTake && item.subRisk != undefined && item.subRisk != null && item.subRisk != "") {
                    nextSelectedMainRiskId = hierarchyArray[i].mainRisk;
                    setSelectedMainRiskId(hierarchyArray[i].mainRisk);
                    nextSelectedSubRiskId = item.subRisk;
                    setSelectedSubRiskId(item.subRisk);
                    calTake = true;
                  }
                })
              }
            }
          }
        }
      })
    }
    if (nextSelectedSubRiskId === "") {
      finishSubSubRisk();
    } else {
      var objQa = {}
      var arrQa = qaArray;
      objQa = {}
      objQa["id"] = riskIdCount + 1;
      setRiskIdCount(riskIdCount + 1);
      objQa["q"] = "Enter another " + "risks" + " within \"" + nextSelectedSubRiskId + "\" (Separate with ;) in \"" + nextSelectedMainRiskId + "\"";

      setVoice(voice11);
      arrQa.push(objQa)
      setQaArray(arrQa)
      setDivHeight('300');
      setTimeout(() => {
        if (scrollRef.current) {
          scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
        }
        if (scrollRef1.current) {
          scrollRef1.current.scrollTop = scrollRef1.current.scrollHeight;
        }

      }, 100);

    }
    subSubRiskClear();



  }

  function getMainRiskTopStr(jsonObj) {
    var mainRiskTopStr = "";
    jsonObj.objectives.forEach((item, index) => {
      var mainRiskName = item.mainRisk.trim();
      if (index === 0) {
        mainRiskTopStr += "'" + mainRiskName + "'";
      } else {
        if (jsonObj.objectives.length - 1 === index) {
          mainRiskTopStr += " and '" + mainRiskName + "'";
        } else {
          mainRiskTopStr += " ,'" + mainRiskName + "'";
        }
      }
    });
    return mainRiskTopStr;
  }
  function getMainRiskTopStrWithCount(jsonObj) {
    var mainRiskTopStr = "";
    var count = 1;
    jsonObj.objectives.forEach((item, index) => {
      var mainRiskName = item.mainRisk.trim();
      if (index === 0) {
        mainRiskTopStr += count + ") " + mainRiskName + "";
        count++;
      } else {
        mainRiskTopStr += ", " + count + ") " + mainRiskName + "";
        count++;
      }
    });
    return mainRiskTopStr;
  }
  function getMainRiskCount(jsonObj) {
    var mainRiskCount = 0;
    jsonObj.objectives.forEach((item, index) => {
      mainRiskCount++;
    });
    return mainRiskCount;
  }

  function getMainRiskStr(jsonObj) {
    var mainRiskStr = "";
    jsonObj.objectives.forEach((item, index) => {
      var mainRiskName = item.mainRisk.trim();
      if (index === 0) {
        mainRiskStr += "'" + mainRiskName + "'";
      } else {
        if (jsonObj.objectives.length - 1 === index) {
          mainRiskStr += " and '" + mainRiskName + "'";
        } else {
          mainRiskStr += " ,'" + mainRiskName + "'";
        }
      }
    });
    return mainRiskStr;
  }

  function getSubRiskMainStr(jsonObj) {
    var subRiskMainStr = "";
    jsonObj.objectives.forEach((item, index) => {
      var mainRiskName = item.mainRisk.trim();
      if (item.components != undefined && item.components != null && item.components.length > 0) {
        var subRiskStr = "";
        item.components.forEach((item1, index1) => {
          var subRiskName = item1.subRisk.trim();
          if (index1 === 0) {
            subRiskStr += "'" + subRiskName + "'";
          } else {
            subRiskStr += ", '" + subRiskName + "'";
          }
        })
        if (subRiskStr != "") {
          subRiskStr += " in to " + "'" + mainRiskName + "'";
          if (subRiskMainStr === '') {
            subRiskMainStr += subRiskStr;
          } else {
            subRiskMainStr += " and " + subRiskStr;
          }
        } else {
          subRiskStr += "'" + mainRiskName + "'" + " has no subRisk ";
          if (subRiskMainStr === '') {
            subRiskMainStr += subRiskStr;
          } else {
            subRiskMainStr += " and " + subRiskStr;
          }
        }

      }
    });
    return subRiskMainStr;
  }

  function getSubRiskMainStrWithCount(jsonObj) {
    var subRiskMainStr = "";
    var firstTime = true;
    jsonObj.objectives.forEach((item, index) => {
      if (item.components != undefined && item.components != null && item.components.length > 0) {
        item.components.forEach((item1, index1) => {
          var subRiskName = item1.subRisk.trim();
          if (firstTime) {
            firstTime = false;
            subRiskMainStr += (index + 1) + "." + (index1 + 1) + ") " + subRiskName + "";
          } else {
            subRiskMainStr += ", " + (index + 1) + "." + (index1 + 1) + ") " + subRiskName + "";
          }
        })
      }
    });
    return subRiskMainStr;
  }


  function getSubSubRiskMainStr(jsonObj) {
    var subSubRiskMainStr = "";
    jsonObj.objectives.forEach((item, index) => {
      var mainRiskName = item.mainRisk.trim();
      if (item.components != undefined && item.components != null && item.components.length > 0) {
        item.components.forEach((item1, index1) => {
          var subRiskName = item1.subRisk.trim();
          if (item1.subSubRisks != undefined && item1.subSubRisks != null && item1.subSubRisks.length > 0) {
            var subSubRiskStr = "";
            item1.subSubRisks.forEach((item2, index2) => {
              var subSubRiskName = item2.subSubRiskName.trim();
              if (index2 === 0) {
                subSubRiskStr += "'" + subSubRiskName + "'";
              } else {
                subSubRiskStr += ", '" + subSubRiskName + "'";
              }
            })
            if (subSubRiskStr != "") {
              subSubRiskStr += " in to " + "'" + subRiskName + "'";
              if (subSubRiskMainStr === '') {
                subSubRiskMainStr += subSubRiskStr;
              } else {
                subSubRiskMainStr += " and " + subSubRiskStr;
              }
            }
          }
        })
      }
    });
    return subSubRiskMainStr;

  }

  function getSubSubRiskMainStrWithCount(jsonObj) {
    var subSubRiskMainStr = "";
    var firstTime = true
    jsonObj.objectives.forEach((item, index) => {
      if (item.components != undefined && item.components != null && item.components.length > 0) {
        item.components.forEach((item1, index1) => {
          if (item1.subSubRisks != undefined && item1.subSubRisks != null && item1.subSubRisks.length > 0) {
            item1.subSubRisks.forEach((item2, index2) => {
              var subSubRiskName = item2.subSubRiskName.trim();
              if (firstTime) {
                firstTime = false;
                subSubRiskMainStr += (index + 1) + "." + (index1 + 1) + "." + (index2 + 1) + ") " + subSubRiskName + "";
              } else {
                subSubRiskMainStr += ", " + (index + 1) + "." + (index1 + 1) + "." + (index2 + 1) + ") " + subSubRiskName + "";
              }
            })
          }
        })
      }
    });
    return subSubRiskMainStr;

  }



  function createString(jsonObj, subRiskFound, subSubRiskFound) {

    var selectedJson = "";
    allAvailableRiskSchemas.forEach((xx1, indexXX) => {
      if (xx1.id === schemaName){
        var tSchema = xx1.schemaFormat;
        tSchema = tSchema.replaceAll('\t', " ");
        selectedJson = tSchema;
      }
    })



    if (!subRiskFound) {
      var str = "";
      str += "Based on the above research and Using this json schema\n";
      str += selectedJson;
      //str += "{\n     '$schema':'http://json-schema.org/draft-07/schema#',\n     'type':'object',\n     'properties':{\n        'objectives':{\n           'type':'array',\n           'items':{\n              'type':'object',\n              'properties':{\n                 'objectiveName':{\n                    'type':'string'\n                 },\n                 'mainRisk':{\n                    'type':'string'\n                 },\n                 'components':{\n                    'type':'array',\n                    'items':{\n                       'type':'object',\n                       'properties':{\n                          'componentName':{\n                             'type':'string'\n                          },\n                          'subRisk':{\n                             'type':'string'\n                          },\n                          'subSubRisks':{\n                             'type':'array',\n                             'items':{\n                                'type':'object',\n                                'properties':{\n                                   'principleName':{\n                                      'type':'string'\n                                   },\n                                   'principleNumber':{\n                                      'type':'integer'\n                                   },\n                                   'subSubRiskName':{\n                                      'type':'string'\n                                   },\n                                   'likelihood':{\n                                      'type':'integer',\n                                      'minimum':1,\n                                      'maximum':5\n                                   },\n                                   'impact':{\n                                      'type':'integer',\n                                      'minimum':1,\n                                      'maximum':5\n                                   },\n                                   'question':{\n                                      'type':'string'\n                                   },\n                                   'yesScore':{\n                                      'type':'integer',\n                                      'minimum':1,\n                                      'maximum':5\n                                   },\n                                   'noScore':{\n                                      'type':'integer',\n                                      'minimum':1,\n                                      'maximum':5\n                                   }\n                                },\n                                'required':[\n                                   'principleName',\n                                   'principleNumber',\n                                   'subSubRiskName',\n                                   'likelihood',\n                                   'impact',\n                                   'question',\n                                   'yesScore',\n                                   'noScore'\n                                ]\n                             }\n                          }\n                       },\n                       'required':[\n                          'componentName',\n                          'subRisk',\n                          'subSubRisks'\n                       ]\n                    }\n                 }\n              },\n              'required':[\n                 'objectiveName',\n                 'mainRisk',\n                 'components'\n              ]\n           }\n        }\n     },\n     'required':[\n        'objectives'\n     ]\n  }\n";
      str += "\nCan you Create a json object only to show the following.\n";
      str += "The main Risk is the ";
      str += hierarchyName + " ";
      str += "in an organization that conducts a ";
      str += createdRegisterDescription + ". ";
      str += "I want to create ";
      str += getMainRiskCount(jsonObj) + " ";
      str += "mainRisks for the ";
      str += getMainRiskCount(jsonObj) + " ";
      //str += "three" + " ";
      // str += "Objectives of the Coso 2017 standard namely ";
      str += "Objectives of the " + globalStandardDataForObjective + " standard namely ";
      str += getMainRiskTopStrWithCount(jsonObj) + ". ";
      //str += "1) Operations 2) Reporting 3) Compliance" + ". ";
      str += "I then want to Create 1 subRisk for each " + globalStandardDataForComponent + " Component ";
      str += "that is relevant for each " + globalStandardDataForObjective + " Objective and create subSubRisks ";
      str += "for the exact " + globalStandardDataForPrinciple + " Principle that is relevant to each " + globalStandardDataForComponent + " Component. ";
      str += "When listing Please name the " + globalStandardDataForObjective + " objective and " + globalStandardDataForComponent + " component against the mainRisks only ";
      str += "and name the " + globalStandardDataForPrinciple + " Principle and the actual Principle number against each subSubRisk. ";
      str += "You must adhere to the rule that one or many of the 16 principles are directly related to one component. ";
      str += "The mainRisks are ";
      str += getMainRiskTopStrWithCount(jsonObj) + ". ";
      str += "Use Realistic examples for subRisks . ";
      str += "Use Realistic examples for subSubRisks. ";
      str += "Any examples provided should be realistic representations of potential risks that an organization conducting logistics services might encounter. \n";
      str += "Please return only the JSON object and do not return Json schema or any other wordings."
      return str;
    } else {
      if (!subSubRiskFound) {
        var str = "";
        str += "Based on the above research and Using this json schema\n";
        str += selectedJson;
        //str += "{\n     '$schema':'http://json-schema.org/draft-07/schema#',\n     'type':'object',\n     'properties':{\n        'objectives':{\n           'type':'array',\n           'items':{\n              'type':'object',\n              'properties':{\n                 'objectiveName':{\n                    'type':'string'\n                 },\n                 'mainRisk':{\n                    'type':'string'\n                 },\n                 'components':{\n                    'type':'array',\n                    'items':{\n                       'type':'object',\n                       'properties':{\n                          'componentName':{\n                             'type':'string'\n                          },\n                          'subRisk':{\n                             'type':'string'\n                          },\n                          'subSubRisks':{\n                             'type':'array',\n                             'items':{\n                                'type':'object',\n                                'properties':{\n                                   'principleName':{\n                                      'type':'string'\n                                   },\n                                   'principleNumber':{\n                                      'type':'integer'\n                                   },\n                                   'subSubRiskName':{\n                                      'type':'string'\n                                   },\n                                   'likelihood':{\n                                      'type':'integer',\n                                      'minimum':1,\n                                      'maximum':5\n                                   },\n                                   'impact':{\n                                      'type':'integer',\n                                      'minimum':1,\n                                      'maximum':5\n                                   },\n                                   'question':{\n                                      'type':'string'\n                                   },\n                                   'yesScore':{\n                                      'type':'integer',\n                                      'minimum':1,\n                                      'maximum':5\n                                   },\n                                   'noScore':{\n                                      'type':'integer',\n                                      'minimum':1,\n                                      'maximum':5\n                                   }\n                                },\n                                'required':[\n                                   'principleName',\n                                   'principleNumber',\n                                   'subSubRiskName',\n                                   'likelihood',\n                                   'impact',\n                                   'question',\n                                   'yesScore',\n                                   'noScore'\n                                ]\n                             }\n                          }\n                       },\n                       'required':[\n                          'componentName',\n                          'subRisk',\n                          'subSubRisks'\n                       ]\n                    }\n                 }\n              },\n              'required':[\n                 'objectiveName',\n                 'mainRisk',\n                 'components'\n              ]\n           }\n        }\n     },\n     'required':[\n        'objectives'\n     ]\n  }\n";
        str += "\nCan you Create a json object only to show the following.\n";
        str += "The main Risk is the ";
        str += hierarchyName + " ";
        str += "in an organization that conducts a ";
        str += createdRegisterDescription + ". ";
        str += "I want to create ";
        str += getMainRiskCount(jsonObj) + " ";
        str += "mainRisks for the ";
        str += getMainRiskCount(jsonObj) + " ";
        //str += "three" + " ";
        // str += "Objectives of the Coso 2017 standard namely ";
        str += "Objectives of the " + globalStandardDataForObjective + " standard namely ";
        str += getMainRiskTopStrWithCount(jsonObj) + ". ";
        //str += "1) Operations 2) Reporting 3) Compliance" + ". ";
        str += "I then want to Create subRisks for each " + globalStandardDataForComponent + " Component that is relevant for each " + globalStandardDataForObjective + " Objective as ";
        str += getSubRiskMainStrWithCount(jsonObj) + " ";
        str += "and create subSubRisks for the exact " + globalStandardDataForPrinciple + " Principle that is relevant to each " + globalStandardDataForComponent + " Component. ";
        str += "When listing Please name the " + globalStandardDataForObjective + " Objects and " + globalStandardDataForComponent + " Components against the mainRisks only and name the " + globalStandardDataForPrinciple + " Principle and the actual Principle number against each subSubRisk. ";
        str += "You must adhere to the rule that one or many of the 16 principles are directly related to one component. ";
        str += "The mainRisks are ";
        str += getMainRiskTopStrWithCount(jsonObj) + ". ";
        str += "Use Realistic examples for subRisks. ";
        str += "Use Realistic examples for subSubRisks. ";
        str += "Any examples provided should be realistic representations of potential risks that an organization conducting logistics services might encounter.\n";
        str += "Please return only the JSON object and do not return Json schema or any other wordings."
        return str;
      } else {
        var str = "";
        str += "Based on the above research and Using this json schema\n";
        str += selectedJson;
        //str += "{\n     '$schema':'http://json-schema.org/draft-07/schema#',\n     'type':'object',\n     'properties':{\n        'objectives':{\n           'type':'array',\n           'items':{\n              'type':'object',\n              'properties':{\n                 'objectiveName':{\n                    'type':'string'\n                 },\n                 'mainRisk':{\n                    'type':'string'\n                 },\n                 'components':{\n                    'type':'array',\n                    'items':{\n                       'type':'object',\n                       'properties':{\n                          'componentName':{\n                             'type':'string'\n                          },\n                          'subRisk':{\n                             'type':'string'\n                          },\n                          'subSubRisks':{\n                             'type':'array',\n                             'items':{\n                                'type':'object',\n                                'properties':{\n                                   'principleName':{\n                                      'type':'string'\n                                   },\n                                   'principleNumber':{\n                                      'type':'integer'\n                                   },\n                                   'subSubRiskName':{\n                                      'type':'string'\n                                   },\n                                   'likelihood':{\n                                      'type':'integer',\n                                      'minimum':1,\n                                      'maximum':5\n                                   },\n                                   'impact':{\n                                      'type':'integer',\n                                      'minimum':1,\n                                      'maximum':5\n                                   },\n                                   'question':{\n                                      'type':'string'\n                                   },\n                                   'yesScore':{\n                                      'type':'integer',\n                                      'minimum':1,\n                                      'maximum':5\n                                   },\n                                   'noScore':{\n                                      'type':'integer',\n                                      'minimum':1,\n                                      'maximum':5\n                                   }\n                                },\n                                'required':[\n                                   'principleName',\n                                   'principleNumber',\n                                   'subSubRiskName',\n                                   'likelihood',\n                                   'impact',\n                                   'question',\n                                   'yesScore',\n                                   'noScore'\n                                ]\n                             }\n                          }\n                       },\n                       'required':[\n                          'componentName',\n                          'subRisk',\n                          'subSubRisks'\n                       ]\n                    }\n                 }\n              },\n              'required':[\n                 'objectiveName',\n                 'mainRisk',\n                 'components'\n              ]\n           }\n        }\n     },\n     'required':[\n        'objectives'\n     ]\n  }\n";
        str += "\nCan you Create a json object only to show the following.\n";
        str += "The main Risk is the ";
        str += hierarchyName + " ";
        str += "in an organization that conducts a ";
        str += createdRegisterDescription + ". ";
        str += "I want to create ";
        str += getMainRiskCount(jsonObj) + " ";
        str += "mainRisks for the ";
        str += getMainRiskCount(jsonObj) + " ";
        //str += "three" + " ";
        str += "Objectives of the " + globalStandardDataForObjective + " standard namely ";
        str += getMainRiskTopStrWithCount(jsonObj) + ". ";
        //str += "1) Operations 2) Reporting 3) Compliance" + ". ";
        str += "I then want to Create subRisks for each " + globalStandardDataForComponent + " Component that is relevant for each " + globalStandardDataForObjective + " Objective as ";
        str += getSubRiskMainStrWithCount(jsonObj) + " ";
        str += "and create subSubRisks for the exact " + globalStandardDataForPrinciple + " Principle that is relevant to each " + globalStandardDataForComponent + " Component as ";
        str += getSubSubRiskMainStrWithCount(jsonObj) + ". ";
        str += "When listing Please name the " + globalStandardDataForObjective + " Objects and " + globalStandardDataForComponent + " Components against the mainRisks only and name the " + globalStandardDataForPrinciple + " Principle and the actual Principle number against each subSubRisk. ";
        str += "You must adhere to the rule that one or many of the 16 principles are directly related to one component. ";
        str += "The mainRisks are ";
        str += getMainRiskTopStrWithCount(jsonObj) + ". ";
        str += "Use Realistic examples for subRisks. ";
        str += "Use Realistic examples for subSubRisks. ";
        str += "Any examples provided should be realistic representations of potential risks that an organization conducting logistics services might encounter.\n";
        str += "Please return only the JSON object and do not return Json schema or any other wordings."
        return str;
      }
    }

    /*
    str = "";
    str += "Using the following schema create a json Object to show the risks for a ";
    str += createdRegisterName;
    str += " associated with mainRisk ";
    str += getMainRiskTopStr(jsonObj) + " ";
    str += "within this risk hierarchy. ";
    str += "So can you list " + getMainRiskCount(jsonObj) + " mainRisk namely " + getMainRiskStr(jsonObj) + " against  the objectives of COSO 2017";
    if (subRiskFound) {
      str += "and subRisk against each components namely ";
      str += getSubRiskMainStr(jsonObj);
      if (subSubRiskFound) {
        str += ", a subSubRiskName, the coso principleName and principleNumber each subSubRisks namely ";
        str += getSubSubRiskMainStr(jsonObj);
      }
    }
    str += ". Dont forget to state the objectiveName against COSO 2017 objectives and the componentName against the COSO 2017 components and principleName against subSubRisks ";
    str += "and organize the output  in the order of mainRisk, subRisk, subSubRisk. ";
    str += "I also want to frame a question against each subSubRisks with a dichotomous ratio scale answer showing scoring numbers Yes = 5 and No = 1 ";
    str += "and return only the JSON object and do not return Json schema : "

    str += "{     '$schema':'http://json-schema.org/draft-07/schema#',     'type':'object',     'properties':{        'objectives':{           'type':'array',           'items':{              'type':'object',              'properties':{                 'objectiveName':{                    'type':'string'                 },                 'mainRisk':{                    'type':'string'                 },                 'components':{                    'type':'array',                    'items':{                       'type':'object',                       'properties':{                          'componentName':{                             'type':'string'                          },                          'subRisk':{                             'type':'string'                          },                          'subSubRisks':{                             'type':'array',                             'items':{                                'type':'object',                                'properties':{                                   'principleName':{                                      'type':'string'                                   },                                   'principleNumber':{                                      'type':'integer'                                   },                                   'subSubRiskName':{                                      'type':'string'                                   },                                   'likelihood':{                                      'type':'integer',                                      'minimum':1,                                      'maximum':5                                   },                                   'impact':{                                      'type':'integer',                                      'minimum':1,                                      'maximum':5                                   },                                   'question':{                                      'type':'string'                                   },                                   'yesScore':{                                      'type':'integer',                                      'minimum':1,                                      'maximum':5                                   },                                   'noScore':{                                      'type':'integer',                                      'minimum':1,                                      'maximum':5                                   }                                },                                'required':[                                   'principleName',                                   'principleNumber',                                   'subSubRiskName',                                   'likelihood',                                   'impact',                                   'question',                                   'yesScore',                                   'noScore'                                ]                             }                          }                       },                       'required':[                          'componentName',                          'subRisk',                          'subSubRisks'                       ]                    }                 }              },              'required':[                 'objectiveName',                 'mainRisk',                 'components'              ]           }        }     },     'required':[        'objectives'     ]  }";
    */


  }



  const [finalHJson, setFinalHJson] = React.useState('')

  function finishSubSubRisk() {
    blinkText(voice12);
    setStep6(true);
    console.log(registerArray)

    var objQa = {}
    var arrQa = qaArray;
    objQa["q"] = "Enter a reference number for this GPT Session and Press \"Create Risk Hierarchy\".";

    setVoice(voice12);

    arrQa.push(objQa)
    setQaArray(arrQa)
    setDivHeight('300');

    setTimeout(() => {
      if (scrollRef.current) {
        scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
      }
      if (scrollRef1.current) {
        scrollRef1.current.scrollTop = scrollRef1.current.scrollHeight;
      }

    }, 100);

    var hObj = {};
    hObj["objectives"] = hierarchyArray
    var jsonStr = JSON.stringify(hObj)
    setFinalHJson(jsonStr)

  }

  const [riskTypeDataForEval, setRiskTypeDataForEval] = React.useState({});
  const [createdRiskId, setCreatedRiskId] = React.useState('');
  const [selectedRiskEvaluateTitle, setSelectedRiskEvaluateTitle] = React.useState('');
  const [editRiskOrRegister, setEditRiskOrRegister] = React.useState('Edit');
  const [savedQuestionArray, setSavedQuestionArray] = React.useState([]);


  function sendToDataBaseH() {

    if (globalStandardDataForObjective === '') {
      alert("please select standard for objective")
      return;
    }

    if (globalStandardDataForComponent === '') {
      alert("please select standard for component")
      return;
    }

    if (globalStandardDataForPrinciple === '') {
      alert("please select standard for principle")
      return;
    }
    if (schemaName === ''){
        alert("Please select a schema for Risk Hierarchy");
        return;
    }


    setRiskStandardOpen(false)


    var obj = {}
    obj["userId"] = globalCentreId
    obj["createdBy"] = createUser

    var questionStr = "";
    var objArr = [];
    var riskStr = "";


    var jsonObj = JSON.parse(finalHJson);

    var mainRiskStr = "";
    var mainRiskTopStr = "";
    var mainRiskCount = 0;
    var subRiskFound = false;
    var subSubRiskFound = false;
    var subRiskMainStr = "";
    var subSubRiskMainStr = "";

    var mainRiskStrWithCount = "";
    var subRiskMainStrWithCount = "";
    var subSubRiskMainStrWithCount = "";

    jsonObj.objectives.forEach((item, index) => {
      var mainRiskName = item.mainRisk.trim();

      if (index === 0) {
        mainRiskTopStr += "'" + mainRiskName + "'";
        mainRiskStr += "'" + mainRiskName + "'";
        mainRiskStrWithCount += (index + 1) + ") " + mainRiskName;
      } else {
        mainRiskStrWithCount += ", " + (index + 1) + ") " + mainRiskName;
        if (jsonObj.objectives.length - 1 === index) {
          mainRiskTopStr += " and '" + mainRiskName + "'";
          mainRiskStr += " and '" + mainRiskName + "'";
        } else {
          mainRiskTopStr += " ,'" + mainRiskName + "'";
          mainRiskStr += " ,'" + mainRiskName + "'";
        }
      }
      mainRiskCount++;
      if (item.components != undefined && item.components != null && item.components.length > 0) {
        subRiskFound = true;
        var subRiskStr = "";
        item.components.forEach((item1, index1) => {
          var subRiskName = item1.subRisk.trim();
          if (index1 === 0) {
            subRiskStr += "'" + subRiskName + "'";
            subRiskMainStrWithCount += (index + 1) + "." + (index1 + 1) + ") " + subRiskName;
          } else {
            subRiskStr += ", '" + subRiskName + "'";
            subRiskMainStrWithCount += ", " + (index + 1) + "." + (index1 + 1) + ") " + subRiskName;
          }
          if (item1.subSubRisks != undefined && item1.subSubRisks != null && item1.subSubRisks.length > 0) {
            subSubRiskFound = true;
            var subSubRiskStr = "";
            item1.subSubRisks.forEach((item2, index2) => {
              var subSubRiskName = item2.subSubRiskName.trim();
              if (index2 === 0) {
                subSubRiskStr += "'" + subSubRiskName + "'";
                subSubRiskMainStrWithCount += (index + 1) + "." + (index1 + 1) + "." + (index2 + 1) + ") " + subSubRiskName;
              } else {
                subSubRiskStr += ", '" + subSubRiskName + "'";
                subSubRiskMainStrWithCount += ", " + (index + 1) + "." + (index1 + 1) + "." + (index2 + 1) + ") " + subSubRiskName;
              }
            })
            if (subSubRiskStr != "") {
              subSubRiskStr += " in to " + "'" + subRiskName + "'";
              if (subSubRiskMainStr === '') {
                subSubRiskMainStr += subSubRiskStr;
              } else {
                subSubRiskMainStr += " and " + subSubRiskStr;
              }
            }
            if (subSubRiskMainStrWithCount != "") {
              subSubRiskMainStrWithCount += " in to " + "'" + subRiskName + "' ";
            }


          }

        })
        if (subRiskStr != "") {
          subRiskStr += " in to " + "'" + mainRiskName + "'";
          if (subRiskMainStr === '') {
            subRiskMainStr += subRiskStr;
          } else {
            subRiskMainStr += " and " + subRiskStr;
          }
        } else {
          subRiskStr += "'" + mainRiskName + "'" + " has no subRisk ";
          if (subRiskMainStr === '') {
            subRiskMainStr += subRiskStr;
          } else {
            subRiskMainStr += " and " + subRiskStr;
          }
        }
        if (subRiskMainStrWithCount != "") {
          subRiskMainStrWithCount += " in to " + "'" + mainRiskName + "' ";
        }


      }
    });


    questionStr += createString(jsonObj, subRiskFound, subSubRiskFound);

    /** For testing 
    if (questionStr != ''){
      alert(questionStr);
      return;
    }
    **/



    /*
    questionStr += "Using the following schema create a json Object to show the risks for a ";
    questionStr += createdRegisterName;
    questionStr += " associated with mainRisk ";
    questionStr += mainRiskTopStr + " ";
    questionStr += "within this risk hierarchy. ";
    questionStr += "So can you list " + mainRiskCount + " mainRisk namely " + mainRiskStr + " against  the objectives of COSO 2017";
    if (subRiskFound) {
      questionStr += "and subRisk against each components namely ";
      questionStr += subRiskMainStr;
      if (subSubRiskFound) {
        questionStr += ", a subSubRiskName, the coso principleName and principleNumber each subSubRisks namely ";
        questionStr += subSubRiskMainStr
      }
    }

    questionStr += ". Dont forget to state the objectiveName against COSO 2017 objectives and the componentName against the COSO 2017 components and principleName against subSubRisks ";
    questionStr += "and organize the output  in the order of mainRisk, subRisk, subSubRisk. ";
    questionStr += "I also want to frame a question against each subSubRisks with a dichotomous ratio scale answer showing scoring numbers Yes = 5 and No = 1 ";
    questionStr += "and return only the JSON object and do not return Json schema : "

    */



    /** 1111111 
    questionStr += "Using the following json schema create a complete json document with proper sample data of the incomplete json document.";
    questionStr += " Here is the incomplete JSON document : "; 
    questionStr += finalHJson.replaceAll("\"", "'");
    questionStr += ". Dont forget to state the objectiveName against COSO 2017 objectives and the componentName against the COSO 2017 components and principleName against subSubRisks ";
    questionStr += "and organize the output  in the order of mainRisk, subRisk, subSubRisk. ";
    questionStr += "I also want to frame a question against each subSubRisks with a dichotomous ratio scale answer showing scoring numbers Yes = 5 and No = 1 ";
    questionStr += "and return only the JSON object and do not return Json schema. Here is the JSON schema : "
    */

    /** 22222 
    questionStr += "Using the following schema I want to analyse the risks associated with the ";
    questionStr += mainRiskTopStr + "";
    questionStr += " element of ";
    if (hierarchyName.substr(0, 1).toUpperCase() === "A" || hierarchyName.substr(0, 1).toUpperCase() === "E" || hierarchyName.substr(0, 1).toUpperCase() === "I" || hierarchyName.substr(0, 1).toUpperCase() === "O" || hierarchyName.substr(0, 1).toUpperCase() === "U"){
      questionStr += "an ";
    }else{
      questionStr += "a ";
    }
    questionStr += hierarchyName + ".";
    questionStr += " So can you list  5 Main_risks against the three objective of COSO2017 and 1 sub_risks against each ";
    questionStr += "Coso component and a Sub_sub-Risk and indicate the coso principle and its number against ";
    questionStr += "each Sub_sub_risk. Dont forget to state the objective and the component against the Main_risk only ";
    questionStr += "and organize the output in the order of Main-risk, sub-risk, sub-sub-risk. ";
    questionStr += "I also want to frame a question against each sub-sub-risk with a dichotomous ratio scale answer showing scoring numbers Yes = 5 and No = 1 ";
    questionStr += "and return as the JSON object only. Please do not return the JSON schema."
    questionStr += ": "
    */

    /** 3333
    questionStr += "Using the following json schema create a complete json document of ";
    if (hierarchyName.substr(0, 1).toUpperCase() === "A" || hierarchyName.substr(0, 1).toUpperCase() === "E" || hierarchyName.substr(0, 1).toUpperCase() === "I" || hierarchyName.substr(0, 1).toUpperCase() === "O" || hierarchyName.substr(0, 1).toUpperCase() === "U"){
      questionStr += "an ";
    }else{
      questionStr += "a ";
    }
    questionStr += hierarchyName + " ";
    questionStr += "with proper sample data including objective of COSO2017 "
    questionStr += "and sub_risks against each Coso component and Sub_sub-Risk and indicate the coso principle "
    questionStr += "and its number against each Sub_sub_risk. Dont forget to state the objective and the component against the Main_risk only and organize the output in the order of Main-risk, sub-risk, sub-sub-risk. I also want to frame a question against each sub-sub-risk with a dichotomous ratio scale answer showing scoring numbers Yes = 5 and No = 1 ";
    questionStr += " and return the output as a JSON object only : ";
    questionStr += "This is the incomplete json document : ";
    questionStr += finalHJson.replaceAll("\"", "'");
    questionStr += ". This is the json Schema : ";
    */

    /*
    questionStr += "{     '$schema':'http://json-schema.org/draft-07/schema#',     'type':'object',     'properties':{        'objectives':{           'type':'array',           'items':{              'type':'object',              'properties':{                 'objectiveName':{                    'type':'string'                 },                 'mainRisk':{                    'type':'string'                 },                 'components':{                    'type':'array',                    'items':{                       'type':'object',                       'properties':{                          'componentName':{                             'type':'string'                          },                          'subRisk':{                             'type':'string'                          },                          'subSubRisks':{                             'type':'array',                             'items':{                                'type':'object',                                'properties':{                                   'principleName':{                                      'type':'string'                                   },                                   'principleNumber':{                                      'type':'integer'                                   },                                   'subSubRiskName':{                                      'type':'string'                                   },                                   'likelihood':{                                      'type':'integer',                                      'minimum':1,                                      'maximum':5                                   },                                   'impact':{                                      'type':'integer',                                      'minimum':1,                                      'maximum':5                                   },                                   'question':{                                      'type':'string'                                   },                                   'yesScore':{                                      'type':'integer',                                      'minimum':1,                                      'maximum':5                                   },                                   'noScore':{                                      'type':'integer',                                      'minimum':1,                                      'maximum':5                                   }                                },                                'required':[                                   'principleName',                                   'principleNumber',                                   'subSubRiskName',                                   'likelihood',                                   'impact',                                   'question',                                   'yesScore',                                   'noScore'                                ]                             }                          }                       },                       'required':[                          'componentName',                          'subRisk',                          'subSubRisks'                       ]                    }                 }              },              'required':[                 'objectiveName',                 'mainRisk',                 'components'              ]           }        }     },     'required':[        'objectives'     ]  }";
    */

    var obj1 = {}
    obj1["messageId"] = questionId;
    obj1["message"] = questionStr;
    objArr.push(obj1);
    obj["chats"] = objArr
    console.log(obj)
    var sendJson = JSON.stringify(obj)

    console.log(sendJson)

    setLoading(true);


    axios(CONFIG.MAIN_URL + '/openai/chat', {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      data: sendJson,
    })
      .then(function (response) {
        console.log("+++++++++++++JSON.stringify(response.data)+++++++++++++");
        console.log(JSON.stringify(response.data));
        var schemaStr = JSON.stringify(response.data)
        var schemaObj = JSON.parse(schemaStr);
        setHierarchyResearch(false)

        setQuestiomRes(JSON.stringify(schemaObj, null, "\t"));
        console.log(response.data)

        var dataStr = "";
        schemaObj.messages.map((item, index) => {
          if (index === schemaObj.messages.length - 1) {
            item.answers.map((data, index) => {
              if (data.messageId === questionId) {
                dataStr = data.answer;
                dataStr = dataStr.replaceAll("\n", "");
                dataStr = dataStr.replaceAll("```json", "");
                dataStr = dataStr.replaceAll("```", "");
              }
            })
          }
        })

        try {
          var jObj = JSON.parse(dataStr);
          console.log(jObj);

          var tmpName = hierarchyName;
          var riskLikelihood = "1";
          var riskImpact = "1";
          var riskLevel = 1;
          var riskAppetite = "1";
          var riskObj = {};
          var today = new Date();
          var curDateTime = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate() + " " + today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();

          riskObj["name"] = tmpName;
          riskObj["key"] = hierarchyKey;
          riskObj["centreId"] = globalCentreId;
          riskObj["riskLikelihood"] = riskLikelihood;
          riskObj["riskImpact"] = riskImpact;
          riskObj["riskLevel"] = riskLevel;
          riskObj["riskAppetite"] = riskAppetite;
          var riskCount = 1;

          if (jObj.objectives != undefined && jObj.objectives != null && jObj.objectives.length > 0) {
            var mainArr = [];
            jObj.objectives.forEach((data) => {
              var tmpObj1 = {};
              tmpObj1["riskTypeTmpId"] = riskCount;
              riskCount++;
              tmpObj1["name"] = data.mainRisk;
              if (data.riskDescription != undefined && data.riskDescription != null) {
                tmpObj1["riskDescription"] = data.riskDescription;
              }
              if (data.impactDescription != undefined && data.impactDescription != null) {
                tmpObj1["impactDescription"] = data.impactDescription;
              }
              if (data.mitigation != undefined && data.mitigation != null) {
                tmpObj1["mitigation"] = data.mitigation;
              }
              tmpObj1["riskLikelihood"] = riskLikelihood;
              tmpObj1["riskImpact"] = riskImpact;
              tmpObj1["riskLevel"] = riskLevel;
              tmpObj1["riskAppetite"] = riskAppetite;
              var tmpObj2 = {};
              tmpObj2["riskLikelihood"] = riskLikelihood;
              tmpObj2["riskImpact"] = riskImpact;
              tmpObj2["riskLevel"] = riskLevel;
              tmpObj1["riskLevelData"] = tmpObj2;
              tmpObj1["riskAppetite"] = riskAppetite;
              var tmpObj3 = {};
              tmpObj3["riskAppetite"] = riskAppetite;
              tmpObj3["secondaryColor"] = "#ffffff";
              tmpObj1["riskAppetiteData"] = tmpObj3;

              var tmpObjObjectiveData = {};
              if (data.objectiveName != undefined && data.objectiveName != null) {
                tmpObjObjectiveData["objectiveName"] = data.objectiveName;
              } else {
                tmpObjObjectiveData["objectiveName"] = '';
              }
              var tmpObjObjectiveDataObj = {};
              tmpObjObjectiveDataObj["objectiveData"] = tmpObjObjectiveData;
              tmpObj1["riskStandardData"] = tmpObjObjectiveDataObj;

              var subArr = [];
              if (data.components != undefined && data.components != null && data.components.length > 0) {
                data.components.forEach((data1) => {
                  var tmpObj4 = {};
                  tmpObj4["riskTypeTmpId"] = riskCount;
                  riskCount++;
                  tmpObj4["name"] = data1.subRisk;
                  
                  if (data1.riskDescription != undefined && data1.riskDescription != null) {
                    tmpObj4["riskDescription"] = data1.riskDescription;
                  }
                  if (data1.impactDescription != undefined && data1.impactDescription != null) {
                    tmpObj4["impactDescription"] = data1.impactDescription;
                  }
                  if (data1.mitigation != undefined && data1.mitigation != null) {
                    tmpObj4["mitigation"] = data1.mitigation;
                  }

                  tmpObj4["riskLikelihood"] = riskLikelihood;
                  tmpObj4["riskImpact"] = riskImpact;
                  tmpObj4["riskLevel"] = riskLevel;
                  tmpObj4["riskAppetite"] = riskAppetite;
                  var tmpObj5 = {};
                  tmpObj5["riskLikelihood"] = riskLikelihood;
                  tmpObj5["riskImpact"] = riskImpact;
                  tmpObj5["riskLevel"] = riskLevel;
                  tmpObj4["riskLevelData"] = tmpObj5;
                  tmpObj4["riskAppetite"] = riskAppetite;
                  var tmpObj6 = {};
                  tmpObj6["riskAppetite"] = riskAppetite;
                  tmpObj6["secondaryColor"] = "#ffffff";
                  tmpObj4["riskAppetiteData"] = tmpObj6;
                  var tmpComponentData = {};
                  if (data1.componentName != undefined && data1.componentName != null) {
                    tmpComponentData["componentName"] = data1.componentName;
                  } else {
                    tmpComponentData["componentName"] = "";
                  }
                  var tmpComponentDataObj = {};
                  tmpComponentDataObj["componentData"] = tmpComponentData;
                  tmpObj4["riskStandardData"] = tmpComponentDataObj;

                  if (data1.subSubRisks != undefined && data1.subSubRisks != null && data1.subSubRisks.length > 0) {
                    var subSubArr = [];
                    data1.subSubRisks.forEach((data2) => {
                      var tmpObj7 = {};
                      tmpObj7["riskTypeTmpId"] = riskCount;
                      riskCount++;
                      tmpObj7["name"] = data2.subSubRiskName;

                      if (data2.riskDescription != undefined && data2.riskDescription != null) {
                        tmpObj7["riskDescription"] = data2.riskDescription;
                      }
                      if (data2.impactDescription != undefined && data2.impactDescription != null) {
                        tmpObj7["impactDescription"] = data2.impactDescription;
                      }
                      if (data2.mitigation != undefined && data2.mitigation != null) {
                        tmpObj7["mitigation"] = data2.mitigation;
                      }

                      var riskLikelihoodStr = ""
                      var riskLevelAmt = 1;
                      if (data2.likelihood != undefined && data2.likelihood != null) {
                        riskLikelihoodStr = data2.likelihood.toString();
                        riskLevelAmt = parseInt(data2.likelihood);
                      } else {
                        riskLikelihoodStr = riskLikelihood;
                      }
                      var riskImpactStr = ""
                      if (data2.impact != undefined && data2.impact != null) {
                        riskImpactStr = data2.impact.toString();
                        riskLevelAmt = riskLevelAmt * (parseInt(data2.impact));
                      } else {
                        riskImpactStr = riskImpact;
                      }

                      tmpObj7["riskLikelihood"] = riskLikelihoodStr;
                      tmpObj7["riskImpact"] = riskImpactStr;
                      tmpObj7["riskLevel"] = riskLevelAmt;
                      tmpObj7["riskAppetite"] = riskAppetite;
                      var tmpObj8 = {};
                      tmpObj8["riskLikelihood"] = riskLikelihoodStr;
                      tmpObj8["riskImpact"] = riskImpactStr;
                      tmpObj8["riskLevel"] = riskLevelAmt;
                      tmpObj7["riskLevelData"] = tmpObj8;
                      tmpObj7["riskAppetite"] = riskAppetite;
                      var tmpObj9 = {};
                      tmpObj9["riskAppetite"] = riskAppetite;
                      tmpObj9["secondaryColor"] = "#ffffff";
                      tmpObj7["riskAppetiteData"] = tmpObj9;

                      var tmpPrincipleData = {};
                      if (data2.principleName != undefined && data2.principleName != null) {
                        tmpPrincipleData["principleName"] = data2.principleName;
                      } else {
                        tmpPrincipleData["principleName"] = "";
                      }
                      if (data2.principleNumber != undefined && data2.principleNumber != null) {
                        tmpPrincipleData["principleNumber"] = data2.principleNumber;
                      } else {
                        tmpPrincipleData["principleNumber"] = "";
                      }

                      var tmpPrincipleDataObj = {};
                      tmpPrincipleDataObj["principleData"] = tmpPrincipleData;
                      tmpObj7["riskStandardData"] = tmpPrincipleDataObj;

                      subSubArr.push(tmpObj7);
                    })
                    tmpObj4["subRisks"] = subSubArr;
                  }
                  subArr.push(tmpObj4);
                })
                tmpObj1["subRisks"] = subArr;
              }
              mainArr.push(tmpObj1);
            })
            riskObj["riskTypes"] = mainArr;

            console.log(riskObj);

            var data = JSON.stringify(riskObj);
            console.log(data);

            axios(CONFIG.MAIN_URL + '/risk/save', {
              method: 'post',
              headers: {
                'Content-Type': 'application/json',
              },
              data: data,
            })
              .then(function (response) {

                console.log(response.data);
                setRiskTypeDataForEval(response.data);
                setCreatedRiskId(response.data.riskId);
                var createdRiskHierarchyIdFromComp = response.data.riskId;

                setCreatedRiskHierarchyId(response.data.riskId)

                setSelectedRiskEvaluateTitle(response.data.name);
                setEditRiskOrRegister('Edit Risk');

                setCreatedHierachy(true)

                updateQuestionTemplate(jObj, response.data, response.data.riskId)
                console.log(questionArray);

                if (questionArray != undefined && questionArray != null && questionArray.length > 0) {
                  var sendArr = [];
                  var randomNo = Math.floor(1000 + Math.random() * 9000);
                  questionArray.forEach((arrayData) => {
                    var tObj = {};
                    tObj["entityId"] = randomNo;
                    tObj["name"] = selectedEntityName;
                    arrayData["entity"] = tObj;
                    sendArr.push(arrayData);
                  })
                  var myJSON = JSON.stringify(sendArr);
                  console.log("+++++++++++++++++++************myJSON*****************++++++++++++++++++++++");
                  console.log(myJSON);
                  var saveUrl = CONFIG.MAIN_URL + '/question/savequestionlist';
                  axios(saveUrl, {
                    method: 'post',
                    headers: {
                      'Content-Type': 'application/json',
                    },
                    data: myJSON,
                  })
                    .then(function (resp) {
                      console.log("++++++++++++++Question Save Return++++++++++");
                      console.log(resp.data);
                      console.log(JSON.stringify(resp.data));
                      setSavedQuestionArray(resp.data)

                    })
                    .catch(function (error) {
                      console.log(error);
                    });

                } else {
                }


                if (createdRiskHierarchyIdFromComp != '') {
                  var assignedRiskId = createdRiskHierarchyIdFromComp;
                  axios(CONFIG.MAIN_URL + `/risk/all`, {
                    method: 'get',
                    headers: {
                      'Content-Type': 'text/plain',
                    },
                  })
                    .then(function (res) {
                      console.log("All Risk Returns");
                      console.log(res.data);
                      var arr = [];
                      res.data.forEach((item) => {
                        if (globalCentreId === item.centreId) {
                          arr.push(item);
                        }
                      })


                      if (assignedRiskId != undefined && assignedRiskId != null && assignedRiskId != '') {
                        arr.forEach((item) => {
                          if (assignedRiskId === item.riskId) {
                            axios(CONFIG.MAIN_URL + `/register/all`, {
                              method: 'get',
                            })
                              .then(function (response) {
                                console.log("all register");
                                console.log(response.data);
                                response.data.forEach((data) => {
                                  if (data.centreId === globalCentreId && data.id === createdRegisterId) {
                                    var regData = data;
                                    regData.riskRegister.forEach((dataReg, index) => {
                                      if (dataReg.id === selectedSectionId) {
                                        dataReg.risks.forEach((dataRisks, index1) => {
                                          if (dataRisks.id === selectedRiskId) {
                                            dataRisks.riskHierarchy["riskId"] = item.riskId;
                                            dataRisks.riskHierarchy["key"] = item.key;
                                            dataRisks.riskHierarchy["name"] = item.name;
                                            dataRisks.riskHierarchy["riskHierarchyData"] = item;
                                          }
                                        })
                                      }
                                    })

                                    console.log(regData);
                                    console.log(JSON.stringify(regData));
                                    let sendJson = JSON.stringify(regData);
                                    axios(CONFIG.MAIN_URL + '/register/save', {
                                      method: 'post',
                                      headers: {
                                        'Content-Type': 'application/json',
                                      },
                                      data: sendJson,
                                    })
                                      .then(function (resp) {
                                        setLoading(false);
                                        console.log("++++++++++++++++++Register Update Response+++++++++++++++++++");
                                        console.log(resp.data);
                                        let rtnData = resp.data;
                                        setTimeout(() => {
                                          alert("Register Updated successfully with Risk Hierarchy.");
                                        }, 500);

                                        setSelectedRegisteredId(rtnData.id);
                                      })
                                      .catch(function (error) {
                                        setLoading(false);
                                        console.log(error);
                                        alert("Error updating Register -:" + error);
                                      });

                                  }
                                })

                              })
                              .catch(function (error) {
                                console.log(error);
                                setLoading(false);
                              });
                          }
                        })
                      }
                    })
                    .catch(function (error) {
                      console.log(error);
                      setLoading(false);
                    });

                } else {
                  alert("No Risk Hierarchy was created. \nPlease press \"Add Risk Hierarchy\" button again to add risk Hierarchy for " + selectedRegisteredName)
                  setLoading(false);
                }

              })
              .catch(function (error) {
                setLoading(false);
                console.log(error);
                alert("Error saving Risk Type -:" + error);
              });

          } else {
            setLoading(false);
            alert("Something went wrong when creating the Risk Hierarchy. Please presss the 'Create Risk Hierarchy' button again to continue")
          }


        } catch (error) {
          setLoading(false);
          alert("Something went wrong when creating the Risk Hierarchy. Please presss the 'Create Risk Hierarchy' button again to continue")
        }

      })
      .catch(function (error) {
        setLoading(false);
        console.log(error);
        alert("Error saving Question -:" + error);
      });

  }

  const [allAvailableRisk, setAllAvailableRisk] = React.useState([]);
  function getAllRisks(centId) {
    axios(CONFIG.MAIN_URL + `/risk/all`, {
      method: 'get',
      headers: {
        'Content-Type': 'text/plain',
      },
    })
      .then(function (response) {
        console.log("All Risk Returns");
        console.log(response.data);
        var arr = [];
        response.data.forEach((item) => {
          if (centId === item.centreId) {
            arr.push(item);
          }
        })
        setAllAvailableRisk(arr);
        if (createdRiskId != undefined && createdRiskId != null && createdRiskId != '') {
          arr.forEach((item) => {
            if (createdRiskId === item.riskId) {
              setRiskTypeDataForEval(item);
              setSelectedRiskEvaluateTitle(item.name);
            }
          })
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  var questionArray = [];
  function updateQuestionTemplate(sndJson, resJson, riskId) {
    console.log("++++++++++++++++++++++++sndJson++++++++++++++++++++++++++++++")
    console.log(sndJson)
    console.log(resJson)
    console.log(riskId)
    if (sndJson.objectives != undefined && sndJson.objectives != null && sndJson.objectives.length > 0) {
      sndJson.objectives.forEach((data) => {
        if (data.components != undefined && data.components != null && data.components.length > 0) {
          data.components.forEach((data1) => {
            if (data1.subSubRisks != undefined && data1.subSubRisks != null && data1.subSubRisks.length > 0) {
              data1.subSubRisks.forEach((data2) => {
                var objectiveName = data.objectiveName;
                var componentName = data1.componentName;
                var riskName = data2.subSubRiskName;
                var principleName = data2.principleName;
                var principleNumber = data2.principleNumber;
                var question = data2.question;
                var yesScore = data2.yesScore;
                var noScore = data2.noScore;
                resJson.riskTypes.forEach((item) => {
                  if (item.subRisks != undefined && item.subRisks != null && item.subRisks.length > 0) {
                    item.subRisks.forEach((item1) => {
                      if (item1.subRisks != undefined && item1.subRisks != null && item1.subRisks.length > 0) {
                        item1.subRisks.forEach((item2) => {
                          if (item2.name === riskName && item2.riskStandardData.principleData.principleName === principleName) {
                            var obj = {};
                            /** Create Question Object */
                            obj["collectionUniqueName"] = "";
                            obj["centreId"] = globalCentreId;

                            obj["question"] = question;
                            obj["questionType"] = "Closeended";
                            obj["questionTypeName"] = "Nominal";
                            var objSub = {};
                            objSub["status"] = "draft";
                            obj["metaInfo"] = objSub;
                            objSub = {};
                            objSub["collectionRiskTypeId"] = item2.riskTypeId + "";
                            objSub["collectionRiskId"] = riskId + "";
                            objSub["name"] = item2.name;
                            objSub["riskLikelihood"] = item2.riskLikelihood;
                            objSub["riskImpact"] = item2.riskImpact;
                            objSub["riskLevel"] = item2.riskLevel;
                            objSub["riskAppetite"] = item2.riskAppetite;
                            obj["riskTypes"] = objSub;

                            objSub = {};
                            objSub["id"] = "";
                            objSub["name"] = objectiveName;
                            obj["objective"] = objSub;

                            objSub = {};
                            objSub["id"] = "";
                            objSub["name"] = componentName;
                            obj["component"] = objSub;

                            objSub = {};
                            objSub["id"] = "";
                            objSub["name"] = principleName;

                            objSub["principleNumber"] = principleNumber;
                            obj["principle"] = objSub;

                            objSub = {};
                            var objSubSub = {};
                            objSubSub["name"] = "radioButtonType";
                            objSubSub["minValue"] = "0";
                            objSubSub["maxValue"] = "0";
                            objSub["answerMethod"] = objSubSub;

                            var arryTmp = [];

                            var tmpObjX1 = {};
                            tmpObjX1["riskLevel"] = yesScore;
                            tmpObjX1["riskCategoryId"] = "";
                            tmpObjX1["riskMethodId"] = "";

                            var tmpObjX0 = {};
                            tmpObjX0["answerName"] = "Yes";
                            tmpObjX0["answerType"] = "radioButtonType";
                            tmpObjX0["riskLevel"] = yesScore;
                            tmpObjX0["expectedAnswerName"] = "";
                            tmpObjX0["riskLevelData"] = tmpObjX1;

                            arryTmp.push(tmpObjX0);

                            tmpObjX1 = {};
                            tmpObjX1["riskLevel"] = noScore;
                            tmpObjX1["riskCategoryId"] = "";
                            tmpObjX1["riskMethodId"] = "";

                            tmpObjX0 = {};
                            tmpObjX0["answerName"] = "No";
                            tmpObjX0["answerType"] = "radioButtonType";
                            tmpObjX0["riskLevel"] = noScore;
                            tmpObjX0["expectedAnswerName"] = "";
                            tmpObjX0["riskLevelData"] = tmpObjX1;

                            arryTmp.push(tmpObjX0);

                            objSub["answerList"] = arryTmp;
                            obj["answers"] = objSub;

                            questionArray.push(obj);
                          }
                        })
                      }
                    })
                  }
                })
              })
            }
          })
        }
      })
    }
  }



  function evaluateRiskHFuction() {
    if (createdRiskId === '') {
      alert("No created Risk for evaluation")
      return;
    }
    setRegisterEvaluate(false)
    setRegisterTypeDataForEval(riskTypeDataForEval);
    setSelectedRegisterEvaluateTitle(selectedRiskEvaluateTitle);
    setOpenRegisterDataForEval(true)
    setOpenRegisterDataForEvalScroll('paper');

  }


  const [openRiskDataEdit, setOpenRiskDataEdit] = React.useState(false);
  const [openRiskDataEditScroll, setOpenRiskDataEditScroll] = React.useState('paper');


  function editRiskHFuction() {

    if (createdRiskId === '') {
      alert("No created Risk for Edit")
      return;
    }
    setOpenRiskDataEdit(true);
    setOpenRiskDataEditScroll('paper');

  }

  function setOpenRiskDataEditfunction() {
    setOpenRiskDataEdit(false)
    getAllRisks(globalCentreId);
  }


  function createNextRiskFuction() {
    clearButton();
    setRiskRegsiter(globalCentreId)

  }
  /** Question Show and Edit */
  function PaperComponentAllQuestionData(props) {
    return (
      <Draggable
        handle="#collection-data-dialog-title"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} />
      </Draggable>
    );
  }



  const [rows, setRows] = React.useState([]);
  const [openShowQuestions, setOpenShowQuestions] = React.useState(false);
  const [openShowQuestionsScroll, setOpenShowQuestionsScroll] = React.useState('paper');

  const [arrayForTransferExcel, setArrayForTransferExcel] = React.useState([]);
  const [riskName, setRiskName] = React.useState('');


  function showQuestionFuction() {
    var count = 1;
    var tmpArray = [];
    setRows([]);
    savedQuestionArray.forEach((item) => {
      console.log(item);
      var tmpObj = {};
      tmpObj["questionId"] = item.questionId;
      tmpObj["id"] = count;
      tmpObj["riskName"] = item.riskTypes.name;
      var priNumber = ""
      if (item.principle.principleNumber != undefined && item.principle.principleNumber != null) {
        priNumber = item.principle.principleNumber;
      }
      if (priNumber != '') {
        tmpObj["principalName"] = "Principle " + priNumber + ": " + item.principle.name;
      } else {
        tmpObj["principalName"] = item.principle.name;
      }

      if (item.objective != undefined && item.objective != null) {
        if (item.objective.name != undefined && item.objective.name != null) {
          tmpObj["objectiveName"] = item.objective.name;
        }
      } else {
        tmpObj["objectiveName"] = "";
      }
      if (item.component != undefined && item.component != null) {
        if (item.component.name != undefined && item.component.name != null) {
          tmpObj["componentName"] = item.component.name;
        }
      } else {
        tmpObj["componentName"] = "";
      }
      //tmpObj["objectiveName"] = item.objective.name;
      //tmpObj["componentName"] = item.component.name;
      if (item.entity != undefined && item.entity != null) {
        tmpObj["entityName"] = item.entity.name;
      } else {
        tmpObj["entityName"] = "";
      }
      tmpObj["question"] = item.question;
      tmpObj["questionType"] = item.questionType;
      tmpObj["questionData"] = item;
      tmpArray.push(tmpObj);
      setRiskName(item.riskTypes.name)
      arrayForTransferExcel.push(tmpObj)
      setRows(tmpArray);
      count++;
    })
    setOpenShowQuestions(true);
    setOpenShowQuestionsScroll('paper');
  }

  const [selectedQuesData, setSelectedQuesData] = React.useState([]);
  const [selectedQuestion, setSelectedQuestion] = React.useState('');
  const [quesDataCount, setQuesDataCount] = React.useState(0);
  const [questionDetailOpen, setQuestionDetailOpen] = React.useState(false);
  const [questionDetailScroll, setQuestionDetailScroll] = React.useState('paper');


  function PaperComponent(props) {
    return (
      <Draggable
        handle="#draggable-dialog-title"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} />
      </Draggable>
    );
  }

  const questionDetailHandleClickClose = () => {
    setQuestionDetailOpen(false);
  };


  function parseId(no, questionId, question) {
    var tmpArray = [];
    setQuesDataCount(no);
    setSelectedQuestion(question);
    savedQuestionArray.forEach((item) => {
      if (item.questionId === questionId) {
        tmpArray.push(item);
        setSelectedQuesData(tmpArray);
      }
    });
    setQuestionDetailOpen(true);
    setQuestionDetailScroll('paper');
  }

  const renderDetailsButton = (params) => {
    return (
      <strong>
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={() => {
            parseId(params.row.id, params.row.questionId, params.row.question)
          }}
        >
          More Info
        </Button>
      </strong>
    )
  }

  const renderTextRiskName = (params) => {
    return (
      <Tooltip title={params.row.riskName}>
        <span style={{ fontSize: '10px' }}>{params.row.riskName}</span>
      </Tooltip>
    )
  }
  const renderTextId2 = (params) => {
    return (
      <span >{params.row.id}</span>
    )
  }
  const renderTextObjectiveName = (params) => {
    return (
      <Tooltip title={params.row.objectiveName}>
        <span style={{ fontSize: '10px' }}>{params.row.objectiveName}</span>
      </Tooltip>
    )
  }
  const renderTextComponentName = (params) => {
    return (
      <Tooltip title={params.row.componentName}>
        <span style={{ fontSize: '10px' }}>{params.row.componentName}</span>
      </Tooltip>
    )
  }

  const renderTextPrincipalName = (params) => {
    return (
      <Tooltip title={params.row.principalName}>
        <span style={{ fontSize: '10px' }}>{params.row.principalName}</span>
      </Tooltip>
    )
  }
  const renderTextEntityName = (params) => {
    return (
      <Tooltip title={params.row.entityName}>
        <span style={{ fontSize: '10px' }}>{params.row.entityName}</span>
      </Tooltip>
    )
  }


  const renderTextQuestion2 = (params) => {
    return (
      <Tooltip title={params.row.question}>
        <span style={{ fontSize: '10px' }}>{params.row.question}</span>
      </Tooltip>
    )
  }

  const renderTextQuestionType2 = (params) => {
    return (
      <span style={{ fontSize: '10px' }}>{params.row.questionType}</span>
    )
  }

  const [openQuestionEdit, setOpenQuestionEdit] = React.useState(false);
  const [openQuestionEditScroll, setOpenQuestionEditScroll] = React.useState('paper');
  const [selectedQuestionName, setSelectedQuestionName] = React.useState('');
  const [selectedQuestionId, setSelectedQuestionId] = React.useState('');


  function editQuestion(questionId, question) {
    setSelectedQuestionName(question);
    setSelectedQuestionId(questionId);
    setOpenQuestionEdit(true);
    setOpenQuestionEditScroll('paper');
  }


  const renderEditButton = (params) => {
    return (
      <strong>
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={() => {
            editQuestion(params.row.questionId, params.row.question)
          }}
        >
          Edit
        </Button>
      </strong>
    )
  }



  const columns = [
    { field: 'id', headerName: 'No', renderCell: renderTextId2, resizable: true, width: 15 },
    { field: 'questionId', headerName: 'No', width: 15, hide: true },
    { field: 'riskName', headerName: 'Risk', renderCell: renderTextRiskName, resizable: true, cellClassName: 'super-app-theme--cell', width: 130 },
    { field: 'objectiveName', headerName: 'Objective', renderCell: renderTextObjectiveName, resizable: true, cellClassName: 'super-app-theme--cell', width: 90 },
    { field: 'componentName', headerName: 'Component', renderCell: renderTextComponentName, resizable: true, cellClassName: 'super-app-theme--cell', width: 90 },
    { field: 'principalName', headerName: 'Principal', renderCell: renderTextPrincipalName, resizable: true, cellClassName: 'super-app-theme--cell', width: 180 },
    { field: 'entityName', headerName: 'Entity', renderCell: renderTextEntityName, resizable: true, cellClassName: 'super-app-theme--cell', width: 100 },
    { field: 'question', headerName: 'Question', renderCell: renderTextQuestion2, cellClassName: 'super-app-theme--cell', resizable: true, width: 250 },
    { field: 'questionType', headerName: 'Type', renderCell: renderTextQuestionType2, resizable: true, width: 80 },
    {
      field: 'action',
      headerName: 'More Info',
      sortable: false,
      renderCell: renderDetailsButton,
      disableClickEventBubbling: true,

    },
    {
      field: 'edit',
      headerName: 'Edit',
      sortable: false,
      renderCell: renderEditButton,
      disableClickEventBubbling: true,

    }

  ];

  /** GPT Research Section */

  const [hierarchyResearch, setHierarchyResearch] = React.useState(false);

  function startAgainFuction3() {
    setHierarchyResearch(true)
    setOpenRiskGpt(false)
  }

  const [openRiskGpt, setOpenRiskGpt] = React.useState(false);
  const [openRiskGptScroll, setOpenRiskGptScroll] = React.useState('paper');
  const [gptTextArray, setGptTextArray] = React.useState([]);
  const [selectedRiskDescription, setSelectedRiskDescription] = React.useState("");
  const [selectedImpactDescription, setSelectedImpactDescription] = React.useState("");
  const [selectedMitigation, setSelectedMitigation] = React.useState("");
  const [selectedRiskLevel, setSelectedRiskLevel] = React.useState("");
  const [selectedRiskAppetite, setSelectedRiskAppetite] = React.useState("");
  const [selectedRiskLevelColor, setSelectedRiskLevelColor] = React.useState("");
  const [selectedRiskAppetiteColor, setSelectedRiskAppetiteColor] = React.useState("");

  
  function openRiskGptFunction() {
    if (hierarchyNo === '') {
      alert("Please Select the item to research your risks ");
      return;
    }
    var countItem = 0;
    var countSection = 1;

    selectedRegisterData.riskRegister.forEach((item, index) => {
      countSection++;
      var arrRisk = [];
      if (item.risks != undefined && item.risks != null && item.risks.length > 0) {
        item.risks.forEach((item1, index1) => {
          countSection++;
          countItem++;
          if (countItem === parseInt(hierarchyNo)) {
            console.log(item)
            console.log(item1)
            setSelectedSectionName(item.section)
            setSelectedRiskName(item1.name);
            if (item1.riskDescription != null) {
              setSelectedRiskDescription(item1.riskDescription);
            } else {
              setSelectedRiskDescription("");
            }
            if (item1.impactDescription != null) {
              setSelectedImpactDescription(item1.impactDescription);
            } else {
              setSelectedImpactDescription("");
            }
            if (item1.mitigation != null) {
              setSelectedMitigation(item1.mitigation);
            } else {
              setSelectedMitigation("");
            }
            if (item1.riskLevel != null) {
              setSelectedRiskLevel(item1.riskLevel);
              colorPatterns.forEach((data, indexX) => {
                if (indexX === 0) {
                  if (parseInt(item1.riskLevel) > 10){
                  data.colors.forEach((data2, indexY) => {
                    if (indexY === (data.colors.length - 1)) {
                      setSelectedRiskLevelColor(data2.color)
                    }
                  })
                }else{
                  data.colors.forEach((data2) => {
                    if (parseInt(data2.scoreNumber) === parseInt(item1.riskLevel)) {
                      setSelectedRiskLevelColor(data2.color)
                    }
                  })
                }
                }
              })
            } else {
              setSelectedRiskLevel("");
              setSelectedRiskLevelColor("")
            }
            if (item1.riskAppetite != null) {
              setSelectedRiskAppetite(item1.riskAppetite);
              colorPatterns.forEach((data, index) => {
                if (index === 0) {
                  data.colors.forEach((data2) => {
                    if (parseInt(data2.scoreNumber) === parseInt(item1.riskAppetite)) {
                      setSelectedRiskAppetiteColor(data2.color)
                    }
                  })
                }
              })
            } else {
              setSelectedRiskAppetite("");
              setSelectedRiskAppetiteColor("")
            }
          }
        })
      }
    })



    setGptTextArray([])
    setHierarchyResearch(false)
    setOpenRiskGpt(true)
    setGptText('');
    setOpenRiskGptScroll('paper')

  }

  const [gptText, setGptText] = React.useState('');
  const handleChangeGptText = (e) => {
    setGptText(e.target.value);
    if (e.target.value != '') {
      document.getElementById('btnSend').style.color = 'white';
      document.getElementById('btnSend').style.backgroundColor = 'black';
    } else {
      document.getElementById('btnSend').style.color = 'black'
      document.getElementById('btnSend').style.backgroundColor = 'aliceblue'
    }
  };


  const saveTheResult1 = () => {
    if (gptTextArray.length === 0) {
      alert("No answers available")
      return;
    }
    var ans = "";
    gptTextArray.forEach((item, index) => {
      if ((index + 1) === gptTextArray.length) {
        ans = item.answer;
      }
    })

    const lines = ans.split("\n");


    const paragraphs = [];

    lines.forEach((line) => {
      if (line.trim().startsWith("###")) {
        const newText = line.replace("###", "").trim();
        const newText1 = newText.replace("**", "").trim()

        const newText2 = newText1.replace(/\*\*$/, "").trim();

        console.log(newText2);
        paragraphs.push(
          new Paragraph({
            children: [
              new TextRun({
                text: newText2,
                bold: true,
                size: 32,
              }),
            ],
            spacing: { after: 200 },
          })
        );
      } else if (line.trim() !== "") {
        const newText = line.replace("#", "").trim();
        const textParts = newText.split(/\*\*/);
        const textRuns = [];

        textParts.forEach((part, index) => {

          if (part.trim() !== "") {
            console.log(part)
            textRuns.push(
              new TextRun({
                text: part.replace("**", "").trim(),
                bold: index % 2 !== 0,
                size: 24,
              })
            );
          }
        });
        // const newText = textRuns.replace("###", "").trim()

        paragraphs.push(

          new Paragraph({
            children: textRuns,
            spacing: { after: 200 },
          })
        );
      }
    });

    const doc = new Document({
      sections: [
        {
          children: paragraphs,
        },
      ],
    });

    // Generate the docx file and save it
    Packer.toBlob(doc).then((blob) => {
      saveAs(blob, `answer-${formatDateForId(new Date())}.docx`);
    });
  }
  const saveTheResult = () => {
    if (gptTextArray.length === 0) {
      alert("No answers available")
      return;
    }
    var ans = "";
    gptTextArray.forEach((item, index) => {
      if ((index + 1) === gptTextArray.length) {
        ans = item.answer;
      }
    })

    const doc = new jsPDF();
    const lines = ans.split('\n');
    let y = 22;
    const lineHeight = 7;

    lines.forEach(line => {
      if (line.trim().startsWith('###')) {
        doc.setFont('times', 'bold');
        doc.setFontSize(18);
        line = line.replace('###', '').trim();
      } else {
        doc.setFont('times', 'normal');
        doc.setFontSize(13);
      }

      if (line.includes('**')) {
        doc.setFont('times', 'bold');
        line = line.replace(/\*\*/g, '');
      }

      const textLines = doc.splitTextToSize(line, 180);
      textLines.forEach(txt => {
        doc.text(txt, 14, y);
        y += lineHeight;

        if (y > doc.internal.pageSize.height - 10) {
          doc.addPage();
          y = 22;
        }
      });
    });

    doc.save(`answer-${formatDateForId(new Date())}.pdf`);

  };

  const [messageId, setMessageId] = React.useState(1);
  function formatDateForId(date) {
    
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
    
  }

  const formatContent = (text) => {
    // Split the content by newlines
    const textStr = text.replace(/\n/g, '@H'); // 4 spaces for each "#"
    console.log(textStr)
    const allText = textStr.replace(/\#\#\#(.*?)\@\H\@\H/g, (match, p1) => {
      //return `<span style={{color: 'red'}}>${p1}</span>@H@H`;
      return `<strong style="color: teal;font-size: 20px;"><u>${p1}</u></strong>@H@H`;
    });
    console.log(allText)
    return allText.split('@H').map((line, index) => {
      // Replace "#" with tabs (indentation using non-breaking space &nbsp;)
      const tabbedLine1 = line.replace(/#/g, ''); // 4 spaces for each "#"
      const tabbedLine2 = tabbedLine1.replace(/\-\-\-/g, ''); // 4 spaces for each "#"
      //const tabbedLine = tabbedLine2.replace(/-/g, '\u00A0\u00A0\u00A0-'); // 4 spaces for each "#"
      // Replace **bold** and remove the surrounding ** marks
      const formattedLine = tabbedLine2.replace(/\*\*(.*?)\*\*/g, (match, p1) => {
        return `<strong>${p1}</strong>`;
      });

      // Return as HTML content, dangerouslySetInnerHTML is used to allow HTML like <strong>
      return (
        <div key={index} dangerouslySetInnerHTML={{ __html: formattedLine }}></div>
      );
    });
  };


  function sentToChatGtp() {
    var obj = {}
    obj["userId"] = globalCentreId;
    obj["createdBy"] = globalUserId;
    console.log(globalCentreId + "-" + globalUserId)

    var objArr = [];

    var obj1 = {}
    obj1["messageId"] = formatDateForId(new Date()) + "-" + messageId;
    setMessageId(messageId + 1);
    obj1["message"] = gptText;
    objArr.push(obj1);
    obj["chats"] = objArr
    var sendJson = JSON.stringify(obj)
    setLoading1(true)

    axios(CONFIG.MAIN_URL + '/openai/advancechat', {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      data: sendJson,
    })
      .then(function (response) {
        console.log(JSON.stringify(response.data));
        var obj = {};
        obj["question"] = gptText;
        var ans = response.data.answer.replaceAll('\n', '<br>')
        obj["answer"] = (response.data.answer);
        setGptTextArray([...gptTextArray, obj]);
        setGptText('')
        setLoading1(false)
        document.getElementById('btnSend').style.color = 'black'
        document.getElementById('btnSend').style.backgroundColor = 'aliceblue'

      })
      .catch(function (error) {
        console.log(error);
        setLoading1(false)
        alert("Error saving Question -:" + error);
      });
  }




  return (
    <>
      <div>
        <Grid container spacing={2}>
          <Grid container spacing={2} className={classes.pageBodyStyle}>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={10} style={{ marginTop: '-21px' }}>{topHeaderTextMessage != "" ? parse(topHeaderTextMessage) : ''}</Grid>
                <Grid item xs={2}>
                  {!speakerOff ?
                    <VolumeUp
                      id='iconVolumeUp'
                      sx={{ cursor: 'pointer', float: 'right', marginTop: '-21px' }}
                      onClick={() => { handleVolumeUp() }}
                    />
                    :
                    <VolumeOff
                      id='iconVolumeUp'
                      sx={{ cursor: 'pointer', float: 'right', marginTop: '-21px' }}
                      onClick={() => { handleVolumeDown() }}
                    />
                  }
                </Grid>

                {qaArray.length === 0 ?
                  <>
                    <Grid item xs={1}>
                      <BootstrapTooltip title='Risk GPT'>
                        <Avatar sx={{ bgcolor: red[500], height: '30px', width: '30px' }} variant="square">
                          <span className={wordstyle}>RG</span>
                        </Avatar>
                      </BootstrapTooltip>
                    </Grid>

                    <Grid item xs={11}>

                      <Grid container spacing={1}>

                        <Grid item xs={12}>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item className='textfieldGrid1'>
                      <Box component="form" sx={{ '& .MuiTextField-root': { width: '100%' }, }} noValidate autoComplete="off">
                        <TextField
                          variant="outlined"
                          value={sendMessageField}
                          onChange={handleSendMessage}
                          focused={true}
                          onClick={textFieldClickBlinkStop}
                        />
                      </Box>

                    </Grid>
                    <Grid item className='textfieldGrid2'>
                      <Button variant="contained" onClick={handleButtonStep1Click} style={{ height: '50px', }}>Done</Button>
                    </Grid>

                  </>
                  :
                  <>
                    <Grid item xs={12} id='messageHtml'>
                      {registerArrayQa}
                    </Grid>
                  </>
                }



              </Grid>

              {sendMessageField === '1' ?
                <>
                  {!createdRegister ?
                    <>
                      <Grid container spacing={2}>
                        {step1 && !step2 ?
                          <>

                            <Grid item xs={11}>
                              <Box component="form" sx={{ '& .MuiTextField-root': { width: '100%' }, }} noValidate autoComplete="off">
                                <TextField
                                  variant="outlined"
                                  value={registerName}
                                  onChange={handleChangeRegisterName}
                                  focused={true}
                                  onClick={textFieldClickBlinkStop}
                                />
                              </Box>

                            </Grid>
                            <Grid item xs={1}>
                              <Button variant="contained" onClick={handleButtonStep2Click} style={{ height: '50px', }}>Done</Button>
                            </Grid>

                          </>
                          :
                          ''
                        }

                        {step1 && step2 && !step3 ?
                          <>
                            <Grid item xs={11}>
                              <Box component="form" sx={{ '& .MuiTextField-root': { width: '100%' }, }} noValidate autoComplete="off">
                                <TextField
                                  variant="outlined"
                                  value={registerDescription}
                                  onChange={handleChangeRegisterDescription}
                                  focused={true}
                                  onClick={textFieldClickBlinkStop}
                                />
                              </Box>
                            </Grid>
                            <Grid item xs={1}>
                              <Button variant="contained" onClick={handleButtonStep3Click} style={{ height: '50px', }}>Done</Button>
                            </Grid>

                          </>
                          :
                          ''
                        }

                        {step1 && step2 && step3 && !step4 ?
                          <>


                            <Grid item xs={10}>
                              <Box component="form" sx={{ '& .MuiTextField-root': { width: '100%' }, }} noValidate autoComplete="off">
                                <TextField
                                  variant="outlined"
                                  value={sectionHeadingName}
                                  onChange={onChangeSectionHeadingName}
                                  focused={true}
                                  onClick={textFieldClickBlinkStop}
                                />
                              </Box>

                            </Grid>


                            <Grid item xs={1}>
                              <Button variant="contained" onClick={() => clickSectionMore()} style={{ height: '50px', }}>Next</Button>
                            </Grid>

                            <Grid item xs={1}>
                              <Button variant="contained" onClick={() => addingSectionFinishButton()} style={{ height: '50px', }}>Done</Button>
                            </Grid>


                          </>
                          :
                          ''
                        }

                        {step1 && step2 && step3 && step4 && !step5 ?
                          <>

                            <Grid item xs={9}>
                              <Box component="form" sx={{ '& .MuiTextField-root': { width: '100%' }, }} noValidate autoComplete="off">
                                <TextField
                                  variant="outlined"
                                  value={riskDescription}
                                  onChange={onChangeRiskDescription}
                                  focused={true}
                                  onClick={textFieldClickBlinkStop}
                                />
                              </Box>

                            </Grid>



                            <Grid item xs={1}>
                              <Button variant="contained" onClick={() => riskMore()} style={{ height: '50px', }}>Next</Button>
                            </Grid>

                            <Grid item xs={1}>
                              <Button variant="contained" onClick={() => riskFinish()} style={{ height: '50px', }}>Done</Button>
                            </Grid>

                            <Grid item xs={1}>
                              <Button variant="contained" onClick={() => finalizeReg()} style={{ height: '50px', }}>Finish</Button>
                            </Grid>


                          </>
                          :
                          ''
                        }
                        {step1 && step2 && step3 && step4 && step5 && !step6 ?
                          <>
                            <Grid item xs={10}>
                              <Box component="form" sx={{ '& .MuiTextField-root': { width: '100%' }, }} noValidate autoComplete="off">
                                <TextField
                                  variant="outlined"
                                  value={questionId}
                                  onChange={handlequestionId}
                                  focused={true}
                                  onClick={textFieldClickBlinkStop}
                                />
                              </Box>

                            </Grid>



                            <Grid item xs={2}>
                              <Button variant="contained" onClick={() => sendToDataBase()} style={{ height: '50px', }}>Create Register</Button>
                            </Grid>
                          </>
                          :
                          ''
                        }


                      </Grid>

                      <br></br>
                    </>
                    :
                    <>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <b><span style={{ fontSize: '1.4rem' }}>{selectedRegisteredName} </span></b><span style={{ fontSize: '1.4rem' }}>has been created.</span>
                        </Grid>
                        <Grid item xs={12}>
                          <div style={{ display: 'flex', gap: '5px', textAlign: 'center' }}>
                            <Button
                              variant="contained"
                              onClick={handleClickOpen}
                            >Show Response</Button>
                            <Button
                              variant="contained"
                              onClick={() => evaluateRiskFuction()}
                            >
                              Evaluate
                            </Button>
                            <Button
                              variant="contained"
                              onClick={() => editRiskFuction()}
                            >
                              Edit Register
                            </Button>
                            <Button
                              variant="contained"
                              onClick={() => addRiskFuction()}
                            >
                              Add Risk Hierarchy
                            </Button>
                            <Button
                              variant="contained"
                              onClick={() => clearButton()}
                            >clear</Button>
                          </div>
                        </Grid>
                      </Grid>
                    </>
                  }
                </>
                :
                ''
              }
              {sendMessageField === '2' ?
                <>
                  {!createdHierachy ?
                    <>
                      <Grid container spacing={2}>
                        {step0 && !step1 ?
                          <>
                            <Grid item xs={9} className='textfieldGrid1X'>
                              <Box component="form" sx={{ '& .MuiTextField-root': { width: '100%' }, }} noValidate autoComplete="off">
                                <TextField
                                  variant="outlined"
                                  value={hierarchyNo}
                                  onChange={handleChangeHierarchyNo}
                                  pattern='[0-9]{0,5}'
                                  focused={true}
                                  onClick={textFieldClickBlinkStop}
                                />
                              </Box>

                            </Grid>
                            <Grid item xs={3} className='textfieldGrid2X'>
                            <Button variant="contained" onClick={handleButtonStep0HClick} style={{ height: '50px', }}>Done</Button>
                              &nbsp;<span style={{fontWeight: 'bold'}}>OR</span>&nbsp;
                              <Button variant="contained" onClick={() => openRiskGptFunction()} style={{ height: '50px', }}>Research</Button>
                            </Grid>

                          </>
                          :
                          ''
                        }


                        {step1 && !step2 ?
                          <>

                            <Grid item className='textfieldGridfrCom1'>
                              <Box component="form" sx={{ '& .MuiTextField-root': { width: '100%' }, }} noValidate autoComplete="off">
                                <TextField
                                  variant="outlined"
                                  value={hierarchyKey}
                                  onChange={handleChangeHierarchyKey}
                                  focused={true}
                                  onClick={textFieldClickBlinkStop}
                                />
                              </Box>

                            </Grid>
                            <Grid item className='textfieldGridfrCom2'>
                              <Button variant="contained" onClick={handleButtonStep2HClick} className='buttonStyle' style={{ height: '50px', }}>Done</Button>
                            </Grid>
                            <Grid item className='textfieldGridfrCom3'>
                              <Button variant="contained" onClick={handleButtonStep2HPreviousClick} className='buttonStyle' style={{ height: '50px', }}>Assign a Created Hierarchy</Button>
                            </Grid>

                          </>
                          :
                          ''
                        }

                        {step1 && step2 && !step3 ?
                          <>
                            <Grid item className='textfieldGrid1'>
                              <Box component="form" sx={{ '& .MuiTextField-root': { width: '100%' }, }} noValidate autoComplete="off">
                                <TextField
                                  variant="outlined"
                                  value={hierarchyName}
                                  onChange={handleChangeHierarchyName}
                                  focused={true}
                                  onClick={textFieldClickBlinkStop}
                                />
                              </Box>
                            </Grid>
                            <Grid item className='textfieldGrid2'>
                              <Button variant="contained" onClick={handleButtonStep3HClick} style={{ height: '50px', }}>Done</Button>
                            </Grid>

                          </>
                          :
                          ''
                        }

                        {step1 && step2 && step3 && !step4 ?
                          <>
                            <Grid item className='textfieldGrid1'>
                              <Box component="form" sx={{ '& .MuiTextField-root': { width: '100%' }, }} noValidate autoComplete="off">
                                <TextField
                                  variant="outlined"
                                  value={mainRiskName}
                                  onChange={onChangeMainRiskName}
                                  focused={true}
                                  onClick={textFieldClickBlinkStop}
                                />
                              </Box>

                            </Grid>

                            <Grid item className='textfieldGrid2'>
                              <Button variant="contained" onClick={() => clickMainRiskDoneButton()} style={{ height: '50px', }}>Done</Button>
                            </Grid>


                          </>
                          :
                          ''
                        }

                        {step1 && step2 && step3 && step4 && !step5 ?
                          <>

                            <Grid item className='textfieldGrid3'>
                              <Box component="form" sx={{ '& .MuiTextField-root': { width: '100%' }, }} noValidate autoComplete="off">
                                <TextField
                                  variant="outlined"
                                  value={subRiskName}
                                  onChange={onChangeSubRiskName}
                                  focused={true}
                                  onClick={textFieldClickBlinkStop}
                                />
                              </Box>
                            </Grid>

                            <Grid item className='textfieldGrid4'>
                              <Button variant="contained" onClick={() => subRiskDone()} style={{ height: '50px', }}>Done</Button>
                            </Grid>

                            <Grid item className='textfieldGrid4'>
                              <Button variant="contained" onClick={() => finishSubRisk()} style={{ height: '50px', }}>Finish</Button>
                            </Grid>


                          </>
                          :
                          ''
                        }

                        {step1 && step2 && step3 && step4 && step5 && !step6 ?
                          <>

                            <Grid item className='textfieldGrid3'>
                              <Box component="form" sx={{ '& .MuiTextField-root': { width: '100%' }, }} noValidate autoComplete="off">
                                <TextField
                                  variant="outlined"
                                  value={subSubRiskName}
                                  onChange={onChangeSubSubRiskName}
                                  focused={true}
                                  onClick={textFieldClickBlinkStop}
                                />
                              </Box>
                            </Grid>
                            <Grid item className='textfieldGrid4'>
                              <Button variant="contained" onClick={() => subSubRiskDone()} style={{ height: '50px', }}>Done</Button>
                            </Grid>

                            <Grid item className='textfieldGrid4'>
                              <Button variant="contained" onClick={() => finishSubSubRisk()} style={{ height: '50px', }}>Finish</Button>
                            </Grid>


                          </>
                          :
                          ''
                        }



                        {step1 && step2 && step3 && step4 && step5 && step6 && !step7 ?
                          <>
                            <Grid item className='textfieldGrid6'>
                              <Box component="form" sx={{ '& .MuiTextField-root': { width: '100%' }, }} noValidate autoComplete="off">
                                <TextField
                                  variant="outlined"
                                  value={questionId}
                                  onChange={handlequestionId}
                                  focused={true}
                                  onClick={textFieldClickBlinkStop}
                                />
                              </Box>

                            </Grid>



                            <Grid item className='textfieldGrid5'>
                              <Button variant="contained" onClick={() => addRiskFuctionStandard()} style={{ height: '50px', }} className='wordStyle'>Create Risk Hierarchy</Button>
                            </Grid>
                            {/* onClick={() => sendToDataBaseH()} */}
                          </>
                          :
                          ''
                        }


                      </Grid>

                      <br></br>
                    </>
                    :
                    <>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <b><span className='wordStyle'>{selectedRiskEvaluateTitle} </span></b><span className='wordStyle'>has been created.</span>
                        </Grid>
                        <Grid item xs={12}>
                          <div style={{ display: 'flex', gap: '5px', textAlign: 'center' }}>
                            {!updatedFromPreviousHirarchy ?
                              <Button
                                variant="contained"
                                className='buttonStyle'
                                onClick={handleClickOpen}
                              >Show Response</Button>
                              :
                              ''
                            }
                            <Button
                              variant="contained"
                              className='buttonStyle'
                              onClick={() => evaluateRiskHFuction()}
                            >
                              Evaluate
                            </Button>
                            <Button
                              variant="contained"
                              className='buttonStyle'
                              onClick={() => editRiskHFuction()}
                            >
                              Edit Risk Hierarchy
                            </Button>
                            {!updatedFromPreviousHirarchy ?
                              <Button
                                variant="contained"
                                className='buttonStyle'
                                onClick={() => showQuestionFuction()}
                              >
                                Show Questions
                              </Button>
                              :
                              ''
                            }
                            {showAddNextHirarchy ?
                              <Button
                                variant="contained"
                                className='buttonStyle'
                                onClick={() => createNextRiskFuction()}
                              >
                                Assign Risk Hierachy for Next Risk
                              </Button>
                              :
                              ''
                            }
                            {!updatedFromPreviousHirarchy ?
                              <Button
                                variant="contained"
                                className='buttonStyle'
                                onClick={() => clearButton()}
                              >clear</Button>
                              :
                              ''
                            }
                          </div>
                        </Grid>
                      </Grid>
                    </>
                  }
                </>
                :
                ''
              }

            </Grid>

          </Grid>
        </Grid>
      </div>

      <Dialog
        open={loading}
        onClose={false}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" style={{ textAlign: 'center' }}>
          <span style={{ textAlign: 'center' }}>Processing !.<br></br>
            Please Wait .......</span>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item xs={12} style={{ textAlign: 'center' }}>
              <CircularWithValueLabel />
            </Grid>
          </Grid>


        </DialogContent>
      </Dialog>

      <Dialog
        open={loading1}
        onClose={false}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" style={{ textAlign: 'center' }}>
          <span style={{ textAlign: 'center' }}>Please Wait ...</span>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <ClockLoader
                size={100}
                color={'red'}
                className={classes.loaderStyle}
                loading={loading1}
              />
            </Grid>
          </Grid>


        </DialogContent>
      </Dialog>

      {/** For Register Eval */}

      <Dialog
        open={openRegisterDataForEval}
        onClose={false}
        scroll={openRegisterDataForEvalScroll}
        aria-labelledby="register-data-dialog-title"
        aria-describedby="register-data-dialog-description"
        fullWidth={true}
        maxWidth={maxWidthState}
        fullScreen={fullScreenState}
        //PaperComponent={PaperComponentCollectionDataRegister}
      >
        <DialogTitle style={{ cursor: 'move' }} id="collection-data-dialog-title">
          <Typography variant="h6" style={{ fontSize: '25px !important' }}>Evaluate "{selectedRegisterEvaluateTitle}" - <SavePageAs /></Typography>
          <Typography variant="h6" style={{ marginRight: '-22px', padding: '7px', marginTop: '-50px', float: 'right' }}>
            <Tooltip title="Close"><Close onClick={RegisterDataForEvalfunctionClose} style={{ cursor: 'pointer' }} /></Tooltip>
          </Typography>
        </DialogTitle>

        <DialogContent dividers={openRegisterDataForEvalScroll === 'paper'}>
          <DialogContentText id="main-risk-scroll-dialog-description" tabIndex={-1}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                {multipleRoles ?
                  <EvaluateComponent1
                    colorPatterns={colorPatterns}
                    registerTypeDataForEval={registerTypeDataForEval}
                    openRegisterDataForEvalScroll={openRegisterDataForEvalScroll}
                    registerEvaluate={true}
                  />
                  :
                  <EvaluateComponent
                    colorPatterns={colorPatterns}
                    registerTypeDataForEval={registerTypeDataForEval}
                    openRegisterDataForEvalScroll={openRegisterDataForEvalScroll}
                    registerEvaluate={registerEvaluate}
                  />
                }
              </Grid>
            </Grid>


          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={RegisterDataForEvalfunctionClose}>Cancel</Button>
        </DialogActions>
      </Dialog>

      {/** Edit Register */}
      <Dialog
        open={openRegisterEdit}
        onClose={false}
        scroll={openRegisterEditScroll}
        aria-labelledby="collection-data-dialog-title"
        aria-describedby="collection-data-dialog-description"
        fullWidth={true}
        maxWidth={'lg'}
      >
        <DialogTitle style={{ cursor: 'move' }} id="collection-data-dialog-title">
          <Typography variant="h6" style={{ fontSize: '25px !important' }}>Edit Register - "{selectedRegisteredName}" - <SavePageAs />
          </Typography>
          <Typography variant="h6" style={{ marginRight: '-15px', padding: '7px', marginTop: '-50px', float: 'right' }}>
            <Tooltip title="Close"><Close onClick={() => setOpenRegisterEdit(false)} style={{ cursor: 'pointer' }} /></Tooltip>
          </Typography>
        </DialogTitle>
        <DialogContent dividers={openRegisterEditScroll === 'paper'}>
          <DialogContentText id="main-risk-scroll-dialog-description" tabIndex={-1}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <RiskRegisterComponent
                  selectedRegisteredId={selectedRegisteredId}
                />
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenRegisterEdit(false)}>Close</Button>
        </DialogActions>
      </Dialog>


      <Dialog
        open={openDisplayChoice}
        onClose={handleCloseDisplayChoice}>
        <DialogTitle>
          Select the Display Method

        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            How do you want to display the Register
          </DialogContentText>
          <Grid container spacing={2}>
            <Grid item xs={12}>&nbsp;</Grid>
            <Grid item xs={5}>
              <Button
                variant="contained"
                component="label"
                onClick={() => byRoleFuction()}
                className='btnFonts'
                style={{ float: 'right' }}
              >
                By Role
              </Button>
            </Grid>
            <Grid item xs={7}>
              <Button
                variant="contained"
                component="label"
                onClick={() => byRiskNameFuction()}
                className='btnFonts'
              >
                By Risk Name
              </Button>
            </Grid>

          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDisplayChoice}>Close</Button>
        </DialogActions>
      </Dialog>


      <div>

        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Questions and answers"}
          </DialogTitle>
          <DialogContent>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <textarea
                  name="postContent"
                  rows={20}
                  cols={50}
                  value={questiomRes}
                />
                { }
              </Grid>
            </Grid>


          </DialogContent>
          <DialogActions>

            <Button onClick={handleClose} autoFocus>
              cancel
            </Button>
          </DialogActions>
        </Dialog>
      </div>

      {/** Edit Risk */}
      <Dialog
        open={openRiskDataEdit}
        onClose={false}
        scroll={openRiskDataEditScroll}
        aria-labelledby="collection-data-dialog-title"
        aria-describedby="collection-data-dialog-description"
        fullWidth={true}
        maxWidth={'lg'}
      >
        <DialogTitle style={{ cursor: 'move' }} id="collection-data-dialog-title">
          <Typography variant="h6" style={{ fontSize: '25px !important' }}>Edit "{selectedRiskEvaluateTitle}" - <SavePageAs />
          </Typography>
          <Typography variant="h6" style={{ marginRight: '-15px', padding: '7px', marginTop: '-50px', float: 'right' }}>
            <Tooltip title="Close"><Close onClick={setOpenRiskDataEditfunction} style={{ cursor: 'pointer' }} /></Tooltip>
          </Typography>
        </DialogTitle>
        <DialogContent dividers={openRiskDataEditScroll === 'paper'}>
          <DialogContentText id="main-risk-scroll-dialog-description" tabIndex={-1}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <RiskHierarchyNew
                  riskHierarchyId={createdRiskId}
                />
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={setOpenRiskDataEditfunction}>Cancel</Button>
        </DialogActions>
      </Dialog>


      <Dialog
        open={openShowQuestions}
        onClose={false}
        scroll={openShowQuestionsScroll}
        aria-labelledby="collection-data-dialog-title"
        aria-describedby="collection-data-dialog-description"
        fullWidth={true}
        maxWidth={'lg'}
        //PaperComponent={PaperComponentAllQuestionData}
      >
        <DialogTitle style={{ cursor: 'move' }} id="collection-data-dialog-title">
          <div style={{ display: 'flex', gap: '200px' }}>
            <h6 style={{ fontSize: '25px !important' }}>Questions related to "{selectedRiskEvaluateTitle}" - <SavePageAs /> </h6>
            <div style={{ float: 'right' }}><TransferToExcelHierarchy arrayForTransferExcel={arrayForTransferExcel} riskName={selectedRiskEvaluateTitle} /></div>

          </div>
          <Typography variant="h6" style={{ textAlign: 'right', marginTop: '', marginRight: '-25px', padding: '7px', marginTop: '-50px' }}>
            <Tooltip title="Close"><Close onClick={() => setOpenShowQuestions(false)} style={{ cursor: 'pointer' }} /></Tooltip>
          </Typography>
        </DialogTitle>
        <DialogContent dividers={openShowQuestionsScroll === 'paper'}>
          <DialogContentText id="main-risk-scroll-dialog-description" tabIndex={-1}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Grid container spacing={2}>

                  <Box
                    sx={{
                      height: 400,
                      width: '100%',
                      '& .super-app-theme--cell': {
                        whiteSpace: 'normal !important',
                        lineHeight: '1',
                      },
                      '& .super-app-theme--Open': {
                        fontSize: '10px !important',
                      },

                    }}
                  >

                    <div style={{ height: 400, width: '100%', backgroundColor: '#ffffff', fontSize: '9px !important' }}>
                      <DataGrid
                        rows={rows}
                        columns={columns}
                        pageSize={5}
                        rowsPerPageOptions={[5]}
                        getRowClassName={`super-app-theme--Open`}
                        disableSelectionOnClick
                      />
                    </div>

                  </Box>
                </Grid>
              </Grid>


            </Grid>

          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenShowQuestions(false)}>Cancel</Button>
        </DialogActions>
      </Dialog>

      {/** Question Details Show Dialog */}
      <Dialog
        maxWidth='xs'
        open={questionDetailOpen}
        onClose={questionDetailHandleClickClose}
        scroll={questionDetailScroll}
        //PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          <Typography variant="h6" gutterBottom component="div">
            Question No - {quesDataCount}
          </Typography>
          <Typography component="th" scope="row" style={{ width: '100%', fontSize: '10px !important' }}>
            <span style={{ fontWeight: '550' }}>Question - </span>{selectedQuestion}
          </Typography>
        </DialogTitle>
        <DialogContent dividers={questionDetailScroll === 'paper'}>
          <DialogContentText
            id="risk-eval-type-scroll-dialog-description"
            tabIndex={-1}
          >
            <Grid container spacing={2}>
              {selectedQuesData.map((data) => {
                return (
                  <Grid item xs={12}>
                    <Box >
                      <Table size="small" aria-label="purchases">
                        <TableBody>
                          <TableRow>
                            <TableCell component="th" scope="row" style={{ width: '80%' }}>
                              <Typography variant="h6" gutterBottom component="div">
                                Detail Weightings
                              </Typography>
                            </TableCell>
                            <TableCell component="th" scope="row" style={{ width: '20%', paddingLeft: '0px !important', paddingRight: '0px !important' }} align="right">
                              <Typography variant="h6" component="div">
                                Score
                              </Typography>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                      <Table size="small" aria-label="purchases">
                        <TableBody>
                          <TableRow>
                            <TableCell component="th" scope="row" style={{ width: '80%' }}>
                              Questionnaire weighting
                            </TableCell>
                            <TableCell component="th" scope="row" style={{ width: '20%', paddingLeft: '0px !important', paddingRight: '0px !important' }} align="right">
                              <span >{data.questionScore}</span>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                      {data.questionType === "Closeended" && (
                        <>
                          <Table size="small" aria-label="purchases">
                            <TableBody>
                              <TableRow>
                                <TableCell component="th" scope="row" style={{ width: '80%' }}>
                                  <Typography variant="h6" gutterBottom component="div">
                                    Answers
                                  </Typography>
                                </TableCell>
                                <TableCell component="th" scope="row" style={{ width: '20%', paddingLeft: '0px !important', paddingRight: '0px !important' }} align="right">
                                  &nbsp;
                                </TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                          <Table size="small" aria-label="purchases">
                            <TableBody>
                              {data.answers.answerMethod.name != "" && data.answers.answerList.length > 0 && data.answers.answerList.map((item) => {
                                return (
                                  <>
                                    <TableRow>
                                      <TableCell component="th" scope="row" style={{ width: '80%' }}>
                                        <span >{item.answerName}</span>
                                      </TableCell>
                                      <TableCell component="th" scope="row" style={{ width: '20%', paddingLeft: '0px !important', paddingRight: '0px !important' }} align="right">
                                        <span>{item.riskLevel}</span>
                                      </TableCell>
                                    </TableRow>
                                  </>
                                )
                              })}
                            </TableBody>
                          </Table>
                        </>
                      )}
                      {data.questionType === "Closeended" && (
                        <Table size="small" aria-label="purchases">
                          <TableBody>
                            {data.answers.answerMethod.name != "" && data.answers.answerList.length > 0 && data.answers.answerList.map((item) => {
                              if (item.expectedAnswerName != "") {
                                return (
                                  <>
                                    <TableRow>
                                      <TableCell component="th" scope="row" style={{ width: '80%' }}>
                                        <span>
                                          {item.answerName}
                                        </span>
                                      </TableCell>
                                      <TableCell component="th" scope="row" style={{ width: '20%', paddingLeft: '0px !important', paddingRight: '0px !important' }} align="right">
                                        <span>{item.expectedAnswerName === "Yes" || item.expectedAnswerName === "checked" ? item.riskLevel : item.expectedAnswerName}</span>
                                      </TableCell>
                                    </TableRow>
                                  </>
                                )
                              }
                            })}
                          </TableBody>
                        </Table>
                      )}
                    </Box>
                  </Grid>
                )
              })}
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={questionDetailHandleClickClose}>Cancel</Button>
        </DialogActions>
      </Dialog>
      {/** End of Question Details Show Dialog*/}



      {/** Edit Question */}
      <Dialog
        open={openQuestionEdit}
        onClose={false}
        scroll={openQuestionEditScroll}
        aria-labelledby="collection-data-dialog-title"
        aria-describedby="collection-data-dialog-description"
        fullWidth={true}
        maxWidth={'lg'}
      >
        <DialogTitle style={{ cursor: 'move' }} id="collection-data-dialog-title">
          <Typography variant="h6" style={{ fontSize: '25px !important' }}>Edit Question - "{selectedQuestionName}"
          </Typography>
          <Typography variant="h6" style={{ marginRight: '-15px', padding: '7px', marginTop: '-50px', float: 'right' }}>
            <Tooltip title="Close"><Close onClick={() => setOpenQuestionEdit(false)} style={{ cursor: 'pointer' }} /></Tooltip>
          </Typography>
        </DialogTitle>
        <DialogContent dividers={openQuestionEditScroll === 'paper'}>
          <DialogContentText id="main-risk-scroll-dialog-description" tabIndex={-1}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <AddQuestionComponent
                  fromUploadPage={'OK'}
                  questionIdFromUploadPage={selectedQuestionId}
                />
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenQuestionEdit(false)}>Cancel</Button>
        </DialogActions>
      </Dialog>




      {/** Add  Risk Hirarchies to Register */}
      <Dialog
        open={openRiskHierarchyComponent}
        onClose={false}
        scroll={openRiskHierarchyComponentScroll}
        aria-labelledby="collection-data-dialog-title"
        aria-describedby="collection-data-dialog-description"
        fullWidth={true}
        maxWidth={'lg'}
      >
        <DialogTitle style={{ cursor: 'move' }} id="collection-data-dialog-title">
          <Typography variant="h6" style={{ fontSize: '25px !important' }}>Add Risk Hierarchy to - "{selectedRegisteredName}" - <SavePageAs />
          </Typography>
          <Typography variant="h6" style={{ marginRight: '-15px', padding: '7px', marginTop: '-50px', float: 'right' }}>
            <Tooltip title="Close"><Close onClick={() => setOpenRiskHierarchyComponent(false)} style={{ cursor: 'pointer' }} /></Tooltip>
          </Typography>
        </DialogTitle>
        <DialogContent dividers={openRegisterEditScroll === 'paper'}>
          <DialogContentText id="main-risk-scroll-dialog-description" tabIndex={-1}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenRiskHierarchyComponent(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openShowHierarchies}
        onClose={false}
        scroll={openShowHierarchiesScroll}
        aria-labelledby="hierarchy-data-dialog-title"
        aria-describedby="hierarchy-data-dialog-description"
        fullWidth={true}
        maxWidth={'md'}
        //PaperComponent={PaperComponentHierarchyData}
      >
        <DialogTitle style={{ cursor: 'move' }} id="hierarchy-data-dialog-title">
          <Typography variant="h6" style={{ fontSize: '25px !important' }}>Add Risk Hierarchy for  "{selectedRiskName}" in "{selectedSectionName}" - <SavePageAs />
          </Typography>
          <Typography variant="h6" style={{ textAlign: 'right', marginTop: '', marginRight: '-25px', padding: '7px', marginTop: '-50px' }}>
            <Tooltip title="Close"><Close onClick={() => setOpenShowHierarchies(false)} style={{ cursor: 'pointer' }} /></Tooltip>
          </Typography>
        </DialogTitle>
        <DialogContent dividers={openShowHierarchiesScroll === 'paper'}>
          <DialogContentText id="main-risk-scroll-dialog-description" tabIndex={-1}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Box
                    sx={{
                      height: 400,
                      width: '100%',
                      '& .super-app-theme--cell': {
                        whiteSpace: 'normal !important',
                        lineHeight: '1',
                      },
                      '& .super-app-theme--Open': {
                        fontSize: '10px !important',
                      },

                    }}
                  >

                    <div style={{ height: 400, width: '100%', backgroundColor: '#ffffff', fontSize: '9px !important' }}>
                      <DataGrid
                        rows={hRows}
                        columns={hColumns}
                        pageSize={5}
                        rowsPerPageOptions={[5]}
                        getRowClassName={`super-app-theme--Open`}
                        disableSelectionOnClick
                      />
                    </div>

                  </Box>
                </Grid>
              </Grid>


            </Grid>

          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenShowHierarchies(false)}>Close</Button>
        </DialogActions>
      </Dialog>


      <Dialog
        open={openHaDetails}
        TransitionComponent={Transition}
        keepMounted
        onClose={haDetailshandleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          <DialogTitle>{rHName}</DialogTitle>
          <DialogContentText id="alert-dialog-slide-description">
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Button variant="contained" onClick={handleButtonHaEval} style={{ height: '50px', float: 'right' }}>Evaluate</Button>
              </Grid>

              <Grid item xs={6}>
                <Button variant="contained" onClick={handleButtonHaQuestion} style={{ height: '50px' }}>Show Questions</Button>
              </Grid>

            </Grid>


          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={haDetailshandleClose}>Close</Button>
        </DialogActions>
      </Dialog>


      <Dialog
        open={riskStandardOpen}
        onClose={handleCloseStandardDialog}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"Which standard do you want to use"}</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Box sx={{ minWidth: 120, marginTop: '10px' }}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Select Global Standard for Objectives</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Select From Global Standaed"
                    value={globalStandardDataForObjective}
                    onChange={handleChangeGlobalStandardDataForObjective}

                  >
                    {globalStandardData.filter(com => com.objectives.length > 0).map((item) => (
                      <MenuItem
                        value={item.standardName}
                      >
                        {item.standardName}
                      </MenuItem>
                    ))}

                  </Select>

                </FormControl>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box sx={{ minWidth: 120 }}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Select Global Standard for Component</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Select From Global Standaed"
                    value={globalStandardDataForComponent}
                    onChange={handleChangeGlobalStandardDataForComponent}

                  >
                    {globalStandardData.filter(com => com.components.length > 0).map((item) => (
                      <MenuItem
                        value={item.standardName}
                      >
                        {item.standardName}
                      </MenuItem>
                    ))}

                  </Select>

                </FormControl>
              </Box>


            </Grid>

            <Grid item xs={12}>
              <Box sx={{ minWidth: 120 }}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Select Global Standard for principle</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Select From Global Standaed"
                    value={globalStandardDataForPrinciple}
                    onChange={handleChangeGlobalStandardDataForPrinciple}

                  >
                    {globalStandardData.filter(com => com.principles.length > 0).map((item) => (
                      <MenuItem
                        value={item.standardName}
                      >
                        {item.standardName}
                      </MenuItem>
                    ))}

                  </Select>

                </FormControl>
              </Box>


            </Grid>

            <Grid item xs={12}>
                <span style={{fontSize: '1.25rem', fontWeight: 'bold'}}>Which Schema do you want to use</span>
            </Grid>
            <Grid item xs={12}>
              <Box sx={{ minWidth: 120 }}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Select a Schema</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Select From Global Standaed"
                    value={schemaName}
                    onChange={handleChangeSchemaName}
                  >
                    {allAvailableRiskSchemas.map((item) => (
                      <MenuItem
                        value={item.id}
                      >
                        {item.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </Grid>


          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={sendToDataBaseH}>Confirm</Button>
          <Button onClick={handleStandardDialogClear}>Clear</Button>
          <Button onClick={handleCloseStandardDialog}>close</Button>
        </DialogActions>
      </Dialog>

      {/** Risk Gpt register create Methods */}
      <Dialog
        open={openRiskGpt}
        onClose={false}
        scroll={openRiskGptScroll}
        aria-labelledby="collection-data-dialog-title"
        aria-describedby="collection-data-dialog-description"
        fullWidth={true}
        maxWidth={'lg'}
      >
        <DialogTitle style={{ cursor: 'move' }} id="collection-data-dialog-title">
          <Typography variant="h6" style={{ fontSize: '26px' }}>Research Risk Using RiskGpt {selectedRiskName != ""? "for \"" + selectedRiskName + "\" in \"" + selectedSectionName + "\"": ''}
          </Typography>
          <Typography variant="h6" style={{ marginRight: '-15px', padding: '7px', marginTop: '-50px', float: 'right' }}>
            <Tooltip title="Close"><Close onClick={() => setOpenRiskGpt(false)} style={{ cursor: 'pointer' }} /></Tooltip>
          </Typography>
          {selectedRiskDescription != ""?
          <Typography variant="h6" style={{ fontSize: '12px' }}>Risk Description :  {selectedRiskDescription}
          </Typography>
          :
          ''
          }
          {selectedImpactDescription != ""?
          <Typography variant="h6" style={{ fontSize: '12px' }}>Risk Impact :  {selectedImpactDescription}
          </Typography>
          :
          ''
          }
          {selectedMitigation != ""?
          <Typography variant="h6" style={{ fontSize: '12px' }}>Mitigation :  {selectedMitigation}
          </Typography>
          :
          ''
          }
          {selectedRiskLevel != ""?
          <Typography variant="h6" style={{ fontSize: '12px' }}>Risk Level :  <span style={{color: selectedRiskLevelColor}}>{selectedRiskLevel}</span>&nbsp;&nbsp;&nbsp;Appetite : <span style={{color: selectedRiskAppetiteColor}}>{selectedRiskAppetite}</span>
          </Typography>
          :
          ''
          }
        </DialogTitle>
        <DialogContent dividers={openRiskGptScroll === 'paper'}>
          <DialogContentText id="main-risk-scroll-dialog-description" tabIndex={-1}>
            <Grid container spacing={2}>

              <Grid item xs={12} style={{ height: '250px', overflowY: 'scroll' }}>
                <Grid container spacing={1}>
                  {/**{gptTextArray.slice().reverse().map((item) => ( */}
                  {gptTextArray.map((item) => (
                    <>
                      <Grid item xs={1}>
                        <BootstrapTooltip title='Risk GPT'>
                          <Avatar sx={{ bgcolor: green[500], height: '25px', width: '25px', fontSize: '1.0rem !important' }} variant="square">
                            <span className={wordstyle}>Q</span>
                          </Avatar>
                        </BootstrapTooltip>
                      </Grid>
                      <Grid item xs={11} style={{ backgroundColor: 'rgba(244,244,244)', borderRadius: '14px' }}>
                        {item.question}

                      </Grid>
                      <Grid item xs={1}>
                        <BootstrapTooltip title='Risk GPT'>
                          <Avatar sx={{ bgcolor: red[500], height: '25px', width: '25px', fontSize: '1.0rem !important' }} variant="square">
                            <span className={wordstyle}>A</span>
                          </Avatar>
                        </BootstrapTooltip>
                      </Grid>
                      <Grid item xs={11}>

                        {/**<span style={{fontSize: '1rem', fontFamily: 'ui-sans-serif,-apple-system,system-ui,Segoe UI,Roboto,Ubuntu,Cantarell,Noto Sans,sans-serif,Helvetica,Apple Color Emoji,Arial,Segoe UI Emoji,Segoe UI Symbol'}}>{parseHtml(item.answer.replaceAll('\n', '<br>'))}</span>**/}
                        <span style={{ fontSize: '1rem', fontFamily: 'ui-sans-serif,-apple-system,system-ui,Segoe UI,Roboto,Ubuntu,Cantarell,Noto Sans,sans-serif,Helvetica,Apple Color Emoji,Arial,Segoe UI Emoji,Segoe UI Symbol' }}>{formatContent(item.answer)}</span>

                      </Grid>
                    </>
                  ))}



                </Grid>


              </Grid>
              <Grid item xs={11}>
                <Box component="form" sx={{ '& .MuiTextField-root': { width: '100%' }, }} noValidate autoComplete="off">
                  <textarea
                    placeholder="Type Your Message here..."
                    variant="outlined"
                    value={gptText}
                    id='gptText'
                    rows={3}
                    style={{ width: "100%" }}
                    onChange={handleChangeGptText}
                  />
                </Box>
              </Grid>
              <Grid item xs={1}>

                <Button
                  id={'btnSend'}
                  variant="contained"
                  onClick={() => {
                    sentToChatGtp()
                  }}
                  //style={{ height: '55px', width: '40px', borderRadius: '50%', color: 'black', backgroundColor: 'aliceblue'  }}
                  sx={{
                    height: "55px",
                    width: "40px",
                    borderRadius: "50%",
                    color: "black",
                    backgroundColor: "aliceblue",
                    "&:hover": {
                      backgroundColor: "#8a8181",
                      color: "white",
                    },
                  }}
                >
                  <ArrowUpward />
                </Button>
              </Grid>


            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {gptTextArray.length > 0 ?
            <>
              <Button
                onClick={saveTheResult}
              >
                Save the Latest Result in PDF format
              </Button>
              &nbsp;&nbsp;
              <Button
                onClick={saveTheResult1}
              >
                Save the Latest Result in WORD(DOC) format
              </Button>
            </>
            :
            ''
          }
          <Button
            onClick={() => startAgainFuction3()}
          >
            Add Risk Hierarchy Using the Above Information
          </Button>
          <Button onClick={() => setOpenRiskGpt(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default DMGRiskGptComponent3
